
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7913"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7913"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1GBb5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $13a68d6de2523d31$var$_class;
function $13a68d6de2523d31$var$_defineProperty(e, r, t) {
    return (r = $13a68d6de2523d31$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $13a68d6de2523d31$var$_toPropertyKey(t) {
    var i = $13a68d6de2523d31$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $13a68d6de2523d31$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $13a68d6de2523d31$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $13a68d6de2523d31$var$Accordion = module.exports.default = ($13a68d6de2523d31$var$_class = class Accordion {
    constructor(){
        $13a68d6de2523d31$var$_defineProperty(this, "tabs", new $bFxq0.LiveNodeList('[role="tab"]'));
        this.registerListeners();
    }
    registerListeners() {
        this.tabs.addEventListener('click', this.handleClick);
    }
    handleClick() {
        const target = event.currentTarget || event.target;
        if (target.classList.contains("single-active")) this.tabs.forEach((tab)=>tab.setAttribute('aria-expanded', 'false'));
        target.setAttribute('aria-expanded', (target.getAttribute('aria-expanded') === 'false').toString());
        // Remove hashes to allow URL-targeted accordion elements to be closed
        history.pushState('', document.title, `${window.location.pathname}${window.location.search}`);
    }
}, $13a68d6de2523d31$var$_applyDecoratedDescriptor($13a68d6de2523d31$var$_class.prototype, "handleClick", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($13a68d6de2523d31$var$_class.prototype, "handleClick"), $13a68d6de2523d31$var$_class.prototype), $13a68d6de2523d31$var$_class);

});
parcelRegister("bfbrY", function(module, exports) {
(function(global, factory) {
    if (typeof define === 'function' && define.amd) define([
        'exports'
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    'use strict';
    exports1.__esModule = true;
    var EMPTY = {};
    var HOP = Object.prototype.hasOwnProperty;
    var fns = {
        memoize: function memoize(fn) {
            var opt = arguments.length <= 1 || arguments[1] === undefined ? EMPTY : arguments[1];
            var cache = opt.cache || {};
            return function() {
                for(var _len = arguments.length, a = Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                var k = String(a[0]);
                if (opt.caseSensitive === false) k = k.toLowerCase();
                return HOP.call(cache, k) ? cache[k] : cache[k] = fn.apply(this, a);
            };
        },
        debounce: function debounce(fn, opts) {
            if (typeof opts === 'function') {
                var p = fn;
                fn = opts;
                opts = p;
            }
            var delay = opts && opts.delay || opts || 0, args = undefined, context = undefined, timer = undefined;
            return function() {
                for(var _len2 = arguments.length, a = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)a[_key2] = arguments[_key2];
                args = a;
                context = this;
                if (!timer) timer = setTimeout(function() {
                    fn.apply(context, args);
                    args = context = timer = null;
                }, delay);
            };
        },
        bind: function bind(target, key, _ref) {
            var fn = _ref.value;
            return {
                configurable: true,
                get: function get() {
                    var value = fn.bind(this);
                    Object.defineProperty(this, key, {
                        value: value,
                        configurable: true,
                        writable: true
                    });
                    return value;
                }
            };
        }
    };
    var memoize = multiMethod(fns.memoize), debounce = multiMethod(fns.debounce), bind = multiMethod(function(f, c) {
        return f.bind(c);
    }, function() {
        return fns.bind;
    });
    exports1.memoize = memoize;
    exports1.debounce = debounce;
    exports1.bind = bind;
    exports1['default'] = {
        memoize: memoize,
        debounce: debounce,
        bind: bind
    };
    function multiMethod(inner, deco) {
        deco = deco || inner.decorate || decorator(inner);
        var d = deco();
        return function() {
            for(var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            var l = args.length;
            return (l < 2 ? deco : l > 2 ? d : inner).apply(undefined, args);
        };
    }
    function decorator(fn) {
        return function(opt) {
            return typeof opt === 'function' ? fn(opt) : function(target, key, desc) {
                desc.value = fn(desc.value, opt, target, key, desc);
            };
        };
    }
});

});

parcelRegister("bFxq0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LiveNodeList = module.exports.LiveElement = undefined;

var $geTWz = parcelRequire("geTWz");
var $87ed7240959a861c$var$_liveElement2 = $87ed7240959a861c$var$_interopRequireDefault($geTWz);

var $bhWPW = parcelRequire("bhWPW");
var $87ed7240959a861c$var$_liveNodeList2 = $87ed7240959a861c$var$_interopRequireDefault($bhWPW);
function $87ed7240959a861c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.LiveElement = $87ed7240959a861c$var$_liveElement2.default;
module.exports.LiveNodeList = $87ed7240959a861c$var$_liveNodeList2.default;
module.exports.default = $87ed7240959a861c$var$_liveNodeList2.default;

});
parcelRegister("geTWz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = undefined;
var $bd29596c5069be04$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $bd29596c5069be04$var$_desc, $bd29596c5069be04$var$_value, $bd29596c5069be04$var$_class;

var $bfbrY = parcelRequire("bfbrY");

var $hBGHJ = parcelRequire("hBGHJ");
var $bd29596c5069be04$var$_observable2 = $bd29596c5069be04$var$_interopRequireDefault($hBGHJ);
function $bd29596c5069be04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bd29596c5069be04$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bd29596c5069be04$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bd29596c5069be04$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $bd29596c5069be04$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $bd29596c5069be04$var$LiveElement = ($bd29596c5069be04$var$_class = function(_Observable) {
    $bd29596c5069be04$var$_inherits(LiveElement, _Observable);
    /**
   * Creates an instance of LiveElement.
   *
   * @param {string}      selector
   * @param {HTMLElement} parent
   */ function LiveElement(selector) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $bd29596c5069be04$var$_classCallCheck(this, LiveElement);
        var _this = $bd29596c5069be04$var$_possibleConstructorReturn(this, (LiveElement.__proto__ || Object.getPrototypeOf(LiveElement)).call(this, selector, parent, config));
        _this.item = null;
        if (_this.parent) _this.item = _this.parent.querySelector(_this.selector);
        _this.registerDOMObserver();
        return _this;
    }
    /**
   * Proxy for Element.addEventListener
   *
   * @param {string}   event
   * @param {function} callback
   * @param {boolean}  passive
   */ /**
   * The underlying element
   *
   * @type {HTMLElement}
   */ $bd29596c5069be04$var$_createClass(LiveElement, [
        {
            key: 'addEventListener',
            value: function addEventListener(event, callback) {
                var passive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (!(event in this.eventListeners)) this.eventListeners[event] = [];
                this.eventListeners[event].push(callback);
                if (this.item) this.item.addEventListener(event, callback);
                this.events['eventListeners:add'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'removeEventListener',
            value: function removeEventListener(event, callback) {
                if (event in this.eventListeners) {
                    var i = this.eventListeners[event].indexOf(callback);
                    if (i > -1) this.eventListeners[event].splice(i, 1);
                }
                if (this.item) this.item.removeEventListener(event, callback);
                this.events['eventListeners:remove'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'attachEventListeners',
            value: function attachEventListeners() {
                var _this2 = this;
                var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.item;
                if (!item) return;
                if (!(item instanceof Element)) throw new TypeError('item must be an instance of Element');
                Object.keys(this.eventListeners).forEach(function(event) {
                    _this2.eventListeners[event].forEach(function(callback) {
                        item.addEventListener(event, callback);
                    });
                });
                this.events['eventListeners:attach'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'detachEventListeners',
            value: function detachEventListeners() {
                var _this3 = this;
                var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.item;
                if (!item) return;
                if (!(item instanceof Element)) throw new TypeError('item must be an instance of Element');
                Object.keys(this.eventListeners).forEach(function(event) {
                    _this3.eventListeners[event].forEach(function(callback) {
                        item.removeEventListener(event, callback);
                    });
                });
                this.events['eventListeners:detach'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'refresh',
            value: function refresh() {
                var current = this.item;
                var selected = this.parent.querySelector(this.selector);
                if (current !== selected) {
                    this.detachEventListeners(current);
                    this.attachEventListeners(selected);
                    this.item = selected;
                    this.events.update.forEach(function(callback) {
                        return callback(selected, current);
                    });
                }
                if (this.item) this.attachDelegatedEventListeners();
                else this.detachDelegatedEventListeners();
            }
        }
    ]);
    return LiveElement;
}($bd29596c5069be04$var$_observable2.default), $bd29596c5069be04$var$_applyDecoratedDescriptor($bd29596c5069be04$var$_class.prototype, 'addEventListener', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($bd29596c5069be04$var$_class.prototype, 'addEventListener'), $bd29596c5069be04$var$_class.prototype), $bd29596c5069be04$var$_applyDecoratedDescriptor($bd29596c5069be04$var$_class.prototype, 'removeEventListener', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($bd29596c5069be04$var$_class.prototype, 'removeEventListener'), $bd29596c5069be04$var$_class.prototype), $bd29596c5069be04$var$_applyDecoratedDescriptor($bd29596c5069be04$var$_class.prototype, 'attachEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($bd29596c5069be04$var$_class.prototype, 'attachEventListeners'), $bd29596c5069be04$var$_class.prototype), $bd29596c5069be04$var$_applyDecoratedDescriptor($bd29596c5069be04$var$_class.prototype, 'detachEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($bd29596c5069be04$var$_class.prototype, 'detachEventListeners'), $bd29596c5069be04$var$_class.prototype), $bd29596c5069be04$var$_applyDecoratedDescriptor($bd29596c5069be04$var$_class.prototype, 'refresh', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($bd29596c5069be04$var$_class.prototype, 'refresh'), $bd29596c5069be04$var$_class.prototype), $bd29596c5069be04$var$_class);
module.exports.default = $bd29596c5069be04$var$LiveElement;

});
parcelRegister("hBGHJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = undefined;
var $cd17048edfeb94db$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cd17048edfeb94db$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $cd17048edfeb94db$var$_desc, $cd17048edfeb94db$var$_value, $cd17048edfeb94db$var$_class;
parcelRequire("geTWz");

var $bfbrY = parcelRequire("bfbrY");
function $cd17048edfeb94db$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd17048edfeb94db$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $cd17048edfeb94db$var$Observable = ($cd17048edfeb94db$var$_class = function() {
    /**
   * Creates an instance of LiveElement.
   *
   * @param {string}      selector
   * @param {HTMLElement} parent
   */ /**
   * List Events
   *
   * @type {object}
   */ /**
   * The CSS selector used to collect items
   *
   * @type string
   */ /**
   * A store of eventListener callbacks which will be attached to the item
   *
   * @type {object}
   */ function Observable(selector) {
        var _this = this;
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $cd17048edfeb94db$var$_classCallCheck(this, Observable);
        this.eventListeners = {};
        this.observerConfig = {
            attributes: false,
            characterData: false,
            childList: true,
            subtree: true
        };
        this.selector = '';
        this.parent = document.documentElement;
        this.events = {
            update: [],
            start: [],
            pause: [],
            resume: [],
            'eventListeners:add': [],
            'eventListeners:remove': [],
            'eventListeners:attach': [],
            'eventListeners:detach': [],
            'eventListeners:purge': [],
            'delegatedEventListeners:add': [],
            'delegatedEventListeners:remove': [],
            'delegatedEventListeners:attach': [],
            'delegatedEventListeners:detach': [],
            'delegatedEventListeners:purge': []
        };
        this.delegatedEvents = {};
        this.selector = selector;
        this.observerConfig = $cd17048edfeb94db$var$_extends({}, this.observerConfig, config);
        if (parent instanceof this.constructor) {
            this.parent = parent.item;
            parent.on('update', function(newItem, oldItem) {
                _this.pause();
                _this.parent = newItem;
                _this.resume();
                _this.refresh();
            });
        } else this.parent = parent;
    }
    /**
   * Add an event listener which will apply to the LiveElement
   *
   * @param {string} event
   * @param {function} callback
   *
   * @return {LiveElement}
   */ /**
   * The parent element of the underlying element
   *
   * @type {HTMLElement}
   */ /**
   * Configuration to pass to elements observed by mutation observer
   *
   * @type {object}
   */ $cd17048edfeb94db$var$_createClass(Observable, [
        {
            key: 'on',
            value: function on(event, callback) {
                if (typeof callback !== 'function') throw new TypeError('callback must be a function');
                this.events[event].push(callback);
                return this;
            }
        },
        {
            key: 'off',
            value: function off(event, callback) {
                if (typeof callback !== 'function') throw new TypeError('callback must be a function');
                if (event in this.events) {
                    var i = this.events[event].indexOf(callback);
                    if (i > -1) this.events[event].splice(i, 1);
                }
                return this;
            }
        },
        {
            key: 'purgeEventListeners',
            value: function purgeEventListeners() {
                this.detachEventListeners();
                this.eventListeners = {};
                this.events['eventListeners:purge'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'addDelegatedEventListener',
            value: function addDelegatedEventListener(target, event, callback, options) {
                if (typeof callback !== 'function') throw new TypeError('callback must be a function');
                if (!(target instanceof Element || target instanceof Window || target instanceof HTMLDocument)) throw new TypeError('target must be window, document or an element');
                if (!(event in this.delegatedEvents)) this.delegatedEvents[event] = [];
                this.delegatedEvents[event].push({
                    target: target,
                    callback: callback,
                    options: options
                });
                if ('items' in this && this.items.length > 0 || 'item' in this && this.item) target.addEventListener(event, callback, options);
                this.events['delegatedEventListeners:add'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'removeDelegatedEventListener',
            value: function removeDelegatedEventListener(target, event, callback) {
                if (typeof callback !== 'function') throw new TypeError('callback must be a function');
                if (!(target instanceof Element || target instanceof Window || target instanceof HTMLDocument)) throw new TypeError('target must be window, document or an element');
                this.delegatedEvents[event] = this.delegatedEvents[event].filter(function(item) {
                    return !(item.target === target && item.callback === callback);
                });
                target.removeEventListener(event, callback);
                this.events['delegatedEventListeners:remove'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'attachDelegatedEventListeners',
            value: function attachDelegatedEventListeners() {
                var _this2 = this;
                Object.keys(this.delegatedEvents).forEach(function(event) {
                    var defs = _this2.delegatedEvents[event];
                    defs.forEach(function(def) {
                        def.target.addEventListener(event, def.callback, def.options);
                    });
                });
                this.events['delegatedEventListeners:attach'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'detachDelegatedEventListeners',
            value: function detachDelegatedEventListeners() {
                var _this3 = this;
                Object.keys(this.delegatedEvents).forEach(function(event) {
                    var defs = _this3.delegatedEvents[event];
                    defs.forEach(function(def) {
                        def.target.removeEventListener(event, def.callback);
                    });
                });
                this.events['delegatedEventListeners:detach'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'purgeDelegatedEventListeners',
            value: function purgeDelegatedEventListeners() {
                this.detachDelegatedEventListeners();
                this.delegatedEventListeners = {};
                this.events['delegatedEventListeners:purge'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'registerDOMObserver',
            value: function registerDOMObserver() {
                this.observer = new MutationObserver(this.refresh);
                this.resume();
                this.events.start.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.observer.disconnect();
                this.events.pause.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'resume',
            value: function resume() {
                if (this.parent) this.observer.observe(this.parent, this.observerConfig);
                this.events.resume.forEach(function(callback) {
                    return callback();
                });
            }
        }
    ]);
    return Observable;
}(), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'on', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'on'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'off', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'off'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'purgeEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'purgeEventListeners'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'addDelegatedEventListener', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'addDelegatedEventListener'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'removeDelegatedEventListener', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'removeDelegatedEventListener'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'attachDelegatedEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'attachDelegatedEventListeners'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'detachDelegatedEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'detachDelegatedEventListeners'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'purgeDelegatedEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'purgeDelegatedEventListeners'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'registerDOMObserver', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'registerDOMObserver'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'pause', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'pause'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_applyDecoratedDescriptor($cd17048edfeb94db$var$_class.prototype, 'resume', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd17048edfeb94db$var$_class.prototype, 'resume'), $cd17048edfeb94db$var$_class.prototype), $cd17048edfeb94db$var$_class);
module.exports.default = $cd17048edfeb94db$var$Observable;

});


parcelRegister("bhWPW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = undefined;
var $837eec002e994195$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $837eec002e994195$var$_desc, $837eec002e994195$var$_value, $837eec002e994195$var$_class;

var $bfbrY = parcelRequire("bfbrY");

var $hBGHJ = parcelRequire("hBGHJ");
var $837eec002e994195$var$_observable2 = $837eec002e994195$var$_interopRequireDefault($hBGHJ);
function $837eec002e994195$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $837eec002e994195$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $837eec002e994195$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $837eec002e994195$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $837eec002e994195$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var $837eec002e994195$var$LiveNodeList = ($837eec002e994195$var$_class = function(_Observable) {
    $837eec002e994195$var$_inherits(LiveNodeList, _Observable);
    /**
   * Creates an instance of LiveNodeList.
   *
   * @param {string}      selector
   * @param {HTMLElement} parent
   */ function LiveNodeList(selector) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $837eec002e994195$var$_classCallCheck(this, LiveNodeList);
        var _this = $837eec002e994195$var$_possibleConstructorReturn(this, (LiveNodeList.__proto__ || Object.getPrototypeOf(LiveNodeList)).call(this, selector, parent, config));
        _this.items = null;
        if (_this.parent) _this.items = _this.parent.querySelectorAll(_this.selector);
        else _this.items = [];
        _this.registerDOMObserver();
        return _this;
    }
    /**
   * @return {int}
   */ /**
   * The list of items
   *
   * @type {NodeList}
   */ $837eec002e994195$var$_createClass(LiveNodeList, [
        {
            key: 'forEach',
            value: function forEach(callback, thisArg) {
                return this.items.forEach(callback, thisArg);
            }
        },
        {
            key: 'map',
            value: function map(callback) {
                return Array.prototype.map.call(this.items, callback);
            }
        },
        {
            key: 'addEventListener',
            value: function addEventListener(event, callback) {
                var passive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (!(event in this.eventListeners)) this.eventListeners[event] = [];
                this.eventListeners[event].push(callback);
                this.items.forEach(function(item) {
                    item.addEventListener(event, callback);
                });
                this.events['eventListeners:add'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'removeEventListener',
            value: function removeEventListener(event, callback) {
                if (event in this.eventListeners) {
                    var i = this.eventListeners[event].indexOf(callback);
                    if (i > -1) this.eventListeners[event].splice(i, 1);
                }
                this.items.forEach(function(item) {
                    item.removeEventListener(event, callback);
                });
                this.events['eventListeners:remove'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'attachEventListeners',
            value: function attachEventListeners() {
                var _this2 = this;
                var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items;
                if (!(Array.isArray(items) || items instanceof NodeList)) throw new TypeError('items must be an instance of Array or NodeList');
                Object.keys(this.eventListeners).forEach(function(event) {
                    _this2.eventListeners[event].forEach(function(callback) {
                        items.forEach(function(item) {
                            item.addEventListener(event, callback);
                        });
                    });
                });
                this.events['eventListeners:attach'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'detachEventListeners',
            value: function detachEventListeners() {
                var _this3 = this;
                var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items;
                if (!(Array.isArray(items) || items instanceof NodeList)) throw new TypeError('items must be an instance of Array or NodeList');
                Object.keys(this.eventListeners).forEach(function(event) {
                    _this3.eventListeners[event].forEach(function(callback) {
                        items.forEach(function(item) {
                            item.removeEventListener(event, callback);
                        });
                    });
                });
                this.events['eventListeners:detach'].forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: 'refresh',
            value: function refresh() {
                var current = this.items;
                var selected = this.parent.querySelectorAll(this.selector);
                var newItems = this.diffNodeList(selected, current);
                var oldItems = this.diffNodeList(current, selected);
                if (newItems.length > 0 || oldItems.length > 0) {
                    this.detachEventListeners(oldItems);
                    this.attachEventListeners(newItems);
                    this.items = selected;
                    this.events.update.forEach(function(callback) {
                        return callback(newItems, oldItems);
                    });
                }
                if (this.items.length > 0) this.attachDelegatedEventListeners();
                else this.detachDelegatedEventListeners();
            }
        },
        {
            key: 'diffNodeList',
            value: function diffNodeList(a, b) {
                return Array.prototype.filter.call(a, function(item) {
                    return !Array.prototype.includes.call(b, item);
                });
            }
        },
        {
            key: 'length',
            get: function get() {
                return this.items.length;
            }
        }
    ]);
    return LiveNodeList;
}($837eec002e994195$var$_observable2.default), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'forEach', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'forEach'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'map', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'map'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'addEventListener', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'addEventListener'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'removeEventListener', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'removeEventListener'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'attachEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'attachEventListeners'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'detachEventListeners', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'detachEventListeners'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_applyDecoratedDescriptor($837eec002e994195$var$_class.prototype, 'refresh', [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($837eec002e994195$var$_class.prototype, 'refresh'), $837eec002e994195$var$_class.prototype), $837eec002e994195$var$_class);
module.exports.default = $837eec002e994195$var$LiveNodeList;

});



parcelRegister("cdXMh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $99Uv1 = parcelRequire("99Uv1");
parcelRequire("f7xZp");
var $7pwWI = parcelRequire("7pwWI");

var $bFxq0 = parcelRequire("bFxq0");
var $8e65118f00680a43$var$_class;
function $8e65118f00680a43$var$_defineProperty(e, r, t) {
    return (r = $8e65118f00680a43$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e65118f00680a43$var$_toPropertyKey(t) {
    var i = $8e65118f00680a43$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8e65118f00680a43$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e65118f00680a43$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8e65118f00680a43$var$Addresses = module.exports.default = ($8e65118f00680a43$var$_class = class Addresses {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $8e65118f00680a43$var$_defineProperty(this, "addresses", new $bFxq0.LiveNodeList('[data-address]'));
        $8e65118f00680a43$var$_defineProperty(this, "selectors", {
            addressContainer: '[data-address]',
            addressFields: '[data-address-fields]',
            addressToggle: '[data-address-toggle]',
            addressForm: '[data-address-form]',
            addressDeleteForm: '[data-address-delete-form]'
        });
        $8e65118f00680a43$var$_defineProperty(this, "hideClass", 'hide');
        if (this.addresses.length === 0) return;
        this.registerListeners();
    }
    registerListeners() {
        this.addresses.forEach(this.initAddressForm);
    }
    initAddressForm(address) {
        const addressFields = address.querySelector(this.selectors.addressFields);
        const addressForm = address.querySelector(this.selectors.addressForm);
        const deleteForm = address.querySelector(this.selectors.addressDeleteForm);
        address.querySelectorAll(this.selectors.addressToggle).forEach((button)=>{
            button.addEventListener('click', ()=>{
                addressForm.classList.toggle(this.hideClass);
                if (!addressForm.classList.contains(this.hideClass)) (0, $99Uv1.scrollToElement)(addressForm, -170);
                else (0, $99Uv1.scrollToElement)(address, -170);
            });
        });
        if (addressForm) (0, $7pwWI.default)(addressForm.querySelector('[data-address=root]'), 'en');
        if (deleteForm) deleteForm.addEventListener('submit', (e)=>{
            const confirmMessage = deleteForm.getAttribute('data-confirm-message');
            if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) e.preventDefault();
        });
    }
}, $8e65118f00680a43$var$_applyDecoratedDescriptor($8e65118f00680a43$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($8e65118f00680a43$var$_class.prototype, "registerListeners"), $8e65118f00680a43$var$_class.prototype), $8e65118f00680a43$var$_applyDecoratedDescriptor($8e65118f00680a43$var$_class.prototype, "initAddressForm", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($8e65118f00680a43$var$_class.prototype, "initAddressForm"), $8e65118f00680a43$var$_class.prototype), $8e65118f00680a43$var$_class);

});
parcelRegister("99Uv1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.animate = $6ab0c7e666c21810$var$animate;
module.exports.convertNameforMatch = $6ab0c7e666c21810$var$convertNameforMatch;
module.exports.convertValueforMatch = $6ab0c7e666c21810$var$convertValueforMatch;
module.exports.ease = $6ab0c7e666c21810$var$ease;
module.exports.formatProductObject = module.exports.formatMoney = module.exports.em = void 0;
module.exports.isInViewport = $6ab0c7e666c21810$var$isInViewport;
module.exports.randomInt = module.exports.isVisible = void 0;
module.exports.scrollToElement = $6ab0c7e666c21810$var$scrollToElement;
module.exports.scrollToPosition = $6ab0c7e666c21810$var$scrollToPosition;

var $6ab0c7e666c21810$var$currency = $6ab0c7e666c21810$var$_interopRequireWildcard((parcelRequire("1srha")));
function $6ab0c7e666c21810$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6ab0c7e666c21810$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/**
 * Check if the slider is currently within the viewport
 *
 * @param {HTMLElement} element
 * @param {object}      offset
 *
 * @return {bool}
 */ function $6ab0c7e666c21810$var$isInViewport(element, offset = {
    x: 0,
    y: 0
}) {
    const { top: top, left: left, bottom: bottom, right: right, width: width, height: height } = element.getBoundingClientRect();
    if (width === 0 && height === 0) return false;
    return top <= window.innerHeight + offset.y && bottom >= 0 - offset.y && left <= window.innerWidth + offset.x && right >= 0 - offset.x;
}
/**
 * Easing function, equivalent to easeInOutCubic
 *
 * @see {https://gist.github.com/gre/1650294}
 *
 * @param {number} t
 *
 * @return {number}
 */ function $6ab0c7e666c21810$var$ease(t) {
    if (t < 0.5) return 4 * t * t * t;
    return (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}
/**
 * Animate a value
 *
 * @param {number}   from
 * @param {number}   to
 * @param {number}   duration
 * @param {function} callback
 *
 * @return {void}
 */ function $6ab0c7e666c21810$var$animate(from, to, duration = 500, callback, easing = $6ab0c7e666c21810$var$ease) {
    const diff = to - from;
    if (!diff) return;
    let start, value;
    /**
   * Set values for each step in the animation
   *
   *
   * @param {number} timestamp
   */ const step = function(timestamp) {
        if (!start) start = timestamp;
        var time = timestamp - start;
        var percent = easing(Math.min(time / duration, 1));
        value = from + diff * percent;
        if (time >= duration) {
            value = to;
            callback(value);
            return;
        }
        callback(value);
        requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
}
/**
 * Smoothly scroll to an element on the page
 *
 * @param {HTMLElement} element
 * @param {Number} duration
 *
 * @return {void}
 */ function $6ab0c7e666c21810$var$scrollToElement(element, offset = 0, duration = 500) {
    const from = window.pageYOffset;
    const to = element.getBoundingClientRect().top + window.pageYOffset + offset;
    return $6ab0c7e666c21810$var$animate(from, to, duration, (y)=>{
        window.scrollTo(0, y);
    });
}
/**
 * Smoothly scroll to an element on the page
 *
 * @param {Number} position
 * @param {Number} duration
 *
 * @return {void}
 */ function $6ab0c7e666c21810$var$scrollToPosition(position = 0, duration = 500) {
    const from = window.pageYOffset;
    const to = position;
    return $6ab0c7e666c21810$var$animate(from, to, duration, (y)=>{
        window.scrollTo(0, y);
    });
}
const $6ab0c7e666c21810$var$randomInt = (min, max)=>Math.floor(Math.random() * (max - min + 1) + min);
// -- Cross browser method to get style properties:
module.exports.randomInt = $6ab0c7e666c21810$var$randomInt;
function $6ab0c7e666c21810$var$_getStyle(element, property) {
    if (window.getComputedStyle) return document.defaultView.getComputedStyle(element, null)[property];
    if (element.currentStyle) return element.currentStyle[property];
}
function $6ab0c7e666c21810$var$_elementInDocument(element) {
    while(element = element.parentNode){
        if (element == document) return true;
    }
    return false;
}
/**
 * Author: Jason Farrell
 * Author URI: http://useallfive.com/
 *
 * Description: Checks if a DOM element is truly visible.
 * Package URL: https://github.com/UseAllFive/true-visibility
 *
 * Checks if a DOM element is visible. Takes into
 * consideration its parents and overflow.
 *
 * @param {Element} element      the DOM element to check if is visible
 *
 * These params are optional that are sent in recursively,
 * you typically won't use these:
 *
 * @param {number} t       Top corner position number
 * @param {number} r       Right corner position number
 * @param {number} b       Bottom corner position number
 * @param {number} l       Left corner position number
 * @param {number} w       Element width number
 * @param {number} h       Element height number
 *
 * @return {boolean}
 */ const $6ab0c7e666c21810$var$isVisible = (element, t, r, b, l, w, h)=>{
    var p = element.parentNode;
    var VISIBLE_PADDING = 2;
    if (!$6ab0c7e666c21810$var$_elementInDocument(element)) return false;
    // -- Return true for document node
    if (p.nodeType === 9) return true;
    // -- Return false if our element is invisible
    if ($6ab0c7e666c21810$var$_getStyle(element, 'opacity') === '0' || $6ab0c7e666c21810$var$_getStyle(element, 'display') === 'none' || $6ab0c7e666c21810$var$_getStyle(element, 'visibility') === 'hidden') return false;
    if (typeof t === 'undefined' || typeof r === 'undefined' || typeof b === 'undefined' || typeof l === 'undefined' || typeof w === 'undefined' || typeof h === 'undefined') {
        t = element.offsetTop;
        l = element.offsetLeft;
        b = t + element.offsetHeight;
        r = l + element.offsetWidth;
        w = element.offsetWidth;
        h = element.offsetHeight;
    }
    // -- If we have a parent, let's continue:
    if (p) {
        // -- Check if the parent can hide its children.
        if ($6ab0c7e666c21810$var$_getStyle(p, 'overflow') === 'hidden' || $6ab0c7e666c21810$var$_getStyle(p, 'overflow') === 'scroll') {
            // -- Only check if the offset is different for the parent
            if (// -- If the target element is to the right of the parent elm
            l + VISIBLE_PADDING > p.offsetWidth + p.scrollLeft || // -- If the target element is to the left of the parent elm
            l + w - VISIBLE_PADDING < p.scrollLeft || // -- If the target element is under the parent elm
            t + VISIBLE_PADDING > p.offsetHeight + p.scrollTop || // -- If the target element is above the parent elm
            t + h - VISIBLE_PADDING < p.scrollTop) // -- Our target element is out of bounds:
            return false;
        }
        // -- Add the offset parent's left/top coords to our element's offset:
        if (element.offsetParent === p) {
            l += p.offsetLeft;
            t += p.offsetTop;
        }
        // -- Let's recursively check upwards:
        return $6ab0c7e666c21810$var$isVisible(p, t, r, b, l, w, h);
    }
    return true;
};
module.exports.isVisible = $6ab0c7e666c21810$var$isVisible;
const $6ab0c7e666c21810$var$em = (size)=>parseInt(window.getComputedStyle(document.body).fontSize, 10) * size;
module.exports.em = $6ab0c7e666c21810$var$em;
const $6ab0c7e666c21810$var$formatProductObject = (product)=>{
    product.id = product.id.replace('gid://shopify/Product/', '');
    product.variants = product.variants.edges.map((item)=>item.node);
    product.variants.forEach((variant)=>{
        variant.id = variant.id.replace('gid://shopify/ProductVariant/', '');
    });
    product.images = product.images.edges.map((item)=>item.node);
    if (product.sellingPlanGroups) product.sellingPlanGroups = product.sellingPlanGroups.edges.map((item)=>item.node);
    product.hasOnlyDefaultVariant = product.variants.length === 1;
    return product;
};
module.exports.formatProductObject = $6ab0c7e666c21810$var$formatProductObject;
const $6ab0c7e666c21810$var$formatMoney = (price)=>{
    return $6ab0c7e666c21810$var$currency.formatMoney(price, window.theme.moneyFormat);
};
// Functions for converting production options/values to match Cylindo's code system
module.exports.formatMoney = $6ab0c7e666c21810$var$formatMoney;
function $6ab0c7e666c21810$var$convertNameforMatch(term) {
    //make sure term is always Capitalized
    term.toLowerCase();
    term = term.charAt(0).toUpperCase() + term.slice(1);
    if (term == 'Frame') term = 'Finish';
    if (term == 'Nailhead') term = 'Nailheads';
    if (term == 'Color') term = 'Fabric';
    return term;
}
function $6ab0c7e666c21810$var$convertValueforMatch(term) {
    if (term == "Customer's Own Material") term = 'COM';
    if (term == "Customer's Own Leather") term = 'COL';
    term = term.replaceAll(' ', '');
    term = term.replaceAll('/', '_');
    term = term.replaceAll('-', '_');
    term = term.replaceAll("'", '');
    term = term.replaceAll('"', '');
    return term;
}

});
parcelRegister("1srha", function(module, exports) {

$parcel$export(module.exports, "formatMoney", function () { return $10fd90636a571f3c$export$a17b3c2052469c69; });
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */ const $10fd90636a571f3c$var$moneyFormat = '${{amount}}';
function $10fd90636a571f3c$export$a17b3c2052469c69(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || $10fd90636a571f3c$var$moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
}

});


parcelRegister("f7xZp", function(module, exports) {

$parcel$export(module.exports, "AddressForm", function () { return (parcelRequire("7pwWI")).default; });

var $7pwWI = parcelRequire("7pwWI");

});
parcelRegister("7pwWI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56546c94f16ab902$export$2e2bcd8739ae039; });

var $cIKkq = parcelRequire("cIKkq");

var $4vS3H = parcelRequire("4vS3H");
var $56546c94f16ab902$var$FIELD_REGEXP = /({\w+})/g;
var $56546c94f16ab902$var$LINE_DELIMITER = '_';
var $56546c94f16ab902$var$INPUT_SELECTORS = {
    lastName: '[name="address[last_name]"]',
    firstName: '[name="address[first_name]"]',
    company: '[name="address[company]"]',
    address1: '[name="address[address1]"]',
    address2: '[name="address[address2]"]',
    country: '[name="address[country]"]',
    zone: '[name="address[province]"]',
    postalCode: '[name="address[zip]"]',
    city: '[name="address[city]"]',
    phone: '[name="address[phone]"]'
};
function $56546c94f16ab902$export$2e2bcd8739ae039(rootEl, locale, options) {
    locale = locale || 'en';
    options = options || {
        inputSelectors: {}
    };
    var formElements = $56546c94f16ab902$var$loadFormElements(rootEl, (0, $4vS3H.mergeObjects)($56546c94f16ab902$var$INPUT_SELECTORS, options.inputSelectors));
    $56546c94f16ab902$var$validateElements(formElements);
    return $56546c94f16ab902$var$loadShippingCountries(options.shippingCountriesOnly).then(function(shippingCountryCodes) {
        return (0, $cIKkq.loadCountries)(locale).then(function(countries) {
            $56546c94f16ab902$var$init(rootEl, formElements, $56546c94f16ab902$var$filterCountries(countries, shippingCountryCodes));
        });
    });
}
/**
 * Runs when countries have been loaded
 */ function $56546c94f16ab902$var$init(rootEl, formElements, countries) {
    $56546c94f16ab902$var$populateCountries(formElements, countries);
    var selectedCountry = formElements.country.input ? formElements.country.input.value : null;
    $56546c94f16ab902$var$setEventListeners(rootEl, formElements, countries);
    $56546c94f16ab902$var$handleCountryChange(rootEl, formElements, selectedCountry, countries);
}
/**
 * Handles when a country change: set labels, reorder fields, populate zones
 */ function $56546c94f16ab902$var$handleCountryChange(rootEl, formElements, countryCode, countries) {
    var country = $56546c94f16ab902$var$getCountry(countryCode, countries);
    $56546c94f16ab902$var$setLabels(formElements, country);
    $56546c94f16ab902$var$reorderFields(rootEl, formElements, country);
    $56546c94f16ab902$var$populateZones(formElements, country);
}
/**
 * Sets up event listener for country change
 */ function $56546c94f16ab902$var$setEventListeners(rootEl, formElements, countries) {
    formElements.country.input.addEventListener('change', function(event) {
        $56546c94f16ab902$var$handleCountryChange(rootEl, formElements, event.target.value, countries);
    });
}
/**
 * Reorder fields in the DOM and add data-attribute to fields given a country
 */ function $56546c94f16ab902$var$reorderFields(rootEl, formElements, country) {
    var formFormat = country.formatting.edit;
    var countryWrapper = formElements.country.wrapper;
    var afterCountry = false;
    $56546c94f16ab902$var$getOrderedField(formFormat).forEach(function(row) {
        row.forEach(function(line) {
            formElements[line].wrapper.dataset.lineCount = row.length;
            if (!formElements[line].wrapper) return;
            if (line === 'country') {
                afterCountry = true;
                return;
            }
            if (afterCountry) rootEl.append(formElements[line].wrapper);
            else rootEl.insertBefore(formElements[line].wrapper, countryWrapper);
        });
    });
}
/**
 * Update labels for a given country
 */ function $56546c94f16ab902$var$setLabels(formElements, country) {
    Object.keys(formElements).forEach(function(formElementName) {
        formElements[formElementName].labels.forEach(function(label) {
            label.textContent = country.labels[formElementName];
        });
    });
}
/**
 * Add right countries in the dropdown for a given country
 */ function $56546c94f16ab902$var$populateCountries(formElements, countries) {
    var countrySelect = formElements.country.input;
    var duplicatedCountrySelect = countrySelect.cloneNode(true);
    countries.forEach(function(country) {
        var optionElement = document.createElement('option');
        optionElement.value = country.code;
        optionElement.textContent = country.name;
        duplicatedCountrySelect.appendChild(optionElement);
    });
    countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;
    if (countrySelect.dataset.default) countrySelect.value = countrySelect.dataset.default;
}
/**
 * Add right zones in the dropdown for a given country
 */ function $56546c94f16ab902$var$populateZones(formElements, country) {
    var zoneEl = formElements.zone;
    if (!zoneEl) return;
    if (country.zones.length === 0) {
        zoneEl.wrapper.dataset.ariaHidden = 'true';
        zoneEl.input.innerHTML = '';
        return;
    }
    zoneEl.wrapper.dataset.ariaHidden = 'false';
    var zoneSelect = zoneEl.input;
    var duplicatedZoneSelect = zoneSelect.cloneNode(true);
    duplicatedZoneSelect.innerHTML = '';
    country.zones.forEach(function(zone) {
        var optionElement = document.createElement('option');
        optionElement.value = zone.code;
        optionElement.textContent = zone.name;
        duplicatedZoneSelect.appendChild(optionElement);
    });
    zoneSelect.innerHTML = duplicatedZoneSelect.innerHTML;
    if (zoneSelect.dataset.default) zoneSelect.value = zoneSelect.dataset.default;
}
/**
 * Will throw if an input or a label is missing from the wrapper
 */ function $56546c94f16ab902$var$validateElements(formElements) {
    Object.keys(formElements).forEach(function(elementKey) {
        var element = formElements[elementKey].input;
        var labels = formElements[elementKey].labels;
        if (!element) return;
        if (typeof element !== 'object') throw new TypeError(formElements[elementKey] + ' is missing an input or select.');
        else if (typeof labels !== 'object') throw new TypeError(formElements[elementKey] + ' is missing a label.');
    });
}
/**
 * Given an countryCode (eg. 'CA'), will return the data of that country
 */ function $56546c94f16ab902$var$getCountry(countryCode, countries) {
    countryCode = countryCode || 'CA';
    return countries.filter(function(country) {
        return country.code === countryCode;
    })[0];
}
/**
 * Given a format (eg. "{firstName}{lastName}_{company}_{address1}_{address2}_{city}_{country}{province}{zip}_{phone}")
 * will return an array of how the form needs to be formatted, eg.:
 * =>
 * [
 *   ['firstName', 'lastName'],
 *   ['company'],
 *   ['address1'],
 *   ['address2'],
 *   ['city'],
 *   ['country', 'province', 'zip'],
 *   ['phone']
 * ]
 */ function $56546c94f16ab902$var$getOrderedField(format) {
    return format.split($56546c94f16ab902$var$LINE_DELIMITER).map(function(fields) {
        var result = fields.match($56546c94f16ab902$var$FIELD_REGEXP);
        if (!result) return [];
        return result.map(function(fieldName) {
            var newFieldName = fieldName.replace(/[{}]/g, '');
            switch(newFieldName){
                case 'zip':
                    return 'postalCode';
                case 'province':
                    return 'zone';
                default:
                    return newFieldName;
            }
        });
    });
}
/**
 * Given a rootEl where all `input`s, `select`s, and `labels` are nested, it
 * will returns all form elements (wrapper, input and labels) of the form.
 * See `FormElements` type for details
 */ function $56546c94f16ab902$var$loadFormElements(rootEl, inputSelectors) {
    var elements = {};
    Object.keys($56546c94f16ab902$var$INPUT_SELECTORS).forEach(function(inputKey) {
        var input = rootEl.querySelector(inputSelectors[inputKey]);
        elements[inputKey] = input ? {
            wrapper: input.parentElement,
            input: input,
            labels: document.querySelectorAll('[for="' + input.id + '"]')
        } : {};
    });
    return elements;
}
/**
 * If shippingCountriesOnly is set to true, will return the list of countries the
 * shop ships to. Otherwise returns null.
 */ function $56546c94f16ab902$var$loadShippingCountries(shippingCountriesOnly) {
    if (!shippingCountriesOnly) // eslint-disable-next-line no-undef
    return Promise.resolve(null);
    var response = fetch(location.origin + '/meta.json');
    return response.then(function(res) {
        return res.json();
    }).then(function(meta) {
        // If ships_to_countries has * in the list, it means the shop ships to
        // all countries
        return meta.ships_to_countries.indexOf('*') !== -1 ? null : meta.ships_to_countries;
    }).catch(function() {
        return null;
    });
}
/**
 * Only returns countries that are in includedCountryCodes
 * Returns all countries if no includedCountryCodes is passed
 */ function $56546c94f16ab902$var$filterCountries(countries, includedCountryCodes) {
    if (!includedCountryCodes) return countries;
    return countries.filter(function(country) {
        return includedCountryCodes.indexOf(country.code) !== -1;
    });
}

});
parcelRegister("cIKkq", function(module, exports) {

$parcel$export(module.exports, "loadCountries", function () { return $942d87f1f31a3525$export$5fd03f02e808abaf; });
var $942d87f1f31a3525$var$query = "query countries($locale: SupportedLocale!) {  countries(locale: $locale) {    name    code    labels {      address1      address2      city      company      country      firstName      lastName      phone      postalCode      zone    }    formatting {      edit    }    zones {      name      code    }  }}";
var $942d87f1f31a3525$var$GRAPHQL_ENDPOINT = 'https://country-service.shopifycloud.com/graphql';
function $942d87f1f31a3525$export$5fd03f02e808abaf(locale) {
    var response = fetch($942d87f1f31a3525$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify({
            query: $942d87f1f31a3525$var$query,
            operationName: 'countries',
            variables: {
                locale: $942d87f1f31a3525$export$2a3d8d07d924f848(locale)
            }
        })
    });
    return response.then(function(res) {
        return res.json();
    }).then(function(countries) {
        return countries.data.countries;
    });
}
var $942d87f1f31a3525$var$DEFAULT_LOCALE = 'EN';
var $942d87f1f31a3525$export$b6a046f0eef1bb2 = [
    'DA',
    'DE',
    'EN',
    'ES',
    'FR',
    'IT',
    'JA',
    'NL',
    'PT',
    'PT_BR'
];
function $942d87f1f31a3525$export$2a3d8d07d924f848(locale) {
    var supportedLocale = locale.replace(/-/, '_').toUpperCase();
    if ($942d87f1f31a3525$export$b6a046f0eef1bb2.indexOf(supportedLocale) !== -1) return supportedLocale;
    else if ($942d87f1f31a3525$export$b6a046f0eef1bb2.indexOf(supportedLocale.substring(0, 2)) !== -1) return supportedLocale.substring(0, 2);
    else return $942d87f1f31a3525$var$DEFAULT_LOCALE;
}

});

parcelRegister("4vS3H", function(module, exports) {

$parcel$export(module.exports, "mergeObjects", function () { return $3493fd9dc4649d5a$export$2321aea138b44780; });
function $3493fd9dc4649d5a$export$2321aea138b44780() {
    var to = Object({});
    for(var index = 0; index < arguments.length; index++){
        var nextSource = arguments[index];
        if (nextSource) {
            for(var nextKey in nextSource)if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}

});




parcelRegister("kYSSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f463fa530a071928$var$_liveNodeList = $f463fa530a071928$var$_interopRequireDefault((parcelRequire("bFxq0")));

var $bfbrY = parcelRequire("bfbrY");
var $f463fa530a071928$var$_class;
function $f463fa530a071928$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $f463fa530a071928$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f463fa530a071928$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f463fa530a071928$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f463fa530a071928$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f463fa530a071928$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f463fa530a071928$var$_defineProperty(e, r, t) {
    return (r = $f463fa530a071928$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f463fa530a071928$var$_toPropertyKey(t) {
    var i = $f463fa530a071928$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f463fa530a071928$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f463fa530a071928$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
/**
 * Creates an Intersection observer to animate elements
 * matching a specific selector.
 *
 * @type {ImageLazyLoader}
 */ let $f463fa530a071928$var$Animator = module.exports.default = ($f463fa530a071928$var$_class = class Animator {
    /**
   * Create the lazy loader instance
   *
   * @param {string} selector
   * @param {object} config
   */ constructor(selector, config = {}){
        /**
     * The default config for lazy loader instances
     *
     * @type {object}
     */ $f463fa530a071928$var$_defineProperty(this, "config", {
            // If the element gets within 50px in the Y axis, start the download.
            rootMargin: '0px 0px',
            threshold: [
                0,
                0.25,
                0.5,
                0.75,
                1
            ]
        });
        /**
     * The selector used to gather images
     *
     * @type {String}
     */ $f463fa530a071928$var$_defineProperty(this, "selector", null);
        /**
     * The node list in which we'll store all the images
     * to be lazy loaded
     *
     * @type {LiveNodeList}
     */ $f463fa530a071928$var$_defineProperty(this, "elements", null);
        /**
     * The IntersectionObserver instance powering this lazy loader
     *
     * @type {IntersectionObserver}
     */ $f463fa530a071928$var$_defineProperty(this, "observer", null);
        /**
     * @type {boolean}
     */ $f463fa530a071928$var$_defineProperty(this, "paused", false);
        this.selector = selector;
        // Merge optional config with the default
        this.config = $f463fa530a071928$var$_objectSpread($f463fa530a071928$var$_objectSpread({}, this.config), config);
        this.collect();
        // Create the IntersectionObserver instance and observe each
        // of the elements matching our selector
        this.observer = new IntersectionObserver(this.intersect, this.config);
        this.observe();
    }
    /**
   * Collect elements on the page to be animated
   */ collect() {
        // Select all the elements to be animated
        this.elements = new $f463fa530a071928$var$_liveNodeList.default(this.selector);
        this.elements.on('update', (newItems, oldItems)=>{
            oldItems.forEach((item)=>this.observer.unobserve(item));
            newItems.forEach((item)=>this.observer.observe(item));
        });
    }
    /**
   * Begin observation for each of the collected elements
   */ observe() {
        this.elements.forEach((element)=>this.observer.observe(element));
    }
    /**
   * Begin observation for each of the collected elements
   */ unobserve() {
        this.elements.forEach((element)=>this.observer.unobserve(element));
    }
    /**
   * Handle a list of entries when an intersection occurs
   *
   * @param {Array} entries
   */ intersect(entries) {
        if (this.paused) return;
        // Loop through the entries
        entries.forEach((entry)=>{
            // Are we in viewport?
            if (entry.isIntersecting && entry.intersectionRatio > 0) {
                // Stop watching and load the image
                this.observer.unobserve(entry.target);
                this.animate(entry.target);
            }
        });
    }
    /**
   * Animate an element
   *
   * @param {HTMLElement} element
   */ animate(element) {
        element.classList.add('animated');
    }
    /**
   * @return {void}
   */ pause() {
        this.paused = true;
    }
    /**
   * @return {void}
   */ unpause() {
        this.paused = false;
    }
}, $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "collect", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "collect"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "observe", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "observe"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "unobserve", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "unobserve"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "intersect", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "intersect"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "animate", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "animate"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "pause", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "pause"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_applyDecoratedDescriptor($f463fa530a071928$var$_class.prototype, "unpause", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f463fa530a071928$var$_class.prototype, "unpause"), $f463fa530a071928$var$_class.prototype), $f463fa530a071928$var$_class);

});

parcelRegister("gXXkU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $jld5k = parcelRequire("jld5k");

var $29n7W = parcelRequire("29n7W");
const $c5a02efd1c559a06$var$_excluded = [
    "id",
    "quantity"
];
var $c5a02efd1c559a06$var$_class;
function $c5a02efd1c559a06$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5a02efd1c559a06$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5a02efd1c559a06$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c5a02efd1c559a06$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5a02efd1c559a06$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c5a02efd1c559a06$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c5a02efd1c559a06$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c5a02efd1c559a06$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $c5a02efd1c559a06$var$_defineProperty(e, r, t) {
    return (r = $c5a02efd1c559a06$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c5a02efd1c559a06$var$_toPropertyKey(t) {
    var i = $c5a02efd1c559a06$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c5a02efd1c559a06$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c5a02efd1c559a06$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
const { root: $c5a02efd1c559a06$var$root } = window.Shopify.routes;
let $c5a02efd1c559a06$var$CartApi = module.exports.default = ($c5a02efd1c559a06$var$_class = class CartApi {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $c5a02efd1c559a06$var$_defineProperty(this, "addToCartForms", new $bFxq0.LiveNodeList(`form[action="${$c5a02efd1c559a06$var$root}cart/add"]`));
        this.registerListeners();
    }
    registerListeners() {
        this.addToCartForms.addEventListener('submit', this.handleSubmit);
    }
    async handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget || event.target;
        const formData = new FormData(form);
        const _Object$fromEntries = Object.fromEntries(formData.entries()), { id: id, quantity: quantity } = _Object$fromEntries, data = $c5a02efd1c559a06$var$_objectWithoutProperties(_Object$fromEntries, $c5a02efd1c559a06$var$_excluded);
        for(const key in data){
            const value = data[key];
            const matches = key.match(/properties\[([^\]]+)\]/);
            if (matches) {
                const [, property] = matches;
                if (!data.properties) data.properties = {};
                data.properties[property] = value;
                delete data[key];
            }
        }
        return this.addToCart(id, quantity, data);
    }
    async handleCartApiCall(callback, lineId) {
        try {
            return await callback();
        } catch (error) {
            if (!(error instanceof $jld5k.CartError)) {
                if (lineId) {
                    const lineItem = await this.getCartItem(lineId);
                    error = new $jld5k.CartItemError(error.message, lineItem);
                } else error = new $jld5k.CartError(error.message);
            }
            let event = new $29n7W.CartErrorEvent({
                error: error
            });
            if (error instanceof $jld5k.CartItemError) event = new $29n7W.CartItemErrorEvent({
                error: error,
                lineItem: error.lineItem
            });
            document.dispatchEvent(event);
        }
    }
    async getCart() {
        const response = await fetch(`${$c5a02efd1c559a06$var$root}cart.js`);
        return response.json();
    }
    async getCartItem(lineId) {
        const cart = await this.getCart();
        return $c5a02efd1c559a06$var$_objectSpread($c5a02efd1c559a06$var$_objectSpread({}, cart.items[lineId - 1]), {}, {
            lineId: lineId
        });
    }
    async getCartVariant(variantId) {
        const cart = await this.getCart();
        return cart.items.find((item)=>item.variant_id === variantId);
    }
    async addToCart(variantId, quantity = 1, data = {}) {
        document.dispatchEvent(new $29n7W.CartProcessingStartEvent());
        this.handleCartApiCall(async ()=>{
            try {
                const body = $c5a02efd1c559a06$var$_objectSpread({
                    id: variantId,
                    quantity: quantity
                }, data);
                const response = await fetch(`${$c5a02efd1c559a06$var$root}cart/add.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                });
                const responseData = await response.json();
                if (!response.ok) {
                    if (responseData.status === 422) throw new $jld5k.NotEnoughStockCartError(responseData.description);
                    if (responseData.status === 404) throw new $jld5k.ProductNotFoundCartError(responseData.description);
                    throw new $jld5k.AddToCartError(undefined, responseData.description);
                }
                document.dispatchEvent(new $29n7W.AddToCartEvent({
                    lineItem: responseData
                }));
                document.dispatchEvent(new $29n7W.CartProcessingEndEvent({
                    lineItem: responseData
                }));
            } catch (error) {
                if (error instanceof $jld5k.CartError) throw error;
                throw new $jld5k.AddToCartError(error.message);
            }
        });
    }
    async updateCart(data) {
        try {
            const response = await fetch(`${$c5a02efd1c559a06$var$root}cart/change.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            const responseData = await response.json();
            if (!response.ok) {
                const lineItem = await this.getCartItem(data.line);
                if (responseData.status === 422) throw new $jld5k.NotEnoughStockCartItemError(responseData.description, lineItem);
                if (responseData.status === 404) throw new $jld5k.ProductNotInCartError(responseData.description, lineItem);
                throw new $jld5k.UpdateCartError(responseData.description, lineItem);
            }
            return responseData;
        } catch (error) {
            if (error instanceof $jld5k.CartError) throw error;
            const lineItem = await this.getCartItem(data.line);
            throw new $jld5k.UpdateCartError(error.message, lineItem);
        }
    }
    async updateLineItem(lineId, quantity) {
        if (quantity < 1) return this.removeLineItem(lineId);
        let lineItem = await this.getCartItem(lineId);
        document.dispatchEvent(new $29n7W.CartProcessingStartEvent({
            lineItem: lineItem
        }));
        return this.handleCartApiCall(async ()=>{
            const cart = await this.updateCart({
                line: lineId,
                quantity: quantity
            });
            if (cart.items_added[0] || cart.items_removed[0]) lineItem = cart.items_added[0] || cart.items_removed[0];
            const event = new $29n7W.UpdateCartEvent({
                lineItem: lineItem,
                cart: cart
            });
            document.dispatchEvent(event);
            document.dispatchEvent(new $29n7W.CartProcessingEndEvent({
                lineItem: lineItem
            }));
        }, lineId);
    }
    async updateSellingPlan(lineId, sellingPlanId) {
        const lineItem = await this.getCartItem(lineId);
        document.dispatchEvent(new $29n7W.CartProcessingStartEvent({
            lineItem: lineItem
        }));
        return this.handleCartApiCall(async ()=>{
            const cart = await this.updateCart({
                line: lineId,
                selling_plan: sellingPlanId
            });
            const lineItem = cart.items[lineId - 1];
            const event = new $29n7W.UpdateCartEvent({
                lineItem: lineItem,
                cart: cart
            });
            document.dispatchEvent(event);
            document.dispatchEvent(new $29n7W.CartProcessingEndEvent({
                lineItem: lineItem
            }));
        });
    }
    async removeLineItem(lineId) {
        const lineItem = await this.getCartItem(lineId);
        document.dispatchEvent(new $29n7W.CartProcessingStartEvent({
            lineItem: lineItem
        }));
        return this.handleCartApiCall(async ()=>{
            const cart = await this.updateCart({
                line: lineId,
                quantity: 0
            });
            const lineItem = cart.items_removed[0];
            const event = new $29n7W.RemoveFromCartEvent({
                lineItem: lineItem,
                cart: cart
            });
            document.dispatchEvent(event);
            document.dispatchEvent(new $29n7W.CartProcessingEndEvent({
                lineItem: lineItem
            }));
        }, lineId);
    }
    async getCartDiscounts(forCustomer = false) {
        const cart = await this.getCart();
        const discounts = cart.items.reduce((acc = {}, item)=>{
            item.line_level_discount_allocations.filter(({ discount_application: discount_application })=>forCustomer ? discount_application.type === 'discount_code' : discount_application.type !== 'discount_code').forEach((discount)=>{
                const { key: key, title: title } = discount.discount_application;
                if (!(key in acc)) acc[key] = {
                    title: title,
                    amount: 0
                };
                acc[key].amount += discount.amount;
            });
            return acc;
        }, {});
        cart.cart_level_discount_applications.filter((item)=>forCustomer ? item.type === 'discount_code' : item.type !== 'discount_code').forEach((discount)=>{
            const { key: key, title: title } = discount;
            if (!(key in discounts)) discounts[key] = {
                title: title,
                amount: 0
            };
            discounts[key].amount += discount.total_allocated_amount;
        });
        return discounts;
    }
    async getCustomerDiscounts() {
        return this.getCartDiscounts(true);
    }
    async applyDiscount(code, silent = false) {
        return this.handleCartApiCall(async ()=>{
            const response = await fetch(`${$c5a02efd1c559a06$var$root}discount/${code}`);
            if (!response.ok) throw new $jld5k.DiscountCodeFormError();
            if (silent) return;
            const cart = await this.getCart();
            const discountApplication = cart.cart_level_discount_applications.find((discount)=>discount.title.toLowerCase() === code.toLowerCase()) || cart.items.find((item)=>!!item.line_level_discount_allocations.find(({ discount_application: discount_application })=>discount_application.type === 'discount_code' && discount_application.title.toLowerCase() === code.toLowerCase()));
            if (!discountApplication) throw new $jld5k.InvalidDiscountCodeError();
            const event = new $29n7W.CartDiscountAppliedEvent({
                code: code,
                cart: cart,
                discountApplication: discountApplication
            });
            document.dispatchEvent(event);
        });
    }
    async removeDiscount() {
        // We can remove the discount code by applying a random, invalid code, silently
        return this.handleCartApiCall(async ()=>{
            await this.applyDiscount('77020ce6-f651-4b08-97d1-69afcce0c2e4', true);
            document.dispatchEvent(new $29n7W.CartDiscountRemovedEvent());
        });
    }
}, $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "handleSubmit", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "handleSubmit"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "handleCartApiCall", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "handleCartApiCall"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCart"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCartItem", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCartItem"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCartVariant", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCartVariant"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "addToCart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "addToCart"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "updateCart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "updateCart"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "updateLineItem", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "updateLineItem"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "updateSellingPlan", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "updateSellingPlan"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "removeLineItem", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "removeLineItem"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCartDiscounts", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "getCartDiscounts"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "applyDiscount", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "applyDiscount"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_applyDecoratedDescriptor($c5a02efd1c559a06$var$_class.prototype, "removeDiscount", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c5a02efd1c559a06$var$_class.prototype, "removeDiscount"), $c5a02efd1c559a06$var$_class.prototype), $c5a02efd1c559a06$var$_class);

});
parcelRegister("jld5k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateCartError = module.exports.RemoveFromCartError = module.exports.ProductNotInCartError = module.exports.ProductNotFoundCartError = module.exports.NotEnoughStockCartItemError = module.exports.NotEnoughStockCartError = module.exports.InvalidDiscountCodeError = module.exports.DiscountCodeFormError = module.exports.CartItemError = module.exports.CartError = module.exports.AddToCartError = void 0;
function $e14a20e565a08a40$var$_defineProperty(e, r, t) {
    return (r = $e14a20e565a08a40$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e14a20e565a08a40$var$_toPropertyKey(t) {
    var i = $e14a20e565a08a40$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e14a20e565a08a40$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $e14a20e565a08a40$var$CartError extends Error {
    constructor(internalErrorMessage, message){
        super(message || window.theme.strings.cart.errors.general);
        $e14a20e565a08a40$var$_defineProperty(this, "internalErrorMessage", null);
        this.name = 'CartError';
        this.internalErrorMessage = internalErrorMessage;
    }
}
module.exports.CartError = $e14a20e565a08a40$var$CartError;
class $e14a20e565a08a40$var$CartItemError extends $e14a20e565a08a40$var$CartError {
    constructor(internalErrorMessage, lineItem, message){
        if (!lineItem) throw new Error('lineItem is required in cart item error data');
        super(internalErrorMessage, message);
        $e14a20e565a08a40$var$_defineProperty(this, "lineItem", null);
        this.name = 'CartItemError';
        this.lineItem = lineItem;
    }
}
module.exports.CartItemError = $e14a20e565a08a40$var$CartItemError;
class $e14a20e565a08a40$var$AddToCartError extends $e14a20e565a08a40$var$CartError {
    constructor(internalErrorMessage, message){
        message = message || window.theme.strings.cart.errors.add_to_cart_error;
        super(internalErrorMessage, message);
        this.name = 'AddToCartError';
    }
}
module.exports.AddToCartError = $e14a20e565a08a40$var$AddToCartError;
class $e14a20e565a08a40$var$UpdateCartError extends $e14a20e565a08a40$var$CartItemError {
    constructor(internalErrorMessage, lineItem, message){
        message = message || window.theme.strings.cart.errors.update_cart_error;
        super(internalErrorMessage, lineItem, message);
        this.name = 'UpdateCartError';
    }
}
module.exports.UpdateCartError = $e14a20e565a08a40$var$UpdateCartError;
class $e14a20e565a08a40$var$RemoveFromCartError extends $e14a20e565a08a40$var$CartItemError {
    constructor(internalErrorMessage, lineItem, message){
        message = message || window.theme.strings.cart.errors.remove_error;
        super(internalErrorMessage, lineItem, message);
        this.name = 'RemoveFromCartError';
    }
}
module.exports.RemoveFromCartError = $e14a20e565a08a40$var$RemoveFromCartError;
class $e14a20e565a08a40$var$ProductNotFoundCartError extends $e14a20e565a08a40$var$AddToCartError {
    constructor(internalErrorMessage, message){
        message = message || window.theme.strings.cart.errors.product_not_found;
        super(internalErrorMessage, message);
        this.name = 'ProductNotFoundCartError';
    }
}
module.exports.ProductNotFoundCartError = $e14a20e565a08a40$var$ProductNotFoundCartError;
class $e14a20e565a08a40$var$NotEnoughStockCartError extends $e14a20e565a08a40$var$AddToCartError {
    constructor(internalErrorMessage, message){
        message = message || window.theme.strings.cart.errors.not_enough_stock;
        super(internalErrorMessage, message);
        this.name = 'NotEnoughStockCartError';
    }
}
module.exports.NotEnoughStockCartError = $e14a20e565a08a40$var$NotEnoughStockCartError;
class $e14a20e565a08a40$var$ProductNotInCartError extends $e14a20e565a08a40$var$UpdateCartError {
    constructor(internalErrorMessage, lineItem, message){
        message = message || window.theme.strings.cart.errors.product_not_in_cart;
        super(internalErrorMessage, lineItem, message);
        this.name = 'ProductNotInCartError';
    }
}
module.exports.ProductNotInCartError = $e14a20e565a08a40$var$ProductNotInCartError;
class $e14a20e565a08a40$var$NotEnoughStockCartItemError extends $e14a20e565a08a40$var$UpdateCartError {
    constructor(internalErrorMessage, lineItem, message){
        message = message || window.theme.strings.cart.errors.not_enough_stock_item;
        super(internalErrorMessage, lineItem, message);
        this.name = 'NotEnoughStockCartItemError';
    }
}
module.exports.NotEnoughStockCartItemError = $e14a20e565a08a40$var$NotEnoughStockCartItemError;
class $e14a20e565a08a40$var$InvalidDiscountCodeError extends $e14a20e565a08a40$var$CartError {
    constructor(internalErrorMessage, message){
        message = message || window.theme.strings.cart.errors.invalid_discount_code;
        super(internalErrorMessage, message);
        this.name = 'InvalidDiscountCodeError';
    }
}
module.exports.InvalidDiscountCodeError = $e14a20e565a08a40$var$InvalidDiscountCodeError;
class $e14a20e565a08a40$var$DiscountCodeFormError extends $e14a20e565a08a40$var$CartError {
    constructor(internalErrorMessage, message){
        message = message || window.theme.strings.cart.errors.discount_code_error;
        super(internalErrorMessage, message);
        this.name = 'DiscountCodeError';
    }
}
module.exports.DiscountCodeFormError = $e14a20e565a08a40$var$DiscountCodeFormError;

});

parcelRegister("29n7W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UpdateCartEvent = module.exports.RemoveFromCartEvent = module.exports.CartProcessingStartEvent = module.exports.CartProcessingEndEvent = module.exports.CartItemOptionalEvent = module.exports.CartItemEvent = module.exports.CartItemErrorEvent = module.exports.CartEvent = module.exports.CartErrorEvent = module.exports.CartDiscountRemovedEvent = module.exports.CartDiscountAppliedEvent = module.exports.AddToCartEvent = void 0;
const $190e5c92ff0fa4f6$var$_excluded = [
    "cart"
], $190e5c92ff0fa4f6$var$_excluded2 = [
    "lineItem"
], $190e5c92ff0fa4f6$var$_excluded3 = [
    "lineItem"
], $190e5c92ff0fa4f6$var$_excluded4 = [
    "error"
], $190e5c92ff0fa4f6$var$_excluded5 = [
    "error"
];
function $190e5c92ff0fa4f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $190e5c92ff0fa4f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $190e5c92ff0fa4f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $190e5c92ff0fa4f6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $190e5c92ff0fa4f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $190e5c92ff0fa4f6$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $190e5c92ff0fa4f6$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $190e5c92ff0fa4f6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $190e5c92ff0fa4f6$var$_defineProperty(e, r, t) {
    return (r = $190e5c92ff0fa4f6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $190e5c92ff0fa4f6$var$_toPropertyKey(t) {
    var i = $190e5c92ff0fa4f6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $190e5c92ff0fa4f6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $190e5c92ff0fa4f6$var$CartEvent extends Event {
    constructor(type, _ref){
        let { cart: cart } = _ref, eventInitDict = $190e5c92ff0fa4f6$var$_objectWithoutProperties(_ref, $190e5c92ff0fa4f6$var$_excluded);
        super(type, eventInitDict);
        /**
     * @type {object}
     */ $190e5c92ff0fa4f6$var$_defineProperty(this, "cart", null);
        if (cart) this.cart = cart;
    }
}
module.exports.CartEvent = $190e5c92ff0fa4f6$var$CartEvent;
class $190e5c92ff0fa4f6$var$CartItemOptionalEvent extends $190e5c92ff0fa4f6$var$CartEvent {
    constructor(type, _ref2){
        let { lineItem: lineItem } = _ref2, eventInitDict = $190e5c92ff0fa4f6$var$_objectWithoutProperties(_ref2, $190e5c92ff0fa4f6$var$_excluded2);
        super(type, eventInitDict);
        if (lineItem) this.lineItem = lineItem;
    }
}
module.exports.CartItemOptionalEvent = $190e5c92ff0fa4f6$var$CartItemOptionalEvent;
class $190e5c92ff0fa4f6$var$CartItemEvent extends $190e5c92ff0fa4f6$var$CartItemOptionalEvent {
    constructor(type, _ref3){
        let { lineItem: lineItem } = _ref3, eventInitDict = $190e5c92ff0fa4f6$var$_objectWithoutProperties(_ref3, $190e5c92ff0fa4f6$var$_excluded3);
        if (!lineItem) throw new Error('lineItem is required in cart item event data');
        super(type, $190e5c92ff0fa4f6$var$_objectSpread({
            lineItem: lineItem
        }, eventInitDict));
        /**
     * @type {object}
     */ $190e5c92ff0fa4f6$var$_defineProperty(this, "lineItem", null);
    }
}
module.exports.CartItemEvent = $190e5c92ff0fa4f6$var$CartItemEvent;
class $190e5c92ff0fa4f6$var$AddToCartEvent extends $190e5c92ff0fa4f6$var$CartItemEvent {
    constructor(eventInitDict){
        super('cart:add', eventInitDict);
    }
}
module.exports.AddToCartEvent = $190e5c92ff0fa4f6$var$AddToCartEvent;
class $190e5c92ff0fa4f6$var$RemoveFromCartEvent extends $190e5c92ff0fa4f6$var$CartItemEvent {
    constructor(eventInitDict){
        super('cart:remove', eventInitDict);
    }
}
module.exports.RemoveFromCartEvent = $190e5c92ff0fa4f6$var$RemoveFromCartEvent;
class $190e5c92ff0fa4f6$var$UpdateCartEvent extends $190e5c92ff0fa4f6$var$CartItemEvent {
    constructor(eventInitDict){
        super('cart:update', eventInitDict);
    }
}
module.exports.UpdateCartEvent = $190e5c92ff0fa4f6$var$UpdateCartEvent;
class $190e5c92ff0fa4f6$var$CartErrorEvent extends $190e5c92ff0fa4f6$var$CartEvent {
    constructor(_ref4){
        let { error: error } = _ref4, eventInitDict = $190e5c92ff0fa4f6$var$_objectWithoutProperties(_ref4, $190e5c92ff0fa4f6$var$_excluded4);
        if (!error) throw new Error('error is required in cart error event data');
        super('cart:error', eventInitDict);
        /**
     * @type {Error}
     */ $190e5c92ff0fa4f6$var$_defineProperty(this, "error", null);
        this.error = error;
    }
}
module.exports.CartErrorEvent = $190e5c92ff0fa4f6$var$CartErrorEvent;
class $190e5c92ff0fa4f6$var$CartItemErrorEvent extends $190e5c92ff0fa4f6$var$CartItemEvent {
    constructor(_ref5){
        let { error: error } = _ref5, eventInitDict = $190e5c92ff0fa4f6$var$_objectWithoutProperties(_ref5, $190e5c92ff0fa4f6$var$_excluded5);
        if (!error) throw new Error('error is required in cart item error event data');
        super('cart:error', eventInitDict);
        /**
     * @type {Error}
     */ $190e5c92ff0fa4f6$var$_defineProperty(this, "error", null);
        this.error = error;
    }
}
module.exports.CartItemErrorEvent = $190e5c92ff0fa4f6$var$CartItemErrorEvent;
class $190e5c92ff0fa4f6$var$CartProcessingStartEvent extends $190e5c92ff0fa4f6$var$CartItemOptionalEvent {
    constructor(eventInitDict = {}){
        super('cart:processing:start', eventInitDict);
    }
}
module.exports.CartProcessingStartEvent = $190e5c92ff0fa4f6$var$CartProcessingStartEvent;
class $190e5c92ff0fa4f6$var$CartProcessingEndEvent extends $190e5c92ff0fa4f6$var$CartItemOptionalEvent {
    constructor(eventInitDict = {}){
        super('cart:processing:end', eventInitDict);
    }
}
module.exports.CartProcessingEndEvent = $190e5c92ff0fa4f6$var$CartProcessingEndEvent;
class $190e5c92ff0fa4f6$var$CartDiscountAppliedEvent extends $190e5c92ff0fa4f6$var$CartEvent {
    constructor(eventInitDict = {}){
        super('cart:discount:apply', eventInitDict);
    }
}
module.exports.CartDiscountAppliedEvent = $190e5c92ff0fa4f6$var$CartDiscountAppliedEvent;
class $190e5c92ff0fa4f6$var$CartDiscountRemovedEvent extends $190e5c92ff0fa4f6$var$CartEvent {
    constructor(eventInitDict = {}){
        super('cart:discount:remove', eventInitDict);
    }
}
module.exports.CartDiscountRemovedEvent = $190e5c92ff0fa4f6$var$CartDiscountRemovedEvent;

});


parcelRegister("ZbtOK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $0b7e9a4b4236cbe4$var$_class;
function $0b7e9a4b4236cbe4$var$_defineProperty(e, r, t) {
    return (r = $0b7e9a4b4236cbe4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0b7e9a4b4236cbe4$var$_toPropertyKey(t) {
    var i = $0b7e9a4b4236cbe4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0b7e9a4b4236cbe4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0b7e9a4b4236cbe4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
const $0b7e9a4b4236cbe4$var$selectors = {
    form: '.collection-filter__form',
    group: '.collection-filter__filter',
    inputs: '.collection-filter__item-input',
    submit: '.collection-filter__submit'
};
let $0b7e9a4b4236cbe4$var$FilterTwo = module.exports.default = ($0b7e9a4b4236cbe4$var$_class = class FilterTwo {
    constructor(){
        /**
     * @type {LiveElement}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "container", new $bFxq0.LiveElement('.collection'));
        /**
     * @type {LiveElement<HTMLFormElement>}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "form", new $bFxq0.LiveElement($0b7e9a4b4236cbe4$var$selectors.form));
        /**
     * @type {LiveNodeList}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "inputs", new $bFxq0.LiveNodeList($0b7e9a4b4236cbe4$var$selectors.inputs));
        /**
     * @type {LiveNodeList}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "filterTitles", new $bFxq0.LiveNodeList('.collection-filter__title'));
        /**
     * @type {LiveNodeList}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "filterToggles", new $bFxq0.LiveNodeList('#filter-toggle, #filter-close'));
        /**
     * @type {LiveElement}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "sortField", new $bFxq0.LiveElement('#sort'));
        /**
     * @type {LiveElement}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "clearFiltersButtons", new $bFxq0.LiveElement('#clear-filters'));
        /**
     * @type {LiveElement}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "horizontalFilter", new $bFxq0.LiveElement('.collection-filter-style-horizontal'));
        /**
     * @type {LiveNodeList<HTMLInputElement>}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "priceRangeInputs", new $bFxq0.LiveNodeList('[data-filter-price-input]'));
        /**
     * @type {LiveNodeList<HTMLInputElement>}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "priceRangeSliders", new $bFxq0.LiveNodeList('[data-filter-price-slider]'));
        /**
     * @type {LiveElement<HTMLButtonElement>}
     */ $0b7e9a4b4236cbe4$var$_defineProperty(this, "priceRangeClear", new $bFxq0.LiveElement('#clear-price-range'));
        this.registerListeners();
        if (sessionStorage.getItem('filter-open') === 'true') {
            this.filterToggles.forEach((item)=>{
                item.setAttribute('aria-expanded', 'true');
            });
            if (this.container.item) this.container.item.classList.add('collection--filter-open');
        }
        this.filterToggles.forEach((item)=>{
            if (!this.container.item.classList.contains('collection--filter-open')) item.querySelector('span').textContent = window.matchMedia('(min-width: 63.75em').matches ? item.dataset.label : item.dataset.mobileLabel;
        });
    }
    registerListeners() {
        this.inputs.addEventListener('input', ()=>{
            this.submit();
        });
        this.filterTitles.addEventListener('click', (event)=>{
            event.preventDefault();
            const target = event.currentTarget || event.target;
            target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        });
        this.filterToggles.addEventListener('click', (event)=>{
            const item = event.currentTarget || event.target;
            const expanded = item.getAttribute('aria-expanded') === 'true';
            this.filterToggles.forEach((item)=>{
                item.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            });
            sessionStorage.setItem('filter-open', expanded ? 'false' : 'true');
            const fn = expanded ? 'remove' : 'add';
            this.container.item.classList[fn]('collection--filter-open');
            this.filterToggles.forEach((item)=>{
                item.querySelector('span').textContent = expanded ? window.matchMedia('(min-width: 63.75em').matches ? item.dataset.label : item.dataset.mobileLabel : item.dataset.closeLabel;
            });
        });
        this.clearFiltersButtons.addEventListener('click', this.clearFilters);
        if (this.horizontalFilter.item) {
            const horizontalFilterTriggers = this.horizontalFilter.item.querySelectorAll('.collection-filter__filter');
            horizontalFilterTriggers.forEach((item)=>{
                item.addEventListener('click', (event)=>{
                    horizontalFilterTriggers.forEach((loopItem)=>{
                        if (loopItem != item) loopItem.setAttribute('aria-expanded', 'false');
                    });
                    const expanded = item.getAttribute('aria-expanded') === 'true';
                    item.setAttribute('aria-expanded', expanded ? 'false' : 'true');
                });
            });
        }
        this.sortField.addEventListener('change', (event)=>{
            const url = new URL(window.location);
            url.searchParams.set('sort_by', event.currentTarget.value);
            window.location = url;
        });
        this.priceRangeInputs.addEventListener('input', (event)=>{
            clearTimeout(this.priceRangeChangeTimeout);
            event.stopPropagation();
            const input = event.currentTarget || event.target;
            const type = input.dataset.filterPriceInput;
            const slider = [
                ...this.priceRangeSliders.items
            ].find((slider)=>slider.dataset.filterPriceSlider === type);
            if (slider) slider.value = input.value;
            const wrapper = slider.closest('.collection-filter__price-range-slider');
            if (wrapper) wrapper.style.setProperty(`--${type}-value`, `${input.value / input.max * 100}%`);
            this.priceRangeChangeTimeout = setTimeout(()=>{
                this.submit();
            }, 250);
        });
        this.priceRangeSliders.addEventListener('input', (event)=>{
            clearTimeout(this.priceRangeChangeTimeout);
            event.stopPropagation();
            const slider = event.currentTarget || event.target;
            const type = slider.dataset.filterPriceSlider;
            const input = [
                ...this.priceRangeInputs.items
            ].find((input)=>input.dataset.filterPriceInput === type);
            if (input) input.value = slider.value;
            const wrapper = slider.closest('.collection-filter__price-range-slider');
            if (wrapper) wrapper.style.setProperty(`--${type}-value`, `${input.value / input.max * 100}%`);
            this.priceRangeChangeTimeout = setTimeout(()=>{
                this.submit();
            }, 250);
        });
        this.priceRangeClear.addEventListener('click', (event)=>{
            event.preventDefault();
            this.priceRangeInputs.items.forEach((input)=>input.value = '');
            this.submit();
        });
    }
    submit() {
        this.form.item?.querySelectorAll('input, textarea, select').forEach((input)=>input.classList.add('pseudo-disabled'));
        this.form.item?.submit();
    }
}, $0b7e9a4b4236cbe4$var$_applyDecoratedDescriptor($0b7e9a4b4236cbe4$var$_class.prototype, "submit", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($0b7e9a4b4236cbe4$var$_class.prototype, "submit"), $0b7e9a4b4236cbe4$var$_class.prototype), $0b7e9a4b4236cbe4$var$_class);

});

parcelRegister("aSWNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ecc8f3e271e49ae$var$_liveNodeList = $7ecc8f3e271e49ae$var$_interopRequireDefault((parcelRequire("bFxq0")));

var $bfbrY = parcelRequire("bfbrY");
var $7ecc8f3e271e49ae$var$_class;
function $7ecc8f3e271e49ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $7ecc8f3e271e49ae$var$_defineProperty(e, r, t) {
    return (r = $7ecc8f3e271e49ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7ecc8f3e271e49ae$var$_toPropertyKey(t) {
    var i = $7ecc8f3e271e49ae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7ecc8f3e271e49ae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7ecc8f3e271e49ae$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $7ecc8f3e271e49ae$var$Form = module.exports.default = ($7ecc8f3e271e49ae$var$_class = class Form {
    constructor(){
        /**
     * @type {string}
     */ $7ecc8f3e271e49ae$var$_defineProperty(this, "errorMessageClass", 'form-group__message');
        /**
     * @type {LiveNodeList}
     */ $7ecc8f3e271e49ae$var$_defineProperty(this, "forms", new $7ecc8f3e271e49ae$var$_liveNodeList.default('form'));
        /**
     * @type {LiveNodeList}
     */ $7ecc8f3e271e49ae$var$_defineProperty(this, "inputs", new $7ecc8f3e271e49ae$var$_liveNodeList.default('input, textarea, select'));
        this.registerListeners();
    }
    registerListeners() {
        this.inputs.forEach(this.setState);
        this.inputs.addEventListener('change', (e)=>{
            this.setState(e.target);
        });
    }
    setState(input) {
        if (![
            'hidden',
            'checkbox',
            'radio'
        ].includes(input.type)) {
            const fn = input.value ? 'add' : 'remove';
            input.classList[fn]('field--filled');
        }
        if (input.value) input.parentNode.classList.remove('form-row--error');
    }
}, $7ecc8f3e271e49ae$var$_applyDecoratedDescriptor($7ecc8f3e271e49ae$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7ecc8f3e271e49ae$var$_class.prototype, "registerListeners"), $7ecc8f3e271e49ae$var$_class.prototype), $7ecc8f3e271e49ae$var$_applyDecoratedDescriptor($7ecc8f3e271e49ae$var$_class.prototype, "setState", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7ecc8f3e271e49ae$var$_class.prototype, "setState"), $7ecc8f3e271e49ae$var$_class.prototype), $7ecc8f3e271e49ae$var$_class);

});

parcelRegister("LCDRY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $08f25d68a2d58c0e$var$_qrcode = $08f25d68a2d58c0e$var$_interopRequireDefault((parcelRequire("a4IBf")));
var $08f25d68a2d58c0e$var$_class;
function $08f25d68a2d58c0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $08f25d68a2d58c0e$var$_defineProperty(e, r, t) {
    return (r = $08f25d68a2d58c0e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $08f25d68a2d58c0e$var$_toPropertyKey(t) {
    var i = $08f25d68a2d58c0e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $08f25d68a2d58c0e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $08f25d68a2d58c0e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $08f25d68a2d58c0e$var$GiftCard = module.exports.default = ($08f25d68a2d58c0e$var$_class = class GiftCard {
    constructor(){
        $08f25d68a2d58c0e$var$_defineProperty(this, "selectors", {
            qrCodeCanvas: '[data-gift-card-qr]',
            printButton: '[data-gift-card-print]',
            giftCardCode: '[data-gift-card-digits]'
        });
        this.registerListeners();
    }
    registerListeners() {
        // This is the QR code that allows customers to use at a POS
        document.querySelectorAll(this.selectors.qrCodeCanvas).forEach((element)=>{
            $08f25d68a2d58c0e$var$_qrcode.default.toCanvas(element, element.dataset.identifier);
        });
        document.querySelectorAll(this.selectors.printButton).forEach((element)=>{
            element.addEventListener('click', ()=>{
                window.print();
            });
        });
        // Auto-select gift card code on click, based on ID passed to the function
        document.querySelectorAll(this.selectors.giftCardCode).forEach((element)=>{
            element.addEventListener('click', (evt)=>{
                const selection = window.getSelection();
                const range = document.createRange();
                range.selectNodeContents(evt.target);
                selection.removeAllRanges();
                selection.addRange(range);
            });
        });
    }
}, $08f25d68a2d58c0e$var$_applyDecoratedDescriptor($08f25d68a2d58c0e$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($08f25d68a2d58c0e$var$_class.prototype, "registerListeners"), $08f25d68a2d58c0e$var$_class.prototype), $08f25d68a2d58c0e$var$_class);

});
parcelRegister("a4IBf", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $755cdfaf93c46fcf$export$185802fd694ee1f5; }, function (v) { return $755cdfaf93c46fcf$export$185802fd694ee1f5 = v; });
$parcel$export(module.exports, "toCanvas", function () { return $755cdfaf93c46fcf$export$f87f6982d1fd4f81; }, function (v) { return $755cdfaf93c46fcf$export$f87f6982d1fd4f81 = v; });
$parcel$export(module.exports, "toDataURL", function () { return $755cdfaf93c46fcf$export$723e4939e5a27c8; }, function (v) { return $755cdfaf93c46fcf$export$723e4939e5a27c8 = v; });
$parcel$export(module.exports, "toString", function () { return $755cdfaf93c46fcf$export$f84e8e69fd4488a5; }, function (v) { return $755cdfaf93c46fcf$export$f84e8e69fd4488a5 = v; });
var $755cdfaf93c46fcf$export$185802fd694ee1f5;
var $755cdfaf93c46fcf$export$f87f6982d1fd4f81;
var $755cdfaf93c46fcf$export$723e4939e5a27c8;
// only svg for now.
var $755cdfaf93c46fcf$export$f84e8e69fd4488a5;

var $kDkNb = parcelRequire("kDkNb");

var $gAnCj = parcelRequire("gAnCj");

var $ikXFc = parcelRequire("ikXFc");

var $8l9CX = parcelRequire("8l9CX");
function $755cdfaf93c46fcf$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === 'function';
    if (!isLastArgCb && !$kDkNb()) throw new Error('Callback required as last argument');
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error('Too few arguments provided');
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === 'undefined') {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error('Too few arguments provided');
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $gAnCj.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $gAnCj.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$755cdfaf93c46fcf$export$185802fd694ee1f5 = $gAnCj.create;
$755cdfaf93c46fcf$export$f87f6982d1fd4f81 = $755cdfaf93c46fcf$var$renderCanvas.bind(null, $ikXFc.render);
$755cdfaf93c46fcf$export$723e4939e5a27c8 = $755cdfaf93c46fcf$var$renderCanvas.bind(null, $ikXFc.renderToDataURL);
$755cdfaf93c46fcf$export$f84e8e69fd4488a5 = $755cdfaf93c46fcf$var$renderCanvas.bind(null, function(data, _, opts) {
    return $8l9CX.render(data, opts);
});

});
parcelRegister("kDkNb", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("gAnCj", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $c13253f8068f611a$export$185802fd694ee1f5; }, function (v) { return $c13253f8068f611a$export$185802fd694ee1f5 = v; });
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $c13253f8068f611a$export$185802fd694ee1f5;

var $clK7V = parcelRequire("clK7V");

var $6i9A9 = parcelRequire("6i9A9");

var $3hA53 = parcelRequire("3hA53");

var $gPKUa = parcelRequire("gPKUa");

var $ishHx = parcelRequire("ishHx");

var $a3sRM = parcelRequire("a3sRM");

var $klsGe = parcelRequire("klsGe");

var $lCyZF = parcelRequire("lCyZF");

var $244Ug = parcelRequire("244Ug");

var $2UyQX = parcelRequire("2UyQX");

var $iYeLP = parcelRequire("iYeLP");

var $kVmIx = parcelRequire("kVmIx");

var $2GVj2 = parcelRequire("2GVj2");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c13253f8068f611a$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $a3sRM.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $c13253f8068f611a$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c13253f8068f611a$var$setupAlignmentPattern(matrix, version) {
    const pos = $ishHx.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $c13253f8068f611a$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $2UyQX.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $c13253f8068f611a$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $iYeLP.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $c13253f8068f611a$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $c13253f8068f611a$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $3hA53();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $kVmIx.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $clK7V.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $lCyZF.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $c13253f8068f611a$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $c13253f8068f611a$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $clK7V.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $lCyZF.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $lCyZF.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $244Ug(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $c13253f8068f611a$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $2GVj2.fromArray(data);
    else if (typeof data === 'string') {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $2GVj2.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $2UyQX.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $2GVj2.fromString(data, estimatedVersion || 40);
    } else throw new Error('Invalid data');
    // Get the min version that can contain data
    const bestVersion = $2UyQX.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error('The amount of data is too big to be stored in a QR Code');
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + '.\n');
    const dataBits = $c13253f8068f611a$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $clK7V.getSymbolSize(version);
    const modules = new $gPKUa(moduleCount);
    // Add function modules
    $c13253f8068f611a$var$setupFinderPattern(modules, version);
    $c13253f8068f611a$var$setupTimingPattern(modules);
    $c13253f8068f611a$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $c13253f8068f611a$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $c13253f8068f611a$var$setupVersionInfo(modules, version);
    // Add data codewords
    $c13253f8068f611a$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $klsGe.getBestMask(modules, $c13253f8068f611a$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $klsGe.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $c13253f8068f611a$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$c13253f8068f611a$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === 'undefined' || data === '') throw new Error('No input text');
    let errorCorrectionLevel = $6i9A9.M;
    let version;
    let mask;
    if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel = $6i9A9.from(options.errorCorrectionLevel, $6i9A9.M);
        version = $2UyQX.from(options.version);
        mask = $klsGe.from(options.maskPattern);
        if (options.toSJISFunc) $clK7V.setToSJISFunction(options.toSJISFunc);
    }
    return $c13253f8068f611a$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("clK7V", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", function () { return $8fdb3a04deb6b1b7$export$8d4a06d3facd414b; }, function (v) { return $8fdb3a04deb6b1b7$export$8d4a06d3facd414b = v; });
$parcel$export(module.exports, "getSymbolTotalCodewords", function () { return $8fdb3a04deb6b1b7$export$b05dac13c7a35c32; }, function (v) { return $8fdb3a04deb6b1b7$export$b05dac13c7a35c32 = v; });
$parcel$export(module.exports, "getBCHDigit", function () { return $8fdb3a04deb6b1b7$export$ed1d66da50968976; }, function (v) { return $8fdb3a04deb6b1b7$export$ed1d66da50968976 = v; });
$parcel$export(module.exports, "setToSJISFunction", function () { return $8fdb3a04deb6b1b7$export$6733b14783f975c2; }, function (v) { return $8fdb3a04deb6b1b7$export$6733b14783f975c2 = v; });
$parcel$export(module.exports, "isKanjiModeEnabled", function () { return $8fdb3a04deb6b1b7$export$ce5b1274f8597fa0; }, function (v) { return $8fdb3a04deb6b1b7$export$ce5b1274f8597fa0 = v; });
$parcel$export(module.exports, "toSJIS", function () { return $8fdb3a04deb6b1b7$export$43dd553ecded716d; }, function (v) { return $8fdb3a04deb6b1b7$export$43dd553ecded716d = v; });
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $8fdb3a04deb6b1b7$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $8fdb3a04deb6b1b7$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $8fdb3a04deb6b1b7$export$ed1d66da50968976;
var $8fdb3a04deb6b1b7$export$6733b14783f975c2;
var $8fdb3a04deb6b1b7$export$ce5b1274f8597fa0;
var $8fdb3a04deb6b1b7$export$43dd553ecded716d;
let $8fdb3a04deb6b1b7$var$toSJISFunction;
const $8fdb3a04deb6b1b7$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$8fdb3a04deb6b1b7$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$8fdb3a04deb6b1b7$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $8fdb3a04deb6b1b7$var$CODEWORDS_COUNT[version];
};
$8fdb3a04deb6b1b7$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$8fdb3a04deb6b1b7$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== 'function') throw new Error('"toSJISFunc" is not a valid function.');
    $8fdb3a04deb6b1b7$var$toSJISFunction = f;
};
$8fdb3a04deb6b1b7$export$ce5b1274f8597fa0 = function() {
    return typeof $8fdb3a04deb6b1b7$var$toSJISFunction !== 'undefined';
};
$8fdb3a04deb6b1b7$export$43dd553ecded716d = function toSJIS(kanji) {
    return $8fdb3a04deb6b1b7$var$toSJISFunction(kanji);
};

});

parcelRegister("6i9A9", function(module, exports) {

$parcel$export(module.exports, "L", function () { return $494bdb52c69e1c27$export$61196ced6d74a310; }, function (v) { return $494bdb52c69e1c27$export$61196ced6d74a310 = v; });
$parcel$export(module.exports, "M", function () { return $494bdb52c69e1c27$export$3a1a48c8f6ef640e; }, function (v) { return $494bdb52c69e1c27$export$3a1a48c8f6ef640e = v; });
$parcel$export(module.exports, "Q", function () { return $494bdb52c69e1c27$export$3722cfe417b6ed86; }, function (v) { return $494bdb52c69e1c27$export$3722cfe417b6ed86 = v; });
$parcel$export(module.exports, "H", function () { return $494bdb52c69e1c27$export$7f8ddf7c7c20b3cd; }, function (v) { return $494bdb52c69e1c27$export$7f8ddf7c7c20b3cd = v; });
$parcel$export(module.exports, "isValid", function () { return $494bdb52c69e1c27$export$1ea939691cdc45b8; }, function (v) { return $494bdb52c69e1c27$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $494bdb52c69e1c27$export$6788812c4e6611e6; }, function (v) { return $494bdb52c69e1c27$export$6788812c4e6611e6 = v; });
var $494bdb52c69e1c27$export$61196ced6d74a310;
var $494bdb52c69e1c27$export$3a1a48c8f6ef640e;
var $494bdb52c69e1c27$export$3722cfe417b6ed86;
var $494bdb52c69e1c27$export$7f8ddf7c7c20b3cd;
var $494bdb52c69e1c27$export$1ea939691cdc45b8;
var $494bdb52c69e1c27$export$6788812c4e6611e6;
$494bdb52c69e1c27$export$61196ced6d74a310 = {
    bit: 1
};
$494bdb52c69e1c27$export$3a1a48c8f6ef640e = {
    bit: 0
};
$494bdb52c69e1c27$export$3722cfe417b6ed86 = {
    bit: 3
};
$494bdb52c69e1c27$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $494bdb52c69e1c27$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'l':
        case 'low':
            return $494bdb52c69e1c27$export$61196ced6d74a310;
        case 'm':
        case 'medium':
            return $494bdb52c69e1c27$export$3a1a48c8f6ef640e;
        case 'q':
        case 'quartile':
            return $494bdb52c69e1c27$export$3722cfe417b6ed86;
        case 'h':
        case 'high':
            return $494bdb52c69e1c27$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error('Unknown EC Level: ' + string);
    }
}
$494bdb52c69e1c27$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== 'undefined' && level.bit >= 0 && level.bit < 4;
};
$494bdb52c69e1c27$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($494bdb52c69e1c27$export$1ea939691cdc45b8(value)) return value;
    try {
        return $494bdb52c69e1c27$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("3hA53", function(module, exports) {
function $263ef272dd4df84b$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$263ef272dd4df84b$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $263ef272dd4df84b$var$BitBuffer;

});

parcelRegister("gPKUa", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $c415cb209b347270$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error('BitMatrix size must be defined and greater than 0');
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $c415cb209b347270$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $c415cb209b347270$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $c415cb209b347270$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $c415cb209b347270$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $c415cb209b347270$var$BitMatrix;

});

parcelRegister("ishHx", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", function () { return $d6f8929d457a5ce3$export$cb05537eb8e57a83; }, function (v) { return $d6f8929d457a5ce3$export$cb05537eb8e57a83 = v; });
$parcel$export(module.exports, "getPositions", function () { return $d6f8929d457a5ce3$export$c39457c570f2b189; }, function (v) { return $d6f8929d457a5ce3$export$c39457c570f2b189 = v; });
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $d6f8929d457a5ce3$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $d6f8929d457a5ce3$export$c39457c570f2b189;

var $clK7V = parcelRequire("clK7V");
var $d6f8929d457a5ce3$require$getSymbolSize = $clK7V.getSymbolSize;
$d6f8929d457a5ce3$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $d6f8929d457a5ce3$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$d6f8929d457a5ce3$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $d6f8929d457a5ce3$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("a3sRM", function(module, exports) {

$parcel$export(module.exports, "getPositions", function () { return $752093736045a529$export$c39457c570f2b189; }, function (v) { return $752093736045a529$export$c39457c570f2b189 = v; });
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $752093736045a529$export$c39457c570f2b189;

var $clK7V = parcelRequire("clK7V");
var $752093736045a529$require$getSymbolSize = $clK7V.getSymbolSize;
const $752093736045a529$var$FINDER_PATTERN_SIZE = 7;
$752093736045a529$export$c39457c570f2b189 = function getPositions(version) {
    const size = $752093736045a529$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $752093736045a529$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $752093736045a529$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("klsGe", function(module, exports) {

$parcel$export(module.exports, "Patterns", function () { return $ecfc04182bcce47f$export$7ed115685df827af; }, function (v) { return $ecfc04182bcce47f$export$7ed115685df827af = v; });
$parcel$export(module.exports, "isValid", function () { return $ecfc04182bcce47f$export$1ea939691cdc45b8; }, function (v) { return $ecfc04182bcce47f$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $ecfc04182bcce47f$export$6788812c4e6611e6; }, function (v) { return $ecfc04182bcce47f$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getPenaltyN1", function () { return $ecfc04182bcce47f$export$a5fd3a02c14d0b3e; }, function (v) { return $ecfc04182bcce47f$export$a5fd3a02c14d0b3e = v; });
$parcel$export(module.exports, "getPenaltyN2", function () { return $ecfc04182bcce47f$export$9a9385107a518e46; }, function (v) { return $ecfc04182bcce47f$export$9a9385107a518e46 = v; });
$parcel$export(module.exports, "getPenaltyN3", function () { return $ecfc04182bcce47f$export$ade754353f0dc75e; }, function (v) { return $ecfc04182bcce47f$export$ade754353f0dc75e = v; });
$parcel$export(module.exports, "getPenaltyN4", function () { return $ecfc04182bcce47f$export$3ff6f04d40d9962b; }, function (v) { return $ecfc04182bcce47f$export$3ff6f04d40d9962b = v; });
$parcel$export(module.exports, "applyMask", function () { return $ecfc04182bcce47f$export$a1c9aa9c0e8ba394; }, function (v) { return $ecfc04182bcce47f$export$a1c9aa9c0e8ba394 = v; });
$parcel$export(module.exports, "getBestMask", function () { return $ecfc04182bcce47f$export$fe9625aaceb0e563; }, function (v) { return $ecfc04182bcce47f$export$fe9625aaceb0e563 = v; });
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $ecfc04182bcce47f$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $ecfc04182bcce47f$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $ecfc04182bcce47f$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $ecfc04182bcce47f$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $ecfc04182bcce47f$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $ecfc04182bcce47f$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $ecfc04182bcce47f$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $ecfc04182bcce47f$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $ecfc04182bcce47f$export$fe9625aaceb0e563;
$ecfc04182bcce47f$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $ecfc04182bcce47f$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$ecfc04182bcce47f$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$ecfc04182bcce47f$export$6788812c4e6611e6 = function from(value) {
    return $ecfc04182bcce47f$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$ecfc04182bcce47f$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $ecfc04182bcce47f$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $ecfc04182bcce47f$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $ecfc04182bcce47f$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $ecfc04182bcce47f$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$ecfc04182bcce47f$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $ecfc04182bcce47f$var$PenaltyScores.N2;
};
$ecfc04182bcce47f$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $ecfc04182bcce47f$var$PenaltyScores.N3;
};
$ecfc04182bcce47f$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $ecfc04182bcce47f$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $ecfc04182bcce47f$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $ecfc04182bcce47f$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error('bad maskPattern:' + maskPattern);
    }
}
$ecfc04182bcce47f$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $ecfc04182bcce47f$var$getMaskAt(pattern, row, col));
    }
};
$ecfc04182bcce47f$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($ecfc04182bcce47f$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $ecfc04182bcce47f$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $ecfc04182bcce47f$export$a5fd3a02c14d0b3e(data) + $ecfc04182bcce47f$export$9a9385107a518e46(data) + $ecfc04182bcce47f$export$ade754353f0dc75e(data) + $ecfc04182bcce47f$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $ecfc04182bcce47f$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("lCyZF", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", function () { return $fbd84a9b87f11bbe$export$41a1fc627aca72b9; }, function (v) { return $fbd84a9b87f11bbe$export$41a1fc627aca72b9 = v; });
$parcel$export(module.exports, "getTotalCodewordsCount", function () { return $fbd84a9b87f11bbe$export$683d1b3e8a1a8438; }, function (v) { return $fbd84a9b87f11bbe$export$683d1b3e8a1a8438 = v; });
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $fbd84a9b87f11bbe$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $fbd84a9b87f11bbe$export$683d1b3e8a1a8438;

var $6i9A9 = parcelRequire("6i9A9");
const $fbd84a9b87f11bbe$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $fbd84a9b87f11bbe$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$fbd84a9b87f11bbe$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $6i9A9.L:
            return $fbd84a9b87f11bbe$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $6i9A9.M:
            return $fbd84a9b87f11bbe$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $6i9A9.Q:
            return $fbd84a9b87f11bbe$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $6i9A9.H:
            return $fbd84a9b87f11bbe$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$fbd84a9b87f11bbe$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $6i9A9.L:
            return $fbd84a9b87f11bbe$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $6i9A9.M:
            return $fbd84a9b87f11bbe$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $6i9A9.Q:
            return $fbd84a9b87f11bbe$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $6i9A9.H:
            return $fbd84a9b87f11bbe$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("244Ug", function(module, exports) {

var $72Ltj = parcelRequire("72Ltj");
function $180fc2d6ceaebbb5$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $180fc2d6ceaebbb5$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $72Ltj.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $180fc2d6ceaebbb5$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error('Encoder not initialized');
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $72Ltj.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $180fc2d6ceaebbb5$var$ReedSolomonEncoder;

});
parcelRegister("72Ltj", function(module, exports) {

$parcel$export(module.exports, "mul", function () { return $520d8b34f4ef465b$export$6e3a27864ab166fe; }, function (v) { return $520d8b34f4ef465b$export$6e3a27864ab166fe = v; });
$parcel$export(module.exports, "mod", function () { return $520d8b34f4ef465b$export$842a2cf37af977e1; }, function (v) { return $520d8b34f4ef465b$export$842a2cf37af977e1 = v; });
$parcel$export(module.exports, "generateECPolynomial", function () { return $520d8b34f4ef465b$export$7b8be06a973a9d05; }, function (v) { return $520d8b34f4ef465b$export$7b8be06a973a9d05 = v; });
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $520d8b34f4ef465b$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $520d8b34f4ef465b$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $520d8b34f4ef465b$export$7b8be06a973a9d05;

var $jbpqx = parcelRequire("jbpqx");
$520d8b34f4ef465b$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $jbpqx.mul(p1[i], p2[j]);
    return coeff;
};
$520d8b34f4ef465b$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $jbpqx.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$520d8b34f4ef465b$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $520d8b34f4ef465b$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $jbpqx.exp(i)
    ]));
    return poly;
};

});
parcelRegister("jbpqx", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $df72c4ae3810800f$export$b310ec824aaee37f; }, function (v) { return $df72c4ae3810800f$export$b310ec824aaee37f = v; });
$parcel$export(module.exports, "mul", function () { return $df72c4ae3810800f$export$6e3a27864ab166fe; }, function (v) { return $df72c4ae3810800f$export$6e3a27864ab166fe = v; });
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $df72c4ae3810800f$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $df72c4ae3810800f$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $df72c4ae3810800f$export$6e3a27864ab166fe;
const $df72c4ae3810800f$var$EXP_TABLE = new Uint8Array(512);
const $df72c4ae3810800f$var$LOG_TABLE = new Uint8Array(256);
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $df72c4ae3810800f$var$EXP_TABLE[i] = x;
        $df72c4ae3810800f$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$df72c4ae3810800f$var$EXP_TABLE[i] = $df72c4ae3810800f$var$EXP_TABLE[i - 255];
})();
$df72c4ae3810800f$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error('log(' + n + ')');
    return $df72c4ae3810800f$var$LOG_TABLE[n];
};
$df72c4ae3810800f$export$b310ec824aaee37f = function exp(n) {
    return $df72c4ae3810800f$var$EXP_TABLE[n];
};
$df72c4ae3810800f$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $df72c4ae3810800f$var$EXP_TABLE[$df72c4ae3810800f$var$LOG_TABLE[x] + $df72c4ae3810800f$var$LOG_TABLE[y]];
};

});



parcelRegister("2UyQX", function(module, exports) {

$parcel$export(module.exports, "getCapacity", function () { return $21ebd8d72c3f8606$export$55b283886ec2d3fb; }, function (v) { return $21ebd8d72c3f8606$export$55b283886ec2d3fb = v; });
$parcel$export(module.exports, "from", function () { return $21ebd8d72c3f8606$export$6788812c4e6611e6; }, function (v) { return $21ebd8d72c3f8606$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getBestVersionForData", function () { return $21ebd8d72c3f8606$export$264e969aa7a8ff7e; }, function (v) { return $21ebd8d72c3f8606$export$264e969aa7a8ff7e = v; });
$parcel$export(module.exports, "getEncodedBits", function () { return $21ebd8d72c3f8606$export$eee5438974ef6f0e; }, function (v) { return $21ebd8d72c3f8606$export$eee5438974ef6f0e = v; });
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $21ebd8d72c3f8606$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $21ebd8d72c3f8606$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $21ebd8d72c3f8606$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $21ebd8d72c3f8606$export$eee5438974ef6f0e;

var $clK7V = parcelRequire("clK7V");

var $lCyZF = parcelRequire("lCyZF");

var $6i9A9 = parcelRequire("6i9A9");

var $kVmIx = parcelRequire("kVmIx");

var $7Vhhs = parcelRequire("7Vhhs");
// Generator polynomial used to encode version information
const $21ebd8d72c3f8606$var$G18 = 7973;
const $21ebd8d72c3f8606$var$G18_BCH = $clK7V.getBCHDigit($21ebd8d72c3f8606$var$G18);
function $21ebd8d72c3f8606$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $21ebd8d72c3f8606$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $21ebd8d72c3f8606$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $kVmIx.getCharCountIndicator(mode, version) + 4;
}
function $21ebd8d72c3f8606$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $21ebd8d72c3f8606$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $21ebd8d72c3f8606$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $21ebd8d72c3f8606$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $21ebd8d72c3f8606$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $kVmIx.MIXED)) return currentVersion;
    }
    return undefined;
}
$21ebd8d72c3f8606$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7Vhhs.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$21ebd8d72c3f8606$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7Vhhs.isValid(version)) throw new Error('Invalid QR Code version');
    // Use Byte mode as default
    if (typeof mode === 'undefined') mode = $kVmIx.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $clK7V.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $lCyZF.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $kVmIx.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $21ebd8d72c3f8606$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $kVmIx.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $kVmIx.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $kVmIx.KANJI:
            return Math.floor(usableBits / 13);
        case $kVmIx.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$21ebd8d72c3f8606$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $6i9A9.from(errorCorrectionLevel, $6i9A9.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $21ebd8d72c3f8606$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $21ebd8d72c3f8606$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$21ebd8d72c3f8606$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7Vhhs.isValid(version) || version < 7) throw new Error('Invalid QR Code version');
    let d = version << 12;
    while($clK7V.getBCHDigit(d) - $21ebd8d72c3f8606$var$G18_BCH >= 0)d ^= $21ebd8d72c3f8606$var$G18 << $clK7V.getBCHDigit(d) - $21ebd8d72c3f8606$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("kVmIx", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", function () { return $f3bac0b3a382822f$export$4d318981b5a83836; }, function (v) { return $f3bac0b3a382822f$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $f3bac0b3a382822f$export$376a9ed239d6c1c8; }, function (v) { return $f3bac0b3a382822f$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "BYTE", function () { return $f3bac0b3a382822f$export$8f4bf8f7eb581284; }, function (v) { return $f3bac0b3a382822f$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "KANJI", function () { return $f3bac0b3a382822f$export$a4d452c2363c8e12; }, function (v) { return $f3bac0b3a382822f$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "MIXED", function () { return $f3bac0b3a382822f$export$bb410559a65d3418; }, function (v) { return $f3bac0b3a382822f$export$bb410559a65d3418 = v; });
$parcel$export(module.exports, "getCharCountIndicator", function () { return $f3bac0b3a382822f$export$e79764af6ffaeb8d; }, function (v) { return $f3bac0b3a382822f$export$e79764af6ffaeb8d = v; });
$parcel$export(module.exports, "getBestModeForData", function () { return $f3bac0b3a382822f$export$1bd4c93ffb42e55e; }, function (v) { return $f3bac0b3a382822f$export$1bd4c93ffb42e55e = v; });
$parcel$export(module.exports, "toString", function () { return $f3bac0b3a382822f$export$f84e8e69fd4488a5; }, function (v) { return $f3bac0b3a382822f$export$f84e8e69fd4488a5 = v; });
$parcel$export(module.exports, "isValid", function () { return $f3bac0b3a382822f$export$1ea939691cdc45b8; }, function (v) { return $f3bac0b3a382822f$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $f3bac0b3a382822f$export$6788812c4e6611e6; }, function (v) { return $f3bac0b3a382822f$export$6788812c4e6611e6 = v; });
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $f3bac0b3a382822f$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $f3bac0b3a382822f$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $f3bac0b3a382822f$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $f3bac0b3a382822f$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $f3bac0b3a382822f$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $f3bac0b3a382822f$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $f3bac0b3a382822f$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $f3bac0b3a382822f$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $f3bac0b3a382822f$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $f3bac0b3a382822f$export$6788812c4e6611e6;

var $7Vhhs = parcelRequire("7Vhhs");

var $54OfO = parcelRequire("54OfO");
$f3bac0b3a382822f$export$4d318981b5a83836 = {
    id: 'Numeric',
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$f3bac0b3a382822f$export$376a9ed239d6c1c8 = {
    id: 'Alphanumeric',
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$f3bac0b3a382822f$export$8f4bf8f7eb581284 = {
    id: 'Byte',
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$f3bac0b3a382822f$export$a4d452c2363c8e12 = {
    id: 'Kanji',
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$f3bac0b3a382822f$export$bb410559a65d3418 = {
    bit: -1
};
$f3bac0b3a382822f$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error('Invalid mode: ' + mode);
    if (!$7Vhhs.isValid(version)) throw new Error('Invalid version: ' + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$f3bac0b3a382822f$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($54OfO.testNumeric(dataStr)) return $f3bac0b3a382822f$export$4d318981b5a83836;
    else if ($54OfO.testAlphanumeric(dataStr)) return $f3bac0b3a382822f$export$376a9ed239d6c1c8;
    else if ($54OfO.testKanji(dataStr)) return $f3bac0b3a382822f$export$a4d452c2363c8e12;
    else return $f3bac0b3a382822f$export$8f4bf8f7eb581284;
};
$f3bac0b3a382822f$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error('Invalid mode');
};
$f3bac0b3a382822f$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $f3bac0b3a382822f$var$fromString(string) {
    if (typeof string !== 'string') throw new Error('Param is not a string');
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case 'numeric':
            return $f3bac0b3a382822f$export$4d318981b5a83836;
        case 'alphanumeric':
            return $f3bac0b3a382822f$export$376a9ed239d6c1c8;
        case 'kanji':
            return $f3bac0b3a382822f$export$a4d452c2363c8e12;
        case 'byte':
            return $f3bac0b3a382822f$export$8f4bf8f7eb581284;
        default:
            throw new Error('Unknown mode: ' + string);
    }
}
$f3bac0b3a382822f$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($f3bac0b3a382822f$export$1ea939691cdc45b8(value)) return value;
    try {
        return $f3bac0b3a382822f$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("7Vhhs", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $5c4b42d86cc17bc8$export$1ea939691cdc45b8; }, function (v) { return $5c4b42d86cc17bc8$export$1ea939691cdc45b8 = v; });
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $5c4b42d86cc17bc8$export$1ea939691cdc45b8;
$5c4b42d86cc17bc8$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("54OfO", function(module, exports) {

$parcel$export(module.exports, "KANJI", function () { return $3b244ee02fdedeee$export$a4d452c2363c8e12; }, function (v) { return $3b244ee02fdedeee$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "BYTE_KANJI", function () { return $3b244ee02fdedeee$export$9df7c29d562bab83; }, function (v) { return $3b244ee02fdedeee$export$9df7c29d562bab83 = v; });
$parcel$export(module.exports, "BYTE", function () { return $3b244ee02fdedeee$export$8f4bf8f7eb581284; }, function (v) { return $3b244ee02fdedeee$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "NUMERIC", function () { return $3b244ee02fdedeee$export$4d318981b5a83836; }, function (v) { return $3b244ee02fdedeee$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $3b244ee02fdedeee$export$376a9ed239d6c1c8; }, function (v) { return $3b244ee02fdedeee$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "testKanji", function () { return $3b244ee02fdedeee$export$175f16aef75a4569; }, function (v) { return $3b244ee02fdedeee$export$175f16aef75a4569 = v; });
$parcel$export(module.exports, "testNumeric", function () { return $3b244ee02fdedeee$export$50b7f9bf92c74274; }, function (v) { return $3b244ee02fdedeee$export$50b7f9bf92c74274 = v; });
$parcel$export(module.exports, "testAlphanumeric", function () { return $3b244ee02fdedeee$export$4ba5f52893b4ac97; }, function (v) { return $3b244ee02fdedeee$export$4ba5f52893b4ac97 = v; });
var $3b244ee02fdedeee$export$a4d452c2363c8e12;
var $3b244ee02fdedeee$export$9df7c29d562bab83;
var $3b244ee02fdedeee$export$8f4bf8f7eb581284;
var $3b244ee02fdedeee$export$4d318981b5a83836;
var $3b244ee02fdedeee$export$376a9ed239d6c1c8;
var $3b244ee02fdedeee$export$175f16aef75a4569;
var $3b244ee02fdedeee$export$50b7f9bf92c74274;
var $3b244ee02fdedeee$export$4ba5f52893b4ac97;
const $3b244ee02fdedeee$var$numeric = '[0-9]+';
const $3b244ee02fdedeee$var$alphanumeric = '[A-Z $%*+\\-./:]+';
let $3b244ee02fdedeee$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$3b244ee02fdedeee$var$kanji = $3b244ee02fdedeee$var$kanji.replace(/u/g, '\\u');
const $3b244ee02fdedeee$var$byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + $3b244ee02fdedeee$var$kanji + ')(?:.|[\r\n]))+';
$3b244ee02fdedeee$export$a4d452c2363c8e12 = new RegExp($3b244ee02fdedeee$var$kanji, 'g');
$3b244ee02fdedeee$export$9df7c29d562bab83 = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
$3b244ee02fdedeee$export$8f4bf8f7eb581284 = new RegExp($3b244ee02fdedeee$var$byte, 'g');
$3b244ee02fdedeee$export$4d318981b5a83836 = new RegExp($3b244ee02fdedeee$var$numeric, 'g');
$3b244ee02fdedeee$export$376a9ed239d6c1c8 = new RegExp($3b244ee02fdedeee$var$alphanumeric, 'g');
const $3b244ee02fdedeee$var$TEST_KANJI = new RegExp('^' + $3b244ee02fdedeee$var$kanji + '$');
const $3b244ee02fdedeee$var$TEST_NUMERIC = new RegExp('^' + $3b244ee02fdedeee$var$numeric + '$');
const $3b244ee02fdedeee$var$TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');
$3b244ee02fdedeee$export$175f16aef75a4569 = function testKanji(str) {
    return $3b244ee02fdedeee$var$TEST_KANJI.test(str);
};
$3b244ee02fdedeee$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $3b244ee02fdedeee$var$TEST_NUMERIC.test(str);
};
$3b244ee02fdedeee$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $3b244ee02fdedeee$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("iYeLP", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", function () { return $dcf949b13d145e8d$export$eee5438974ef6f0e; }, function (v) { return $dcf949b13d145e8d$export$eee5438974ef6f0e = v; });
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $dcf949b13d145e8d$export$eee5438974ef6f0e;

var $clK7V = parcelRequire("clK7V");
const $dcf949b13d145e8d$var$G15 = 1335;
const $dcf949b13d145e8d$var$G15_MASK = 21522;
const $dcf949b13d145e8d$var$G15_BCH = $clK7V.getBCHDigit($dcf949b13d145e8d$var$G15);
$dcf949b13d145e8d$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($clK7V.getBCHDigit(d) - $dcf949b13d145e8d$var$G15_BCH >= 0)d ^= $dcf949b13d145e8d$var$G15 << $clK7V.getBCHDigit(d) - $dcf949b13d145e8d$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $dcf949b13d145e8d$var$G15_MASK;
};

});

parcelRegister("2GVj2", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $1f5bf4cc2f6ad782$export$571d59b505e6bb4e; }, function (v) { return $1f5bf4cc2f6ad782$export$571d59b505e6bb4e = v; });
$parcel$export(module.exports, "fromString", function () { return $1f5bf4cc2f6ad782$export$3004f64547af360e; }, function (v) { return $1f5bf4cc2f6ad782$export$3004f64547af360e = v; });
$parcel$export(module.exports, "rawSplit", function () { return $1f5bf4cc2f6ad782$export$89ab1afb9839589b; }, function (v) { return $1f5bf4cc2f6ad782$export$89ab1afb9839589b = v; });
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $1f5bf4cc2f6ad782$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $1f5bf4cc2f6ad782$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $1f5bf4cc2f6ad782$export$89ab1afb9839589b;

var $kVmIx = parcelRequire("kVmIx");

var $kc2ek = parcelRequire("kc2ek");

var $zw5y5 = parcelRequire("zw5y5");

var $5fXol = parcelRequire("5fXol");

var $7ejS7 = parcelRequire("7ejS7");

var $54OfO = parcelRequire("54OfO");

var $clK7V = parcelRequire("clK7V");

var $a2ChO = parcelRequire("a2ChO");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $1f5bf4cc2f6ad782$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $1f5bf4cc2f6ad782$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $1f5bf4cc2f6ad782$var$getSegmentsFromString(dataStr) {
    const numSegs = $1f5bf4cc2f6ad782$var$getSegments($54OfO.NUMERIC, $kVmIx.NUMERIC, dataStr);
    const alphaNumSegs = $1f5bf4cc2f6ad782$var$getSegments($54OfO.ALPHANUMERIC, $kVmIx.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($clK7V.isKanjiModeEnabled()) {
        byteSegs = $1f5bf4cc2f6ad782$var$getSegments($54OfO.BYTE, $kVmIx.BYTE, dataStr);
        kanjiSegs = $1f5bf4cc2f6ad782$var$getSegments($54OfO.KANJI, $kVmIx.KANJI, dataStr);
    } else {
        byteSegs = $1f5bf4cc2f6ad782$var$getSegments($54OfO.BYTE_KANJI, $kVmIx.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $1f5bf4cc2f6ad782$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $kVmIx.NUMERIC:
            return $kc2ek.getBitsLength(length);
        case $kVmIx.ALPHANUMERIC:
            return $zw5y5.getBitsLength(length);
        case $kVmIx.KANJI:
            return $7ejS7.getBitsLength(length);
        case $kVmIx.BYTE:
            return $5fXol.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $1f5bf4cc2f6ad782$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $1f5bf4cc2f6ad782$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $kVmIx.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $kVmIx.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $kVmIx.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $kVmIx.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $kVmIx.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $kVmIx.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $kVmIx.BYTE,
                        length: $1f5bf4cc2f6ad782$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $kVmIx.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $kVmIx.BYTE,
                        length: $1f5bf4cc2f6ad782$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $1f5bf4cc2f6ad782$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        'start'
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = '' + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $1f5bf4cc2f6ad782$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $1f5bf4cc2f6ad782$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $1f5bf4cc2f6ad782$var$getSegmentBitsLength(node.length, node.mode) + 4 + $kVmIx.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $1f5bf4cc2f6ad782$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $kVmIx.getBestModeForData(data);
    mode = $kVmIx.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $kVmIx.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + ' cannot be encoded with mode ' + $kVmIx.toString(mode) + '.\n Suggested mode is: ' + $kVmIx.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $kVmIx.KANJI && !$clK7V.isKanjiModeEnabled()) mode = $kVmIx.BYTE;
    switch(mode){
        case $kVmIx.NUMERIC:
            return new $kc2ek(data);
        case $kVmIx.ALPHANUMERIC:
            return new $zw5y5(data);
        case $kVmIx.KANJI:
            return new $7ejS7(data);
        case $kVmIx.BYTE:
            return new $5fXol(data);
    }
}
$1f5bf4cc2f6ad782$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === 'string') acc.push($1f5bf4cc2f6ad782$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($1f5bf4cc2f6ad782$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$1f5bf4cc2f6ad782$export$3004f64547af360e = function fromString(data, version) {
    const segs = $1f5bf4cc2f6ad782$var$getSegmentsFromString(data, $clK7V.isKanjiModeEnabled());
    const nodes = $1f5bf4cc2f6ad782$var$buildNodes(segs);
    const graph = $1f5bf4cc2f6ad782$var$buildGraph(nodes, version);
    const path = $a2ChO.find_path(graph.map, 'start', 'end');
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $1f5bf4cc2f6ad782$export$571d59b505e6bb4e($1f5bf4cc2f6ad782$var$mergeSegments(optimizedSegs));
};
$1f5bf4cc2f6ad782$export$89ab1afb9839589b = function rawSplit(data) {
    return $1f5bf4cc2f6ad782$export$571d59b505e6bb4e($1f5bf4cc2f6ad782$var$getSegmentsFromString(data, $clK7V.isKanjiModeEnabled()));
};

});
parcelRegister("kc2ek", function(module, exports) {

var $kVmIx = parcelRequire("kVmIx");
function $eb36a879fd7ec1ec$var$NumericData(data) {
    this.mode = $kVmIx.NUMERIC;
    this.data = data.toString();
}
$eb36a879fd7ec1ec$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$eb36a879fd7ec1ec$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$eb36a879fd7ec1ec$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $eb36a879fd7ec1ec$var$NumericData.getBitsLength(this.data.length);
};
$eb36a879fd7ec1ec$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $eb36a879fd7ec1ec$var$NumericData;

});

parcelRegister("zw5y5", function(module, exports) {

var $kVmIx = parcelRequire("kVmIx");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $06ac291b140c21a4$var$ALPHA_NUM_CHARS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $06ac291b140c21a4$var$AlphanumericData(data) {
    this.mode = $kVmIx.ALPHANUMERIC;
    this.data = data;
}
$06ac291b140c21a4$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$06ac291b140c21a4$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$06ac291b140c21a4$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $06ac291b140c21a4$var$AlphanumericData.getBitsLength(this.data.length);
};
$06ac291b140c21a4$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $06ac291b140c21a4$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $06ac291b140c21a4$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($06ac291b140c21a4$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $06ac291b140c21a4$var$AlphanumericData;

});

parcelRegister("5fXol", function(module, exports) {

var $kVmIx = parcelRequire("kVmIx");
function $3d3c6c65b5e76606$var$ByteData(data) {
    this.mode = $kVmIx.BYTE;
    if (typeof data === 'string') this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$3d3c6c65b5e76606$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$3d3c6c65b5e76606$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$3d3c6c65b5e76606$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $3d3c6c65b5e76606$var$ByteData.getBitsLength(this.data.length);
};
$3d3c6c65b5e76606$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $3d3c6c65b5e76606$var$ByteData;

});

parcelRegister("7ejS7", function(module, exports) {

var $kVmIx = parcelRequire("kVmIx");

var $clK7V = parcelRequire("clK7V");
function $5439415d8c94b1a9$var$KanjiData(data) {
    this.mode = $kVmIx.KANJI;
    this.data = data;
}
$5439415d8c94b1a9$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$5439415d8c94b1a9$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$5439415d8c94b1a9$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $5439415d8c94b1a9$var$KanjiData.getBitsLength(this.data.length);
};
$5439415d8c94b1a9$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $clK7V.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error('Invalid SJIS character: ' + this.data[i] + '\n' + 'Make sure your charset is UTF-8');
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $5439415d8c94b1a9$var$KanjiData;

});

parcelRegister("a2ChO", function(module, exports) {
'use strict';
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $74f7ca262adec399$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $74f7ca262adec399$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === 'undefined';
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
            var msg = [
                'Could not find a path from ',
                s,
                ' to ',
                d,
                '.'
            ].join('');
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $74f7ca262adec399$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $74f7ca262adec399$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $74f7ca262adec399$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $74f7ca262adec399$var$dijkstra;

});



parcelRegister("ikXFc", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d59860332100bb5f$export$b3890eb0ae9dca99; }, function (v) { return $d59860332100bb5f$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "renderToDataURL", function () { return $d59860332100bb5f$export$c3e5526bbaf70a25; }, function (v) { return $d59860332100bb5f$export$c3e5526bbaf70a25 = v; });
var $d59860332100bb5f$export$b3890eb0ae9dca99;
var $d59860332100bb5f$export$c3e5526bbaf70a25;

var $7B07m = parcelRequire("7B07m");
function $d59860332100bb5f$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + 'px';
    canvas.style.width = size + 'px';
}
function $d59860332100bb5f$var$getCanvasElement() {
    try {
        return document.createElement('canvas');
    } catch (e) {
        throw new Error('You need to specify a canvas element');
    }
}
$d59860332100bb5f$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $d59860332100bb5f$var$getCanvasElement();
    opts = $7B07m.getOptions(opts);
    const size = $7B07m.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext('2d');
    const image = ctx.createImageData(size, size);
    $7B07m.qrToImageData(image.data, qrData, opts);
    $d59860332100bb5f$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$d59860332100bb5f$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $d59860332100bb5f$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || 'image/png';
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("7B07m", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $587c147e4dae2f4a$export$d2312e68e1f5ad00; }, function (v) { return $587c147e4dae2f4a$export$d2312e68e1f5ad00 = v; });
$parcel$export(module.exports, "getScale", function () { return $587c147e4dae2f4a$export$5cdac61cf538712e; }, function (v) { return $587c147e4dae2f4a$export$5cdac61cf538712e = v; });
$parcel$export(module.exports, "getImageWidth", function () { return $587c147e4dae2f4a$export$c3a1a1f268a8142b; }, function (v) { return $587c147e4dae2f4a$export$c3a1a1f268a8142b = v; });
$parcel$export(module.exports, "qrToImageData", function () { return $587c147e4dae2f4a$export$83136f57c739c5f3; }, function (v) { return $587c147e4dae2f4a$export$83136f57c739c5f3 = v; });
var $587c147e4dae2f4a$export$d2312e68e1f5ad00;
var $587c147e4dae2f4a$export$5cdac61cf538712e;
var $587c147e4dae2f4a$export$c3a1a1f268a8142b;
var $587c147e4dae2f4a$export$83136f57c739c5f3;
function $587c147e4dae2f4a$var$hex2rgba(hex) {
    if (typeof hex === 'number') hex = hex.toString();
    if (typeof hex !== 'string') throw new Error('Color should be defined as hex string');
    let hexCode = hex.slice().replace('#', '').split('');
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error('Invalid hex color: ' + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push('F', 'F');
    const hexValue = parseInt(hexCode.join(''), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
    };
}
$587c147e4dae2f4a$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === 'undefined' || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $587c147e4dae2f4a$var$hex2rgba(options.color.dark || '#000000ff'),
            light: $587c147e4dae2f4a$var$hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$587c147e4dae2f4a$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$587c147e4dae2f4a$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $587c147e4dae2f4a$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$587c147e4dae2f4a$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $587c147e4dae2f4a$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("8l9CX", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $6127c0b0196fc6f2$export$b3890eb0ae9dca99; }, function (v) { return $6127c0b0196fc6f2$export$b3890eb0ae9dca99 = v; });
var $6127c0b0196fc6f2$export$b3890eb0ae9dca99;

var $7B07m = parcelRequire("7B07m");
function $6127c0b0196fc6f2$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $6127c0b0196fc6f2$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== 'undefined') str += ' ' + y;
    return str;
}
function $6127c0b0196fc6f2$var$qrToPath(data, size, margin) {
    let path = '';
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $6127c0b0196fc6f2$var$svgCmd('M', col + margin, 0.5 + row + margin) : $6127c0b0196fc6f2$var$svgCmd('m', moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $6127c0b0196fc6f2$var$svgCmd('h', lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$6127c0b0196fc6f2$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $7B07m.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? '' : '<path ' + $6127c0b0196fc6f2$var$getColorAttrib(opts.color.light, 'fill') + ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';
    const path = '<path ' + $6127c0b0196fc6f2$var$getColorAttrib(opts.color.dark, 'stroke') + ' d="' + $6127c0b0196fc6f2$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + ' ' + qrcodesize + '"';
    const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';
    if (typeof cb === 'function') cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("1AauR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $12714badf2bf3ccc$var$_dec, $12714badf2bf3ccc$var$_class;
function $12714badf2bf3ccc$var$_defineProperty(e, r, t) {
    return (r = $12714badf2bf3ccc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12714badf2bf3ccc$var$_toPropertyKey(t) {
    var i = $12714badf2bf3ccc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12714badf2bf3ccc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $12714badf2bf3ccc$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $12714badf2bf3ccc$var$Header = module.exports.default = ($12714badf2bf3ccc$var$_dec = (0, $bfbrY.debounce)(100), $12714badf2bf3ccc$var$_class = class Header {
    constructor(){
        /**
     * @type {LiveElement}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "mainHeader", new $bFxq0.LiveElement('.main-header'));
        /**
     * @type {LiveElement}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "burger", new $bFxq0.LiveElement('.burger'));
        /**
     * @type {LiveElement}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "burgerLabel", new $bFxq0.LiveElement('.burger__label'));
        /**
     * @type {Number}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "lastScrollPosition", 0);
        /**
     * @type {LiveNodeList}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "searchButtons", new $bFxq0.LiveNodeList('.main-header-search-button'));
        /**
     * @type {LiveElement}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "search", new $bFxq0.LiveElement('.main-header-search'));
        /**
     * @type {LiveElement}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "searchClose", new $bFxq0.LiveElement('.main-header-search__close'));
        /**
     * @type {LiveElement}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "searchInput", new $bFxq0.LiveElement('.search-form-input'));
        /**
     * @type {LiveNodeList}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "mobileNavLinks", new $bFxq0.LiveNodeList('.main-nav__list-item--subnav .main-nav__list-link, .sub-nav-list__item--subnav .sub-nav-list__link'));
        /**
     * @type {LiveNodeList}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "mobileNavBackLinks", new $bFxq0.LiveNodeList('.sub-nav-list__back, .grand-child-list__back'));
        /**
     * @type {LiveNodeList}
     */ $12714badf2bf3ccc$var$_defineProperty(this, "subNavs", new $bFxq0.LiveNodeList('.sub-nav-list'));
        this.registerListeners();
    }
    registerListeners() {
        this.burger.addEventListener('click', this.toggleNav);
        this.searchButtons.addEventListener('click', this.openSearch);
        this.searchClose.addEventListener('click', this.closeSearch);
        this.toggleScrollHeader();
        this.mobileNavLinks.addEventListener('click', this.openSubNav);
        this.mobileNavBackLinks.addEventListener('click', this.closeSubNav);
        window.addEventListener('scroll', ()=>{
            this.toggleScrollHeader();
        }, {
            passive: true
        });
    }
    toggleNav(e) {
        e.preventDefault();
        if (document.body.classList.contains('nav-open')) this.closeNav();
        else this.openNav();
    }
    openNav() {
        document.body.classList.add('nav-open');
        document.body.classList.add('lock-scroll');
        this.burger.item.setAttribute('aria-expanded', 'true');
        this.changeLabelText('Close menu');
    }
    /**
   *
   */ closeNav() {
        document.body.classList.remove('nav-open');
        document.body.classList.remove('lock-scroll');
        this.burger.item.setAttribute('aria-expanded', 'false');
        this.changeLabelText('Open menu');
        this.subNavs.forEach((subNav)=>{
            subNav.setAttribute('aria-hidden', 'true');
        });
    }
    /**
   *
   */ changeLabelText(text = 'Open menu') {
        this.burgerLabel.item.innerHTML = text;
        this.burger.item.title = this.burgerLabel.item.innerText;
    }
    /**
   *
   */ async toggleScrollHeader() {
        requestAnimationFrame((t)=>{
            const y = this.lastScrollPosition;
            if (window.scrollY > 127) {
                const firstTransition = !this.mainHeader.item.classList.contains('main-header--sticky');
                if (firstTransition) this.mainHeader.item.style.transition = 'none';
                this.mainHeader.item.classList.add('main-header--sticky');
                if (firstTransition) setTimeout(()=>{
                    this.mainHeader.item.style.transition = null;
                }, 10);
            } else if (window.scrollY < 127) this.mainHeader.item.classList.remove('main-header--sticky');
            const hide = window.scrollY >= y && window.scrollY > 127;
            this.mainHeader.item.setAttribute('aria-hidden', hide.toString());
            this.lastScrollPosition = window.scrollY;
        });
    }
    openSearch(e) {
        e.preventDefault();
        this.search.item.classList.add('main-header-search--active');
        this.mainHeader.item.classList.add('main-header--search-active');
        this.searchInput.item.focus();
    }
    closeSearch(e) {
        e.preventDefault();
        this.searchClose.item.blur();
        this.search.item.classList.remove('main-header-search--active');
        this.mainHeader.item.classList.remove('main-header--search-active');
    }
    openSubNav(e) {
        if (window.matchMedia('(min-width: 63.75em)').matches) return true;
        e.preventDefault();
        const link = e.currentTarget || e.target;
        const target = link.getAttribute('aria-controls');
        const element = document.getElementById(target);
        element?.setAttribute('aria-hidden', 'false');
    }
    closeSubNav(e) {
        if (window.matchMedia('(min-width: 63.75em)').matches) return true;
        e.preventDefault();
        const link = e.currentTarget || e.target;
        const target = link.getAttribute('aria-controls');
        const element = document.getElementById(target);
        element?.setAttribute('aria-hidden', 'true');
    }
}, $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "registerListeners"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "toggleNav", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "toggleNav"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "openNav", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "openNav"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "closeNav", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "closeNav"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "toggleScrollHeader", [
    $bfbrY.bind,
    $12714badf2bf3ccc$var$_dec
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "toggleScrollHeader"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "openSearch", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "openSearch"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "closeSearch", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "closeSearch"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_applyDecoratedDescriptor($12714badf2bf3ccc$var$_class.prototype, "openSubNav", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($12714badf2bf3ccc$var$_class.prototype, "openSubNav"), $12714badf2bf3ccc$var$_class.prototype), $12714badf2bf3ccc$var$_class);

});

parcelRegister("fCHpm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $b5fc138a03f39af2$var$_flickityFade = $b5fc138a03f39af2$var$_interopRequireDefault((parcelRequire("5QHHp")));
var $b5fc138a03f39af2$var$_class;
function $b5fc138a03f39af2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $b5fc138a03f39af2$var$_defineProperty(e, r, t) {
    return (r = $b5fc138a03f39af2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b5fc138a03f39af2$var$_toPropertyKey(t) {
    var i = $b5fc138a03f39af2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b5fc138a03f39af2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b5fc138a03f39af2$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $b5fc138a03f39af2$var$HeroBanner = module.exports.default = ($b5fc138a03f39af2$var$_class = class HeroBanner {
    constructor(){
        /**
     * @type {LiveElement}
     */ $b5fc138a03f39af2$var$_defineProperty(this, "heroBanner", new $bFxq0.LiveElement('.hero-banner'));
        this.registerListeners();
    }
    registerListeners() {
        if (!this.heroBanner.item) return;
        this.setupProductFlickitySlideshow();
        this.heroBanner.on('update', this.setupProductFlickitySlideshow);
        document.addEventListener('shopify:section:load', this.setupProductFlickitySlideshow);
    }
    setupProductFlickitySlideshow() {
        const heroBanner = this.heroBanner.item.querySelector('.hero-banner__slides');
        var flkty = new $b5fc138a03f39af2$var$_flickityFade.default(heroBanner, {
            autoPlay: 5000,
            cellAlign: 'left',
            draggable: false,
            fade: true,
            pageDots: true,
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            wrapAround: true
        });
    }
}, $b5fc138a03f39af2$var$_applyDecoratedDescriptor($b5fc138a03f39af2$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($b5fc138a03f39af2$var$_class.prototype, "registerListeners"), $b5fc138a03f39af2$var$_class.prototype), $b5fc138a03f39af2$var$_applyDecoratedDescriptor($b5fc138a03f39af2$var$_class.prototype, "setupProductFlickitySlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($b5fc138a03f39af2$var$_class.prototype, "setupProductFlickitySlideshow"), $b5fc138a03f39af2$var$_class.prototype), $b5fc138a03f39af2$var$_class);

});
parcelRegister("5QHHp", function(module, exports) {


/**
 * Flickity fade v2.0.0
 * Fade between Flickity slides
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("iPy8b")), (parcelRequire("2L9JE")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // ---- Slide ---- //
    let Slide = Flickity.Slide;
    Slide.prototype.renderFadePosition = function() {};
    Slide.prototype.setOpacity = function(alpha) {
        this.cells.forEach((cell)=>{
            cell.element.style.opacity = alpha;
        });
    };
    // ---- Flickity ---- //
    Flickity.create.fade = function() {
        this.fadeIndex = this.selectedIndex;
        this.prevSelectedIndex = this.selectedIndex;
        this.on('select', this.onSelectFade);
        this.on('dragEnd', this.onDragEndFade);
        this.on('settle', this.onSettleFade);
        this.on('activate', this.onActivateFade);
        this.on('deactivate', this.onDeactivateFade);
    };
    let proto = Flickity.prototype;
    let updateSlides = proto.updateSlides;
    proto.updateSlides = function() {
        updateSlides.apply(this, arguments);
        if (!this.options.fade) return;
        this.slides.forEach((slide, i)=>{
            // position cells at selected target
            let slideTargetX = slide.target - slide.x;
            let firstCellX = slide.cells[0].x;
            slide.cells.forEach((cell)=>{
                let targetX = cell.x - firstCellX - slideTargetX;
                this._renderCellPosition(cell, targetX);
            });
            // set initial opacity
            let alpha = i === this.selectedIndex ? 1 : 0;
            slide.setOpacity(alpha);
        });
    };
    /* ---- events ---- */ proto.onSelectFade = function() {
        // in case of resize, keep fadeIndex within current count
        this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
        this.prevSelectedIndex = this.selectedIndex;
    };
    proto.onSettleFade = function() {
        delete this.didDragEnd;
        if (!this.options.fade) return;
        // set full and 0 opacity on selected & faded slides
        this.selectedSlide.setOpacity(1);
        let fadedSlide = this.slides[this.fadeIndex];
        if (fadedSlide && this.fadeIndex !== this.selectedIndex) this.slides[this.fadeIndex].setOpacity(0);
    };
    proto.onDragEndFade = function() {
        // set flag
        this.didDragEnd = true;
    };
    proto.onActivateFade = function() {
        if (this.options.fade) this.element.classList.add('is-fade');
    };
    proto.onDeactivateFade = function() {
        if (!this.options.fade) return;
        this.element.classList.remove('is-fade');
        // reset opacity
        this.slides.forEach((slide)=>{
            slide.setOpacity('');
        });
    };
    /* ---- position & fading ---- */ let positionSlider = proto.positionSlider;
    proto.positionSlider = function() {
        if (!this.options.fade) {
            positionSlider.apply(this, arguments);
            return;
        }
        this.fadeSlides();
        this.dispatchScrollEvent();
    };
    let positionSliderAtSelected = proto.positionSliderAtSelected;
    proto.positionSliderAtSelected = function() {
        if (this.options.fade) // position fade slider at origin
        this.setTranslateX(0);
        positionSliderAtSelected.apply(this, arguments);
    };
    proto.fadeSlides = function() {
        if (this.slides.length < 2) return;
        // get slides to fade-in & fade-out
        let indexes = this.getFadeIndexes();
        let fadeSlideA = this.slides[indexes.a];
        let fadeSlideB = this.slides[indexes.b];
        let distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
        let progress = this.wrapDifference(fadeSlideA.target, -this.x);
        progress /= distance;
        fadeSlideA.setOpacity(1 - progress);
        fadeSlideB.setOpacity(progress);
        // hide previous slide
        let fadeHideIndex = indexes.a;
        if (this.isDragging) fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
        let isNewHideIndex = this.fadeHideIndex !== undefined && this.fadeHideIndex !== fadeHideIndex && this.fadeHideIndex !== indexes.a && this.fadeHideIndex !== indexes.b;
        if (isNewHideIndex) // new fadeHideSlide set, hide previous
        this.slides[this.fadeHideIndex].setOpacity(0);
        this.fadeHideIndex = fadeHideIndex;
    };
    proto.getFadeIndexes = function() {
        if (!this.isDragging && !this.didDragEnd) return {
            a: this.fadeIndex,
            b: this.selectedIndex
        };
        if (this.options.wrapAround) return this.getFadeDragWrapIndexes();
        else return this.getFadeDragLimitIndexes();
    };
    proto.getFadeDragWrapIndexes = function() {
        let distances = this.slides.map(function(slide, i) {
            return this.getSlideDistance(-this.x, i);
        }, this);
        let absDistances = distances.map(function(distance) {
            return Math.abs(distance);
        });
        let minDistance = Math.min(...absDistances);
        let closestIndex = absDistances.indexOf(minDistance);
        let distance = distances[closestIndex];
        let len = this.slides.length;
        let delta = distance >= 0 ? 1 : -1;
        return {
            a: closestIndex,
            b: utils.modulo(closestIndex + delta, len)
        };
    };
    proto.getFadeDragLimitIndexes = function() {
        // calculate closest previous slide
        let dragIndex = 0;
        for(let i = 0; i < this.slides.length - 1; i++){
            let slide = this.slides[i];
            if (-this.x < slide.target) break;
            dragIndex = i;
        }
        return {
            a: dragIndex,
            b: dragIndex + 1
        };
    };
    proto.wrapDifference = function(a, b) {
        let diff = b - a;
        if (!this.options.wrapAround) return diff;
        let diffPlus = diff + this.slideableWidth;
        let diffMinus = diff - this.slideableWidth;
        if (Math.abs(diffPlus) < Math.abs(diff)) diff = diffPlus;
        if (Math.abs(diffMinus) < Math.abs(diff)) diff = diffMinus;
        return diff;
    };
    // ---- wrapAround ---- //
    let _updateWrapShiftCells = proto._updateWrapShiftCells;
    proto._updateWrapShiftCells = function() {
        if (this.options.fade) // update isWrapping
        this.isWrapping = this.getIsWrapping();
        else _updateWrapShiftCells.apply(this, arguments);
    };
    let shiftWrapCells = proto.shiftWrapCells;
    proto.shiftWrapCells = function() {
        if (!this.options.fade) shiftWrapCells.apply(this, arguments);
    };
    return Flickity;
});

});
parcelRegister("iPy8b", function(module, exports) {
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if (module.exports) {
    const Flickity = (parcelRequire("fixlF"));
    (parcelRequire("9I5P5"));
    (parcelRequire("fhrzP"));
    (parcelRequire("bE0vI"));
    (parcelRequire("6r4oe"));
    (parcelRequire("hcSXq"));
    (parcelRequire("kX4su"));
    (parcelRequire("gOEtF"));
    module.exports = Flickity;
}

});
parcelRegister("fixlF", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("kmx2F")), (parcelRequire("l6dwe")), (parcelRequire("2L9JE")), (parcelRequire("7mI7p")), (parcelRequire("edS4e")), (parcelRequire("ct5VN")));
    else {
        // browser global
        let _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    const { getComputedStyle: getComputedStyle, console: console } = window1;
    let { jQuery: jQuery } = window1;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    let GUID = 0;
    // internal store of all Flickity intances
    let instances = {};
    function Flickity(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = {
            ...this.constructor.defaults
        };
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    let proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        let { resize: resize, watchCSS: watchCSS, rightToLeft: rightToLeft } = this.options;
        // add id for Flickity.data
        let id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
        this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(let eventName in this.options.on){
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(let method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        this.slider.append(...cellElems);
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        let slider = document.createElement('div');
        slider.className = 'flickity-slider';
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        let cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map((cellElem)=>new Cell(cellElem));
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach((cell)=>{
            cell.x = cellX;
            this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        let sideOffset = this.options.rightToLeft ? -1 : 1;
        let renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        let positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = `translateX( ${positionValue} )`;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach((cell)=>cell.getSize());
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        let { beginMargin: beginMargin, endMargin: endMargin } = this;
        let slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        let canCellFit = this._getCanCellFit();
        this.cells.forEach((cell, i)=>{
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        let { groupCells: groupCells } = this.options;
        if (!groupCells) return ()=>false;
        if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return (i)=>i % number !== 0;
        }
        // default, group by width of slide
        let percent = 1;
        // parse '75%
        let percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        let groupWidth = (this.size.innerWidth + 1) * percent;
        return (i, slideWidth)=>slideWidth <= groupWidth;
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    let cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        let { cellAlign: cellAlign, rightToLeft: rightToLeft } = this.options;
        let shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${height}px`;
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let beforeGapX = this.cursorPosition;
        let lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        let afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        let { wrapAround: wrapAround } = this.options;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== 'fill') return true;
        // check that slides can fit
        let gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        // check that content width - shifting cell is bigger than viewport width
        for (let cell of this.cells){
            if (cell.size.outerWidth > gapWidth) return false;
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while(gapX > 0){
            let cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach((slide)=>{
            slide.target = contentWidth * this.cellAlign;
        });
        else {
            // contain to bounds
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide)=>{
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        let emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    const unidraggerEvents = [
        'dragStart',
        'dragMove',
        'dragEnd',
        'pointerDown',
        'pointerMove',
        'pointerEnd',
        'staticClick'
    ];
    let _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === 'staticClick') {
            // add cellElem and cellIndex args to staticClick
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        let isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
        let event = args.shift(0);
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        const { selectedIndex: selectedIndex, slideableWidth: slideableWidth, slides: { length: length } } = this;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            let wrapIndex = utils.modulo(index, length);
            // go to shortest
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) return;
        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        let cellSlide = this.slides.find((slide)=>slide.cells.includes(cell));
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for (let cell of this.cells){
            if (cell.element === elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        return elems.map((elem)=>this.getCell(elem)).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        let closest = elem.closest('.flickity-slider > *');
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        let len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        let cellElems = [];
        for(let i = index - adjCount; i <= index + adjCount; i++){
            let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        let isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        let afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes('flickity')) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        let { activeElement: activeElement } = document;
        let handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        let isFocused = this.focusableElems.some((elem)=>activeElement === elem);
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this[leftMethod]();
        },
        ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach((cell)=>cell.destroy());
        this.viewport.remove();
        // move child elements back into element
        this.element.append(...this.slider.children);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, 'flickity');
    let { jQueryBridget: jQueryBridget } = window1;
    if (jQuery && jQueryBridget) jQueryBridget('flickity', Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("kmx2F", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("l6dwe", function(module, exports) {
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    let measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    let measurementsLength = measurements.length;
    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach((measurement)=>{
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        let isElement = elem && typeof elem == 'object' && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        measurements.forEach((measurement)=>{
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("2L9JE", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener('DOMContentLoaded', onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = 'data-' + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("7mI7p", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("l6dwe")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(getSize) {
    const cellClassName = 'flickity-cell';
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    let proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("edS4e", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != 'undefined' ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    let proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach((cell)=>cell.select());
    };
    proto.unselect = function() {
        this.cells.forEach((cell)=>cell.unselect());
    };
    proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    return Slide;
});

});

parcelRegister("ct5VN", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("2L9JE")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    let proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(()=>this.animate());
    };
    proto.positionSlider = function() {
        let x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
    };
    proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell)=>{
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell)=>this._wrapShiftCell(cell, 0));
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("9I5P5", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("fixlF")), (parcelRequire("4gNry")), (parcelRequire("2L9JE")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    let proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = '';
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        this.on('pointerDown', this.handlePointerDown);
        this.on('pointerUp', this.handlePointerUp);
        this.on('pointerDown', this.handlePointerDone);
        this.on('dragStart', this.handleDragStart);
        this.on('dragMove', this.handleDragMove);
        this.on('dragEnd', this.handleDragEnd);
        this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle('is-draggable', this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        let isTouchStart = event.type === 'touchstart';
        let isTouchPointer = event.pointerType === 'touch';
        let isFocusNode = event.target.matches('input, textarea, select');
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        let dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let { freeScroll: freeScroll } = this.options;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        (dist, minDist)=>dist <= minDist : (dist, minDist)=>dist < minDist;
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("4gNry", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("kmx2F")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    let startEvent, activeEvents;
    if ('ontouchstart' in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        activeEvents = [
            'touchmove',
            'touchend',
            'touchcancel'
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = 'pointerdown';
        activeEvents = [
            'pointermove',
            'pointerup',
            'pointercancel'
        ];
    } else {
        // mouse events
        startEvent = 'mousedown';
        activeEvents = [
            'mousemove',
            'mouseup'
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = 'none';
    proto.bindHandles = function() {
        this._bindHandles('addEventListener', this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles('removeEventListener', '');
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle)=>{
            handle[bindMethod](startEvent, this);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.addEventListener(eventName, this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.removeEventListener(eventName, this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches)if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    const cursorNodes = [
        'TEXTAREA',
        'INPUT',
        'SELECT',
        'OPTION'
    ];
    // input types that do not have text fields
    const clickTypes = [
        'radio',
        'checkbox',
        'button',
        'submit',
        'image',
        'file'
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer('pointerMove', event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch('pointerMove', event);
    };
    proto.pointerMove = function(event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer('pointerUp', event);
    };
    proto.ontouchend = function(event) {
        this.withTouch('pointerUp', event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(()=>delete this.isPreventingClicks);
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent('pointerDone');
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer('pointerCancel', event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch('pointerCancel', event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        let isMouseup = event.type === 'mouseup';
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(()=>{
                delete this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});


parcelRegister("fhrzP", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("fixlF")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    const svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === 'previous';
        this.isLeft = direction === 'left';
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        let element = this.element = document.createElement('button');
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? 'Previous' : 'Next';
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        element.setAttribute('aria-label', label);
        // init as disabled
        this.disable();
        // create arrow
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        // add title #1189
        let title = document.createElementNS(svgURI, 'title');
        title.append(label);
        // add path
        let path = document.createElementNS(svgURI, 'path');
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180)');
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        let { x0: x0, x1: x1, x2: x2, x3: x3, y1: y1, y2: y2 } = shape;
        // create movement string
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute('disabled');
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute('disabled', true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft: rightToLeft, arrowShape: arrowShape } = this.options;
        let prevDirection = rightToLeft ? 'right' : 'left';
        let nextDirection = rightToLeft ? 'left' : 'right';
        this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
        this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = ()=>{
            this.uiChange();
            this.previous();
        };
        this.handleNextButtonClick = ()=>{
            this.uiChange();
            this.next();
        };
        this.on('activate', this.activatePrevNextButtons);
        this.on('select', this.updatePrevNextButtons);
    };
    let proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? 'enable' : 'disable']();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("bE0vI", function(module, exports) {


// page dots
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("fixlF")), (parcelRequire("2L9JE")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement('div');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        let delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i)=>{
            let dot = document.createElement('button');
            dot.setAttribute('type', 'button');
            let num = i + 1 + this.dots.length;
            dot.className = 'flickity-page-dot';
            dot.textContent = `View slide ${num}`;
            return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach((dot)=>dot.remove());
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove('is-selected');
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add('is-selected');
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    let proto = Flickity.prototype;
    proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot)=>{
            utils.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("6r4oe", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("fixlF")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state !== 'playing') return;
        // default to 3 seconds
        let time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(()=>{
            this.onTick();
            this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        this.player = new Player(this.options.autoPlay, ()=>{
            this.next(true);
        });
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    let proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("hcSXq", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("fixlF")), (parcelRequire("2L9JE")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell)=>fragment.appendChild(cell.element));
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    let proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach((cell)=>{
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        let cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("kX4su", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("fixlF")), (parcelRequire("2L9JE")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    const lazyAttr = 'data-flickity-lazyload';
    const lazySrcAttr = `${lazyAttr}-src`;
    const lazySrcsetAttr = `${lazyAttr}-srcset`;
    const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
    Flickity.create.lazyLoad = function() {
        this.on('select', this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    let proto = Flickity.prototype;
    proto.lazyLoad = function() {
        let { lazyLoad: lazyLoad } = this.options;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img)=>new LazyLoader(img, this.handleLazyLoadComplete));
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches('img')) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return [
            ...cellElem.querySelectorAll(imgSelector)
        ];
    }
    proto.onLazyLoadComplete = function(img, event) {
        let cell = this.getParentCell(img);
        let cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        let mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("gOEtF", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("fixlF")), (parcelRequire("kiFLb")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        let onImagesLoadedProgress = (instance, image)=>{
            let cell = this.getParentCell(image.img);
            this.cellSizeChange(cell && cell.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("kiFLb", function(module, exports) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("kmx2F")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});





parcelRegister("6iqGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49591f6c35eb4d7c$var$_liveNodeList = $49591f6c35eb4d7c$var$_interopRequireDefault((parcelRequire("bFxq0")));

var $bfbrY = parcelRequire("bfbrY");

var $99Uv1 = parcelRequire("99Uv1");
var $49591f6c35eb4d7c$var$_class;
function $49591f6c35eb4d7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $49591f6c35eb4d7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $49591f6c35eb4d7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $49591f6c35eb4d7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $49591f6c35eb4d7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $49591f6c35eb4d7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $49591f6c35eb4d7c$var$_defineProperty(e, r, t) {
    return (r = $49591f6c35eb4d7c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $49591f6c35eb4d7c$var$_toPropertyKey(t) {
    var i = $49591f6c35eb4d7c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $49591f6c35eb4d7c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $49591f6c35eb4d7c$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
/**
 * Creates an Intersection observer to lazy load images
 * matching a specific selector. Images matching selector
 * must have either an `data-src` or `data-srcset` attribute.
 * After the image is successfully loaded, both `data-src` and
 * `data-srcset` attributes are removed, allowing before and
 * after states to be styled in CSS
 *
 * @type {ImageLazyLoader}
 */ let $49591f6c35eb4d7c$var$ImageLazyLoader = module.exports.default = ($49591f6c35eb4d7c$var$_class = class ImageLazyLoader {
    /**
   * Create the lazy loader instance
   *
   * @param {string} selector
   * @param {object} config
   */ constructor(selector, config = {}){
        /**
     * The default config for lazy loader instances
     *
     * @type {object}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "config", {
            // If the image gets within 50px in the Y axis, start the download.
            rootMargin: '100px 0px',
            threshold: [
                0,
                0.25,
                0.5,
                0.75,
                1
            ],
            trackVisibility: true,
            delay: 100
        });
        /**
     * @type {string}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "containerSelector", '.lazy-load-container');
        /**
     * The selector used to gather images
     *
     * @type {String}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "selector", null);
        /**
     * The node list in which we'll store all the images
     * to be lazy loaded
     *
     * @type {NodeList}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "images", null);
        /**
     * A node list containing lazy load containers
     *
     * @type {NodeList}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "containers", null);
        /**
     * The IntersectionObserver instance powering this lazy loader
     *
     * @type {IntersectionObserver}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "observer", null);
        /**
     * @type {boolean}
     */ $49591f6c35eb4d7c$var$_defineProperty(this, "paused", false);
        this.selector = selector;
        // Merge optional config with the default
        this.config = $49591f6c35eb4d7c$var$_objectSpread($49591f6c35eb4d7c$var$_objectSpread({}, this.config), config);
        this.collect();
        this.images.forEach((image)=>{
            if ((0, $99Uv1.isInViewport)(image)) this.load(image);
        });
        // Create the IntersectionObserver instance and observe each
        // of the images and containers matching our selector
        this.observer = new IntersectionObserver(this.intersect, this.config);
        this.observe();
    }
    /**
   * Collect images and containers on the page to be lazy loaded
   */ collect() {
        // Select all the images to be lazy loaded
        this.images = new $49591f6c35eb4d7c$var$_liveNodeList.default(this.selector);
        this.containers = new $49591f6c35eb4d7c$var$_liveNodeList.default(this.containerSelector);
        this.images.on('update', (newItems, oldItems)=>{
            oldItems.forEach((item)=>this.observer.unobserve(item));
            newItems.forEach((item)=>this.observer.observe(item));
        });
        this.containers.on('update', (newItems, oldItems)=>{
            oldItems.forEach((item)=>this.observer.unobserve(item));
            newItems.forEach((item)=>this.observer.observe(item));
        });
    }
    /**
   * Begin observation for each of the collected elements
   */ observe() {
        this.images.forEach((image)=>this.observer.observe(image));
        this.containers.forEach((container)=>this.observer.observe(container));
    }
    /**
   * Begin observation for each of the collected elements
   */ unobserve() {
        this.images.forEach((image)=>this.observer.unobserve(image));
        this.containers.forEach((container)=>this.observer.unobserve(container));
    }
    /**
   * Handle a list of entries when an intersection occurs
   *
   * @param {Array} entries
   */ intersect(entries) {
        if (this.paused) return;
        // Loop through the entries
        entries.forEach((entry)=>{
            // Are we in viewport?
            if (entry.isIntersecting && entry.intersectionRatio > 0) {
                // If the entry is a container, load all the images within it
                if (entry.target.matches(this.containerSelector)) {
                    Promise.all(Array.prototype.map.call(entry.target.querySelectorAll(this.selector), this.load)).then(()=>{
                        this.observer.unobserve(entry.target);
                    });
                    return;
                }
                this.load(entry.target).then(()=>{
                    // Stop watching and load the image
                    this.observer.unobserve(entry.target);
                }).catch((_)=>{
                    this.observer.unobserve(entry.target);
                });
            }
        });
    }
    /**
   * Load an image
   *
   * @param {HTMLImageElement} image
   */ load(image) {
        return new Promise((resolve, reject)=>{
            // Remove the data-src and data-srcset attributes when
            // the image has successfully loaded
            image.addEventListener('load', ()=>{
                requestAnimationFrame(()=>{
                    image.removeAttribute('data-lazy-load-src');
                    image.removeAttribute('data-lazy-load-srcset');
                });
                // If image is within a slideshow, trigger a transition to ensure that
                // the slide is in the correct position. This is necessary because until
                // the image is loaded the slide may be of an incorrect size
                const slideshow = image.closest('.slideshow');
                if (slideshow && slideshow.magicRoundabout) slideshow.magicRoundabout.transition();
                resolve(true);
            });
            image.addEventListener('error', (e)=>{
                reject(e);
            });
            // Set the srcset or src attribute on the image.
            // We prefer srcset if it is defined
            if ('srcset' in image && 'lazyLoadSrcset' in image.dataset) image.srcset = image.dataset.lazyLoadSrcset;
            else if ('lazyLoadSrc' in image.dataset) image.src = image.dataset.lazyLoadSrc;
        });
    }
    /**
   * Unobserve the current list of images and reselect all images on the page
   *
   * @return {void}
   */ refreshImages() {
        this.unobserve();
        this.collect();
        this.observe();
    }
    /**
   * @return {void}
   */ pause() {
        this.paused = true;
    }
    /**
   * @return {void}
   */ unpause() {
        this.paused = false;
    }
}, $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "collect", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "collect"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "observe", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "observe"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "unobserve", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "unobserve"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "intersect", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "intersect"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "load", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "load"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "refreshImages", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "refreshImages"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "pause", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "pause"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_applyDecoratedDescriptor($49591f6c35eb4d7c$var$_class.prototype, "unpause", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($49591f6c35eb4d7c$var$_class.prototype, "unpause"), $49591f6c35eb4d7c$var$_class.prototype), $49591f6c35eb4d7c$var$_class);

});

parcelRegister("69ZXl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $47c3a48f52c3ecec$var$_class;
function $47c3a48f52c3ecec$var$_defineProperty(e, r, t) {
    return (r = $47c3a48f52c3ecec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $47c3a48f52c3ecec$var$_toPropertyKey(t) {
    var i = $47c3a48f52c3ecec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $47c3a48f52c3ecec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $47c3a48f52c3ecec$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $47c3a48f52c3ecec$var$Instagram = module.exports.default = ($47c3a48f52c3ecec$var$_class = class Instagram {
    /**
   *
   */ constructor(){
        $47c3a48f52c3ecec$var$_defineProperty(this, "containers", new $bFxq0.LiveNodeList('.juicer-feed'));
        if (this.containers.length === 0) return;
        this.registerListeners();
    }
    registerListeners() {
        this.containers.forEach(this.getPosts);
    }
    /**
   *
   */ async getPosts(container) {
        const FEED_ID = container.dataset.feedId;
        const FEED_LIMIT = container.dataset.feedLimit;
        const FEED_URL = 'https://www.juicer.io/api/feeds/' + FEED_ID + '?page=1&per=' + FEED_LIMIT;
        const response = await fetch(FEED_URL);
        const data = await response.json();
        data.posts.items.forEach((postData)=>{
            container.append(this.template(postData));
        });
    }
    /**
   * @param {object} postData
   *
   * @returns {HTMLElement}
   */ template(postData) {
        const item = document.createElement('li');
        item.classList.add('juicer-feed__post', 'juicer-post');
        item.innerHTML = `
      <a href="${postData.full_url}" class="juicer-post__link" target="_blank" rel="noopener">
        <div class="juicer-post__image">
          <img data-lazy-load-src="${postData.image}" />
        </div>
      </a>
    `;
        return item;
    }
}, $47c3a48f52c3ecec$var$_applyDecoratedDescriptor($47c3a48f52c3ecec$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($47c3a48f52c3ecec$var$_class.prototype, "registerListeners"), $47c3a48f52c3ecec$var$_class.prototype), $47c3a48f52c3ecec$var$_applyDecoratedDescriptor($47c3a48f52c3ecec$var$_class.prototype, "getPosts", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($47c3a48f52c3ecec$var$_class.prototype, "getPosts"), $47c3a48f52c3ecec$var$_class.prototype), $47c3a48f52c3ecec$var$_class);

});

parcelRegister("1DG8D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hiddenPropertyLabels = module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $if6TQ = parcelRequire("if6TQ");

var $jld5k = parcelRequire("jld5k");

var $99Uv1 = parcelRequire("99Uv1");

var $4RPMd = parcelRequire("4RPMd");

var $dreuv = parcelRequire("dreuv");

var $29n7W = parcelRequire("29n7W");

var $hPUPb = parcelRequire("hPUPb");

var $9gI3j = parcelRequire("9gI3j");
parcelRequire("gqLTF");

var $etbRz = parcelRequire("etbRz");
var $131a1ec47f227bae$var$_class;
function $131a1ec47f227bae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $131a1ec47f227bae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $131a1ec47f227bae$var$ownKeys(Object(t), !0).forEach(function(r) {
            $131a1ec47f227bae$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $131a1ec47f227bae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $131a1ec47f227bae$var$_defineProperty(e, r, t) {
    return (r = $131a1ec47f227bae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $131a1ec47f227bae$var$_toPropertyKey(t) {
    var i = $131a1ec47f227bae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $131a1ec47f227bae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $131a1ec47f227bae$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
const $131a1ec47f227bae$var$DYNAMIC_SECTIONS = [
    'product-upsells'
];
const $131a1ec47f227bae$var$hiddenPropertyLabels = module.exports.hiddenPropertyLabels = [
    'Lead time'
];
let $131a1ec47f227bae$var$MiniCart = module.exports.default = ($131a1ec47f227bae$var$_class = class MiniCart {
    constructor(){
        /**
     * @type {object}
     */ $131a1ec47f227bae$var$_defineProperty(this, "cart", null);
        /**
     * @type {LiveElement}
     */ $131a1ec47f227bae$var$_defineProperty(this, "minicart", new $bFxq0.LiveElement('.mini-cart'));
        /**
     * @type {LiveElement}
     */ $131a1ec47f227bae$var$_defineProperty(this, "minicartInner", new $bFxq0.LiveElement('.mini-cart__inner'));
        /**
     * @type {LiveElement}
     */ $131a1ec47f227bae$var$_defineProperty(this, "minicartItemContainer", new $bFxq0.LiveElement('.mini-cart__items'));
        /**
     * @type {LiveElement}
     */ $131a1ec47f227bae$var$_defineProperty(this, "minicartEmptyState", new $bFxq0.LiveElement('.mini-cart__empty'));
        /**
     * @type {LiveElement}
     */ $131a1ec47f227bae$var$_defineProperty(this, "minicartFooter", new $bFxq0.LiveElement('.mini-cart__footer'));
        /**
     * @type {LiveElement}
     */ $131a1ec47f227bae$var$_defineProperty(this, "cartTable", new $bFxq0.LiveElement('.cart-table tbody'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "errorContainers", new $bFxq0.LiveNodeList('[data-cart-errors]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "toggles", new $bFxq0.LiveNodeList('[data-minicart-toggle]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "removeButtons", new $bFxq0.LiveNodeList('[data-remove-line-item]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "subtotals", new $bFxq0.LiveNodeList('[data-cart-subtotal]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "totals", new $bFxq0.LiveNodeList('[data-cart-total]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "counts", new $bFxq0.LiveNodeList('[data-cart-count]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "deliveryProgressContainer", new $bFxq0.LiveElement('.mini-cart__delivery-progress'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "deliveryNotificationMessages", new $bFxq0.LiveNodeList('.delivery-notification-message'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "discountContainers", new $bFxq0.LiveNodeList('[data-cart-discounts]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "discountForms", new $bFxq0.LiveNodeList('[data-discount-form]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "discountRemoveButtons", new $bFxq0.LiveNodeList('[data-discount-code-remove]'));
        /**
     * @type {LiveNodeList}
     */ $131a1ec47f227bae$var$_defineProperty(this, "sellingPlanFields", new $bFxq0.LiveNodeList('[data-selling-plan-toggle], [data-selling-plan-select]'));
        this.registerListeners();
    }
    registerListeners() {
        // Handlers for page load
        document.addEventListener('DOMContentLoaded', this.reload);
        // Handlers for cart update events
        document.addEventListener('cart:add', this.reload);
        document.addEventListener('cart:remove', this.reload);
        document.addEventListener('cart:update', this.reload);
        document.addEventListener('cart:discount:apply', this.reload);
        document.addEventListener('cart:discount:remove', this.reload);
        // Handlers for errors
        document.addEventListener('cart:error', (event)=>{
            this.renderError(event.error);
        });
        // Handlers for opening/closing minicart
        if (!document.body.classList.contains('template-cart')) {
            document.addEventListener('cart:add', this.openMinicart);
            document.addEventListener('cart:error', this.openMinicart);
        }
        this.minicart.addEventListener('click', this.closeMinicart);
        this.minicartInner.addEventListener('click', (event)=>event.stopPropagation());
        this.toggles.addEventListener('click', this.handleToggleClick);
        this.removeButtons.addEventListener('click', this.handleRemoveButtonClick);
        this.sellingPlanFields.addEventListener('change', this.handleSellingPlanChange);
        this.sellingPlanFields.addEventListener('input', this.handleSellingPlanChange);
        document.addEventListener('cart:processing:start', (event)=>{
            if ('lineItem' in event) this.clearItemErrors(event.lineItem.lineId);
            this.minicart.item.setAttribute('aria-busy', 'true');
            this.cartTable.item?.setAttribute('aria-busy', 'true');
        });
        document.addEventListener('cart:processing:end', ()=>{
            this.minicart.item.setAttribute('aria-busy', 'false');
            this.cartTable.item?.setAttribute('aria-busy', 'false');
        });
        this.discountForms.addEventListener('submit', this.handleDiscountSubmit);
        this.discountRemoveButtons.addEventListener('click', this.handleDiscountRemove);
    }
    openMinicart() {
        this.minicart.item?.setAttribute('aria-hidden', 'false');
        this.toggles.forEach((toggle)=>toggle.setAttribute('aria-expanded', 'true'));
    }
    closeMinicart() {
        this.minicart.item?.setAttribute('aria-hidden', 'true');
        this.toggles.forEach((toggle)=>toggle.setAttribute('aria-expanded', 'false'));
    }
    handleToggleClick(event) {
        event.preventDefault();
        const target = event.currentTarget || event.target;
        target?.blur();
        if (this.minicart.item.getAttribute('aria-hidden') === 'true') this.openMinicart();
        else this.closeMinicart();
    }
    async reload() {
        this.cart = await window.app.components.cartApi?.getCart();
        this.clearAllErrors();
        await this.populateMetafields($etbRz.productMetafields, $etbRz.variantMetafields);
        await this.populateSellingPlans();
        await this.populateSKUs();
        await this.rerenderSection();
        await this.buildCart();
        await this.buildMinicart();
        await this.buildDiscounts();
        this.updateSubtotal();
        this.updateTotal();
        this.updateCount();
        this.updateDeliveryMessages();
    }
    async rerenderSection() {
        const response = await fetch(`/sections?section_id=mini-cart`, {
            credentials: 'include'
        });
        const newHTML = await response.text();
        const dummy = document.createElement('div');
        dummy.innerHTML = newHTML;
        for (const section of $131a1ec47f227bae$var$DYNAMIC_SECTIONS){
            const newSection = dummy.querySelector(`#${section}`);
            const oldSection = this.minicart.item?.querySelector(`#${section}`);
            oldSection.replaceWith(newSection);
        }
    }
    async populateMetafields(keys = [], variantKeys = []) {
        const ids = this.cart.items.map((item)=>item.product_id);
        const metafieldQuery = (0, $hPUPb.variantMetafieldQuery)(ids, keys, variantKeys);
        const metafieldData = await (0, $9gI3j.fetchFromApi)(metafieldQuery);
        this.cart.items = this.cart.items.map((item)=>{
            item.metafields = {};
            for (const fullKey of keys){
                const [namespace, key] = fullKey.split('.');
                if (!item.metafields[namespace]) item.metafields[namespace] = {};
                item.metafields[namespace][key] = metafieldData.data.products?.edges?.find((edge)=>edge.node.id === `gid://shopify/Product/${item.product_id}`)?.node[`${namespace}___${key}`]?.value;
            }
            item.variant_metafields = {};
            for (const fullKey of variantKeys){
                const [namespace, key] = fullKey.split('.');
                if (!item.variant_metafields[namespace]) item.variant_metafields[namespace] = {};
                item.variant_metafields[namespace][key] = metafieldData.data.products?.edges?.find((edge)=>edge.node.id === `gid://shopify/Product/${item.product_id}`)?.node.variants?.edges?.find((edge)=>edge.node.id === `gid://shopify/ProductVariant/${item.variant_id}`)?.node[`${namespace}___${key}`]?.value;
            }
            return item;
        });
    }
    async populateSellingPlans() {
        const ids = this.cart.items.map((item)=>item.product_id);
        const sellingPlanQuery = (0, $hPUPb.sellingPlansQuery)(ids);
        const sellingPlanData = await (0, $9gI3j.fetchFromApi)(sellingPlanQuery);
        this.cart.items = this.cart.items.map((item)=>{
            item.sellingPlanGroups = sellingPlanData.data.products?.edges.find((edge)=>edge.node.id === `gid://shopify/Product/${item.product_id}`)?.node.sellingPlanGroups.edges.map((edge)=>edge.node).map((group)=>({
                    name: group?.name,
                    sellingPlans: group.sellingPlans?.edges.map((edge)=>{
                        edge.node.id = edge.node.id.replace('gid://shopify/SellingPlan/', '');
                        return edge.node;
                    })
                }));
            return item;
        });
    }
    async populateSKUs() {
        const ids = this.cart.items.map((item)=>item.product_id);
        const query = (0, $hPUPb.skuQuery)(ids);
        const skuData = await (0, $9gI3j.fetchFromApi)(query);
        this.cart.items = this.cart.items.map((item)=>{
            item.sku = skuData.data.products?.edges.find((edge)=>edge.node.id === `gid://shopify/Product/${item.product_id}`)?.node.variants.edges.find((edge)=>edge.node.id === `gid://shopify/ProductVariant/${item.variant_id}`)?.node.sku;
            return item;
        });
    }
    async buildCart() {
        if (!this.cartTable.item) return;
        this.cartTable.item.innerHTML = '';
        let i = 0;
        for (const item of this.cart.items){
            const template = await (0, $4RPMd.templateCartItem)(item, i + 1);
            this.cartTable.item.insertAdjacentHTML('beforeend', template);
            const viewer = this.cartTable.item.lastElementChild.querySelector('cylindo-viewer');
            if (viewer) await this.setupCylindo(viewer, item);
            i++;
        }
    }
    async buildMinicart() {
        if (!this.minicartItemContainer.item) return;
        this.minicartItemContainer.item.innerHTML = '';
        if (this.cart.items.length === 0) {
            this.minicartItemContainer.item.setAttribute('aria-hidden', 'true');
            this.minicartFooter.item.setAttribute('aria-hidden', 'true');
            this.minicartEmptyState.item.setAttribute('aria-hidden', 'false');
        } else {
            this.minicartItemContainer.item.setAttribute('aria-hidden', 'false');
            this.minicartFooter.item.setAttribute('aria-hidden', 'false');
            this.minicartEmptyState.item.setAttribute('aria-hidden', 'true');
        }
        let i = 0;
        for (const item of this.cart.items){
            const template = await (0, $if6TQ.templateMinicartItem)(item, i + 1);
            this.minicartItemContainer.item.insertAdjacentHTML('beforeend', template);
            const viewer = this.minicartItemContainer.item.lastElementChild.querySelector('cylindo-viewer');
            if (viewer) await this.setupCylindo(viewer, item);
            i++;
        }
    }
    async setupCylindo(viewer, item) {
        const features = {};
        item.options_with_values.filter(({ name: name })=>window.theme.cylindoOptions.includes(name)).forEach(({ name: name, value: value })=>{
            features[(0, $99Uv1.convertNameforMatch)(name)] = (0, $99Uv1.convertValueforMatch)(value);
        });
        Object.entries(item.properties).filter(([name])=>window.theme.cylindoOptions.includes(name)).forEach(([name, value])=>{
            features[(0, $99Uv1.convertNameforMatch)(name)] = (0, $99Uv1.convertValueforMatch)(value);
        });
        viewer.features = features;
    }
    async buildItem(item, lineId) {
        const minicartItemElement = this.minicartItemContainer.item?.querySelector(`.mini-cart-item[data-line-id="${lineId}"]`);
        const cartItemElement = this.cartTable.item?.querySelector(`.cart-item[data-line-id="${lineId}"]`);
        if (minicartItemElement) minicartItemElement.outerHTML = await (0, $if6TQ.templateMinicartItem)(item, lineId);
        if (cartItemElement) cartItemElement.outerHTML = await (0, $4RPMd.templateCartItem)(item, lineId);
        [
            minicartItemElement,
            cartItemElement
        ].forEach((itemElement)=>{
            const viewer = itemElement.querySelector('cylindo-viewer');
        });
    }
    async buildDiscounts() {
        const customerDiscounts = await window.app.components.cartApi.getCustomerDiscounts();
        const discounts = await window.app.components.cartApi.getCartDiscounts();
        const containers = this.discountContainers.items || [];
        this.discountForms.forEach((form)=>form.setAttribute('aria-hidden', Object.entries(customerDiscounts).length > 0 ? 'true' : 'false'));
        for (const container of containers){
            container.innerHTML = '';
            const customerItems = Object.entries(customerDiscounts);
            for (const [key, value] of customerItems)container.innerHTML += await (0, $dreuv.templateCustomerDiscountItem)($131a1ec47f227bae$var$_objectSpread({
                key: key
            }, value));
            const items = Object.entries(discounts);
            for (const [key, value] of items)container.innerHTML += await (0, $dreuv.templateDiscountItem)($131a1ec47f227bae$var$_objectSpread({
                key: key
            }, value));
        }
    }
    async updateSubtotal() {
        this.subtotals.forEach((subtotal)=>{
            subtotal.closest('.mini-cart__subtotal, .cart-summary__subtotal')?.setAttribute('aria-hidden', (this.cart.original_total_price === this.cart.total_price).toString());
            subtotal.textContent = (0, $99Uv1.formatMoney)(this.cart.original_total_price);
        });
    }
    async updateTotal() {
        this.totals.forEach((total)=>{
            total.textContent = (0, $99Uv1.formatMoney)(this.cart.total_price);
        });
    }
    async updateCount() {
        this.counts.forEach((count)=>{
            count.textContent = this.cart.item_count === 0 ? '' : this.cart.item_count;
        });
    }
    async clearGlobalErrors() {
        this.errorContainers.forEach((item)=>item.innerHTML = '');
    }
    clearAllErrors() {
        this.clearGlobalErrors();
        this.minicartItemContainer.item?.querySelectorAll('.cart__error')?.forEach((element)=>element.remove());
        this.cartTable.item?.querySelectorAll('.cart__error')?.forEach((element)=>element.remove());
    }
    async clearItemErrors(lineId) {
        const minicartItemElement = this.minicartItemContainer.item?.querySelector(`.mini-cart-item[data-line-id="${lineId}"]`);
        const cartItemElement = this.cartTable.item?.querySelector(`.cart-item[data-line-id="${lineId}"]`);
        if (minicartItemElement) minicartItemElement.querySelectorAll('.cart__error').forEach((element)=>{
            element.remove();
        });
        if (cartItemElement) cartItemElement.querySelectorAll('.cart__error').forEach((element)=>{
            element.remove();
        });
    }
    async renderError(error) {
        let targets = this.errorContainers?.items || [];
        if (error instanceof $jld5k.CartItemError) {
            // Restore correct item details before showing errors
            await this.buildItem(error.lineItem, error.lineItem.lineId);
            targets = [
                this.minicartItemContainer.item?.querySelector(`[data-line-id="${error.lineItem.lineId}"] .mini-cart-item__info`),
                this.cartTable.item?.querySelector(`[data-line-id="${error.lineItem.lineId}"] .cart-item-product__info`)
            ];
        }
        targets = [
            ...targets
        ].filter((target)=>!!target);
        if (targets.length === 0) return;
        const errorElement = document.createElement('span');
        errorElement.classList.add('cart__error');
        errorElement.textContent = error.message;
        // Clear existing errors
        targets.forEach((target)=>{
            target.querySelectorAll('.cart__error')?.forEach((element)=>element.remove());
            target.appendChild(errorElement.cloneNode(true));
        });
        document.dispatchEvent(new $29n7W.CartProcessingEndEvent());
    }
    handleRemoveButtonClick(event) {
        event.preventDefault();
        const target = event.currentTarget || event.target;
        const lineId = target.getAttribute('data-line-id');
        if (!lineId) return;
        window.app.components.cartApi.removeLineItem(lineId);
    }
    handleDiscountSubmit(event) {
        event.preventDefault();
        const form = event.currentTarget || event.target;
        const discountCode = form.querySelector('[name="discount_code"]')?.value;
        try {
            window.app.components.cartApi.applyDiscount(discountCode);
        } catch (error) {
            if (error instanceof $jld5k.InvalidDiscountCodeError) this.renderDiscountError(error);
        }
    }
    handleDiscountRemove(event) {
        event.preventDefault();
        window.app.components.cartApi.removeDiscount();
    }
    handleSellingPlanChange(event) {
        const target = event.currentTarget || event.target;
        const item = target.closest('.mini-cart-item__info-plan-group');
        const lineId = target.getAttribute('data-line-id');
        const toggle = item.querySelector('[data-selling-plan-toggle]');
        const select = item.querySelector('[data-selling-plan-select]');
        let sellingPlanId = null;
        if (toggle.checked) sellingPlanId = select.value;
        window.app.components.cartApi.updateSellingPlan(lineId, sellingPlanId);
    }
    updateDeliveryMessages() {
        const totalPrice = this.cart.total_price;
        const freeShipping = parseInt(window.theme.free_shipping.free_shipping_amount);
        const freeShippingMoney = window.theme.free_shipping.free_shipping_money;
        if (this.deliveryNotificationMessages.length === 0) return;
        let deliveryMessage = window.theme.free_shipping.empty_html.replace('{{ money }}', freeShippingMoney);
        if (totalPrice >= 1 && totalPrice < freeShipping) {
            const priceDiff = (0, $99Uv1.formatMoney)(freeShipping - totalPrice);
            deliveryMessage = window.theme.free_shipping.between_html.replace('{{ money }}', priceDiff);
        } else if (totalPrice >= freeShipping) deliveryMessage = window.theme.free_shipping.over;
        this.deliveryNotificationMessages.forEach((message)=>{
            message.innerHTML = deliveryMessage;
        });
        let cartTotal = totalPrice * 100;
        let percentage = cartTotal / freeShipping < 100 ? cartTotal / freeShipping : '100';
        document.querySelector('.delivery-notification-progress__spent').style.width = percentage + '%';
    }
}, $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "openMinicart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "openMinicart"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "closeMinicart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "closeMinicart"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "handleToggleClick", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "handleToggleClick"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "reload", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "reload"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "rerenderSection", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "rerenderSection"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "populateMetafields", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "populateMetafields"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "populateSellingPlans", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "populateSellingPlans"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "populateSKUs", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "populateSKUs"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "buildCart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "buildCart"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "buildMinicart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "buildMinicart"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "setupCylindo", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "setupCylindo"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "clearGlobalErrors", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "clearGlobalErrors"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "clearAllErrors", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "clearAllErrors"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "clearItemErrors", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "clearItemErrors"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "renderError", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "renderError"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "handleRemoveButtonClick", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "handleRemoveButtonClick"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "handleDiscountRemove", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "handleDiscountRemove"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "handleSellingPlanChange", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "handleSellingPlanChange"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_applyDecoratedDescriptor($131a1ec47f227bae$var$_class.prototype, "updateDeliveryMessages", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($131a1ec47f227bae$var$_class.prototype, "updateDeliveryMessages"), $131a1ec47f227bae$var$_class.prototype), $131a1ec47f227bae$var$_class);

});
parcelRegister("if6TQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.templateMinicartItem = void 0;

var $d47efad3790a269f$var$_slugify = $d47efad3790a269f$var$_interopRequireDefault((parcelRequire("lahK0")));

var $99Uv1 = parcelRequire("99Uv1");

var $gqLTF = parcelRequire("gqLTF");

var $1DG8D = parcelRequire("1DG8D");

var $dreuv = parcelRequire("dreuv");
function $d47efad3790a269f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d47efad3790a269f$var$minicartItemImage = async (item)=>{
    return `
    <a
      href="${item.url}"
      title="${item.product_title}"
      class="mini-cart-item__image objFit"
    >
      ${item.metafields.cylindo.enabled && item.sku ? `
            <cylindo-viewer controls="" customer-id="4704" code="${item.sku?.split('-').slice(0, -1).join('-')}">
              <cylindo-360-frame frame="${item.metafields.cylindo.frame_number || 1}"></cylindo-360-frame>
            </cylindo-viewer>
          ` : `
            <figure class="mini-cart-item__image-wrap">
              ${item.image ? `<img class="mini-cart-item__image-img" src="${item.image}" sizes="7em" alt="${item.product_title}">` : ''}
            </figure>
          `}
    </a>
  `;
};
const $d47efad3790a269f$var$minicartItemTitle = async (item)=>`
  <a
    href="${item.url}"
    class="mini-cart-item__info-title"
  >
    <h5>
      ${item.product_title}
    </h5>

    ${item?.metafields?.product?.short_description ? `<p>${item.metafields.product.short_description}</p>` : ''}
  </a>
`;
const $d47efad3790a269f$var$minicartItemVariant = async (item)=>{
    if (item.options_with_values.length === 0 || item.options_with_values.length === 1 && item.options_with_values[0].name === 'Title') return '';
    return item.options_with_values.map(({ name: name, value: value })=>{
        const optionClassName = (0, $d47efad3790a269f$var$_slugify.default)(name);
        const valueClassName = (0, $d47efad3790a269f$var$_slugify.default)(value);
        return `
      <div class="mini-cart-item__info-variant">
        <span class="mini-cart-item__info-variant-name mini-cart-item__info-variant-name--${optionClassName}">
          ${name}:
        </span>

        <span class="mini-cart-item__info-variant-value mini-cart-item__info-variant-value--${valueClassName}">
          ${value}
        </span>
      </div>
    `;
    }).join('\n');
};
const $d47efad3790a269f$var$minicartItemProperties = async (item)=>{
    const properties = Object.entries(item.properties);
    if (properties.length === 0) return '';
    return properties.map(([name, value])=>{
        const optionClassName = (0, $d47efad3790a269f$var$_slugify.default)(name);
        const valueClassName = (0, $d47efad3790a269f$var$_slugify.default)(value);
        if (!value || value === '') return '';
        return `
      <div class="mini-cart-item__info-property">
        ${!$1DG8D.hiddenPropertyLabels.includes(name) ? `
          <span class="mini-cart-item__info-property-name mini-cart-item__info-property-name--${optionClassName}">
            ${name}:
          </span>
        ` : ''}

          <span class="mini-cart-item__info-property-value mini-cart-item__info-property-value--${valueClassName}">
            ${value}
          </span>
        </div>
        `;
    }).join('\n');
};
const $d47efad3790a269f$var$minicartItemSku = async (item)=>{
    if (!item.sku) return '';
    return `
    <div class="mini-cart-item__info-sku">
      <span class="mini-cart-item__info-sku-label">SKU:</span>
      <span class="mini-cart-item__info-sku-value">${item.sku}</span>
    </div>
  `;
};
const $d47efad3790a269f$var$minicartItemPrice = async (item)=>`
  <div class="mini-cart-item__info-price">
    ${item.final_line_price !== item.original_line_price ? `
      <s class="mini-cart-item__info-price--original">${(0, $99Uv1.formatMoney)(item.original_line_price)}</s>
    ` : ''}
    ${(0, $99Uv1.formatMoney)(item.final_line_price)}
  </div>
`;
const $d47efad3790a269f$var$minicartItemDiscounts = async (item)=>`
  <ul class="mini-cart-item__info-discounts">
    ${(await Promise.all(item.line_level_discount_allocations.map(({ amount: amount, discount_application: discount_application })=>{
        const data = {
            key: discount_application.key,
            title: discount_application.title,
            amount: amount
        };
        return discount_application.type === 'discount_code' ? (0, $dreuv.templateCustomerDiscountItem)(data) : (0, $dreuv.templateDiscountItem)(data);
    }))).join('')}
  </ul>
`;
const $d47efad3790a269f$var$minicartItemSellingPlans = async (item, lineId)=>{
    if (!item.sellingPlanGroups) return '';
    const currentPlanId = item.selling_plan_allocation?.selling_plan?.id.toString();
    return item.sellingPlanGroups.map((group)=>`
    <div class="mini-cart-item__info-plan-group">
      <label class="mini-cart-item__info-plan-group-label">
        <input data-selling-plan-toggle type="checkbox" class="mini-cart-item__info-plan-group-toggle" data-line-id="${lineId}" ${group.sellingPlans.find((plan)=>plan.id === currentPlanId) !== undefined ? 'checked' : ''} />
        <h5 class="mini-cart-item__info-plan-group-title">${group.name}</h5>
      </label>

      ${group.sellingPlans.length > 1 ? `
              <select data-selling-plan-select data-line-id="${lineId}" class="mini-cart-item__info-plan-select">
                ${group.sellingPlans.map((plan)=>`
                  <option value="${plan.id}" ${plan.id === currentPlanId ? 'selected' : ''}>${plan.name}</option>
                `).join('')}
              </select>
            ` : `
              <input type="hidden" data-selling-plan-select data-line-id="${lineId}" value="${group.sellingPlans[0].id}" />
              <span class="mini-cart-item__info-plan-name">${group.sellingPlans[0].name}</span>
            `}
    </div>
  `).join('');
};
const $d47efad3790a269f$var$minicartItemRemoveButton = async (item, lineId)=>`
  <a
    href="/cart/change?line=${lineId}&amp;quantity=0"
    class="mini-cart-item__info-clear"
    data-remove-line-item
    data-line-id="${lineId}"
  >
    <span>Remove</span>
  </a>
`;
const $d47efad3790a269f$var$templateMinicartItem = async (item, lineId)=>`
  <div class="mini-cart-items__item mini-cart-item" data-line-id="${lineId}" aria-live="polite">
    ${await $d47efad3790a269f$var$minicartItemImage(item)}

    <div class="mini-cart-item__info">
      ${await $d47efad3790a269f$var$minicartItemTitle(item)}
      ${await $d47efad3790a269f$var$minicartItemPrice(item)}
      <div class="mini-cart-item__info-content">
        <div class="mini-cart-item__info-variants">
          ${await $d47efad3790a269f$var$minicartItemVariant(item)}
          ${await $d47efad3790a269f$var$minicartItemProperties(item)}
          ${await $d47efad3790a269f$var$minicartItemSku(item)}
        </div>

        ${await $d47efad3790a269f$var$minicartItemDiscounts(item)}

        ${await $d47efad3790a269f$var$minicartItemSellingPlans(item, lineId)}
      </div>

      ${await (0, $gqLTF.quantityIncrementor)(item.quantity, item.variant_id, lineId)}
      ${await $d47efad3790a269f$var$minicartItemRemoveButton(item, lineId)}
    </div>
  </div>
`;
module.exports.templateMinicartItem = $d47efad3790a269f$var$templateMinicartItem;

});
parcelRegister("lahK0", function(module, exports) {
(function(name, root, factory) {
    module.exports = factory();
    module.exports['default'] = factory();
})('slugify', module.exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E\'","\u0538":"Y\'","\u0539":"T\'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C\'","\u053F":"K","\u0540":"H","\u0541":"D\'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R\'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P\'","\u0554":"Q\'","\u0555":"O\'\'","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}');
    var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","\u2211":"soma","\xa3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== 'string') throw new Error('slugify: string argument expected');
        options = typeof options === 'string' ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? '-' : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split('')// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = ' ';
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '');
        }, '');
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});

});

parcelRegister("gqLTF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.quantityIncrementor = module.exports.minicartEmptyState = module.exports.cartEmptyState = void 0;
const $bf643a5a29b7bac7$var$quantityIncrementor = async (quantity, variantId, lineId)=>{
    const id = `quantity_${crypto.randomUUID()}`;
    return `
    <div class="mini-cart-item__info-quantity">
      <div
        class="quantity-incrementor"
        data-variant-id="${variantId}"
        data-line-id="${lineId}"
      >
        <label for="${id}" class="quantity-incrementor__label screenreader-text">
          ${window.theme.strings.quantity}:
        </label>

        <button class="quantity-incrementor__minus" type="button">
          <span class="screenreader-text">
            ${window.theme.strings.incrementorMinus}
          </span>
        </button>

        <input
          class="quantity-incrementor__input"
          type="number"
          id="${id}"
          name="quantity"
          value="${quantity}"
          min="0"
          max="${window.theme.inventory[variantId] || 999}"
          aria-label="${window.theme.strings.itemQuantity}"
        />

        <button class="quantity-incrementor__plus" type="button">
          <span class="screenreader-text">
            ${window.theme.strings.incrementorPlus}
          </span>
        </button>
      </div>
    </div>
  `;
};
module.exports.quantityIncrementor = $bf643a5a29b7bac7$var$quantityIncrementor;
const $bf643a5a29b7bac7$var$cartEmptyState = async ()=>`
  <div class="cart__empty">

  </div>
`;
module.exports.cartEmptyState = $bf643a5a29b7bac7$var$cartEmptyState;
const $bf643a5a29b7bac7$var$minicartEmptyState = async ()=>`
  <div class="mini-cart__empty">
    <h2 class="mini-cart__empty-title">${window.theme.strings.miniCart.empty.title}</h2>
    <p class="mini-cart__empty-text">${window.theme.strings.miniCart.empty.content}</p>

    <a href="/products/all" class="text-link">
      ${window.theme.strings.miniCart.empty.buttonText}
    </a>
  </div>
`;
module.exports.minicartEmptyState = $bf643a5a29b7bac7$var$minicartEmptyState;

});

parcelRegister("dreuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.templateDiscountItem = module.exports.templateCustomerDiscountItem = void 0;

var $99Uv1 = parcelRequire("99Uv1");
const $9c89099ab4c8baee$var$templateCustomerDiscountItem = async ({ key: key, title: title, amount: amount })=>{
    return `
    <li class="discounts-list__item" data-key="${key}">
      <span class="discounts-list__item-label">${title} <button data-discount-code-remove>&times;</button></span>
      <span class="discounts-list__item-amount">- ${(0, $99Uv1.formatMoney)(amount)}</span>
    </li>
  `;
};
module.exports.templateCustomerDiscountItem = $9c89099ab4c8baee$var$templateCustomerDiscountItem;
const $9c89099ab4c8baee$var$templateDiscountItem = async ({ key: key, title: title, amount: amount })=>{
    return `
    <li class="discounts-list__item" data-key="${key}">
      <span class="discounts-list__item-label">${title}</span>
      <span class="discounts-list__item-amount">- ${(0, $99Uv1.formatMoney)(amount)}</span>
    </li>
  `;
};
module.exports.templateDiscountItem = $9c89099ab4c8baee$var$templateDiscountItem;

});


parcelRegister("4RPMd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.templateCartItem = void 0;

var $99Uv1 = parcelRequire("99Uv1");

var $38b44673de44a149$var$_slugify = $38b44673de44a149$var$_interopRequireDefault((parcelRequire("lahK0")));

var $gqLTF = parcelRequire("gqLTF");

var $1DG8D = parcelRequire("1DG8D");

var $dreuv = parcelRequire("dreuv");
function $38b44673de44a149$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38b44673de44a149$var$cartItemImage = async (item)=>`
  <a
    href="${item.url}"
    title="${item.product_title}"
    class="cart-item-product__image objFit"
  >
    ${item.metafields.cylindo.enabled && item.sku ? `
          <cylindo-viewer controls="" customer-id="4704" code="${item.sku?.split('-').slice(0, -1).join('-')}">
            <cylindo-360-frame frame="${item.metafields.cylindo.frame_number || 1}"></cylindo-360-frame>
          </cylindo-viewer>
        ` : `
          <figure class="cart-item-product__image-figure">
            ${item.image ? `<img class="cart-item-product__image-img" src="${item.image}" sizes="7em" alt="${item.product_title}">` : ''}
          </figure>
        `}
  </a>
`;
const $38b44673de44a149$var$cartItemTitle = async (item)=>`
  <a href="${item.url}" class="cart-item-product__info-title" data-cart-item-title data-role="product-title">
    ${item.product_title}
  </a>
`;
const $38b44673de44a149$var$cartItemVariant = async (item)=>{
    if (item.options_with_values.length === 0 || item.options_with_values.length === 1 && item.options_with_values[0].name === 'Title') return '';
    return item.options_with_values.map(({ name: name, value: value })=>{
        const optionClassName = (0, $38b44673de44a149$var$_slugify.default)(name);
        const valueClassName = (0, $38b44673de44a149$var$_slugify.default)(value);
        return `
      <div class="cart-item-product__info-variant">
        <span class="cart-item-product__info-variant-name cart-item-product__info-variant-name--${optionClassName}">
          ${name}:
        </span>

        <span class="cart-item-product__info-variant-value cart-item-product__info-variant-value--${valueClassName}">
          ${value}
        </span>
      </div>
    `;
    }).join('\n');
};
const $38b44673de44a149$var$cartItemProperties = async (item)=>{
    const properties = Object.entries(item.properties);
    if (properties.length === 0) return '';
    return properties.map(([name, value])=>{
        const optionClassName = (0, $38b44673de44a149$var$_slugify.default)(name);
        const valueClassName = (0, $38b44673de44a149$var$_slugify.default)(value);
        if (!value || value === '') return '';
        return `
      <div class="cart-item-product__info-property">
        ${!$1DG8D.hiddenPropertyLabels.includes(name) ? `
          <span class="cart-item__info-property-name cart-item__info-property-name--${optionClassName}">
            ${name}:
          </span>
        ` : ''}

          <span class="cart-item-product__info-property-value cart-item-product__info-property-value--${valueClassName}">
            ${value}
          </span>
        </div>
        `;
    }).join('\n');
};
const $38b44673de44a149$var$cartItemSku = async (item)=>{
    if (!item.sku) return '';
    return `
    <div class="cart-item-product__info-sku">
      <span class="cart-item-product__info-sku-label">SKU:</span>
      <span class="cart-item-product__info-sku-value">${item.sku}</span>
    </div>
  `;
};
const $38b44673de44a149$var$cartItemProduct = async (item, lineId)=>`
  <div class="cart-item-product">
    ${item.image ? await $38b44673de44a149$var$cartItemImage(item) : ''}

    <div class="cart-item-product__info">
      ${await $38b44673de44a149$var$cartItemTitle(item)}

      <div class="cart-item-product__info-content">
        ${await $38b44673de44a149$var$cartItemVariant(item)}
        ${await $38b44673de44a149$var$cartItemProperties(item)}
        ${await $38b44673de44a149$var$cartItemSku(item)}
        ${await $38b44673de44a149$var$cartItemSellingPlans(item, lineId)}
      </div>
    </div>
  </div>
`;
const $38b44673de44a149$var$cartItemSellingPlans = async (item, lineId)=>{
    if (!item.sellingPlanGroups) return '';
    const currentPlanId = item.selling_plan_allocation?.selling_plan?.id.toString();
    return item.sellingPlanGroups.map((group)=>`
    <div class="mini-cart-item__info-plan-group">
      <label class="mini-cart-item__info-plan-group-label">
        <input data-selling-plan-toggle type="checkbox" class="mini-cart-item__info-plan-group-toggle" data-line-id="${lineId}" ${group.sellingPlans.find((plan)=>plan.id === currentPlanId) !== undefined ? 'checked' : ''} />
        <h5 class="mini-cart-item__info-plan-group-title">${group.name}</h5>
      </label>

      ${group.sellingPlans.length > 1 ? `
              <select data-selling-plan-select data-line-id="${lineId}" class="mini-cart-item__info-plan-select">
                ${group.sellingPlans.map((plan)=>`
                  <option value="${plan.id}" ${plan.id === currentPlanId ? 'selected' : ''}>${plan.name}</option>
                `).join('')}
              </select>
            ` : `
              <input type="hidden" data-selling-plan-select data-line-id="${lineId}" value="${group.sellingPlans[0].id}" />
              <span class="mini-cart-item__info-plan-name">${group.sellingPlans[0].name}</span>
            `}
    </div>
  `).join('');
};
const $38b44673de44a149$var$cartItemPrice = async (item)=>`
  <div class="cart-item-product__info-price" data-cart-item-price>
    ${item.final_price !== item.original_price ? `<s class="cart-item-product__info-price-original">${(0, $99Uv1.formatMoney)(item.original_price)}</s>` : ''}
    ${(0, $99Uv1.formatMoney)(item.final_price)}
  </div>
`;
const $38b44673de44a149$var$cartItemTotal = async (item)=>`
  <div class="cart-item-product__total" data-cart-item-total>
    ${(0, $99Uv1.formatMoney)(item.final_line_price)}
  </div>
`;
const $38b44673de44a149$var$cartItemDiscounts = async (item)=>`
  <ul class="mini-cart-item__info-discounts">
    ${(await Promise.all(item.line_level_discount_allocations.map(({ amount: amount, discount_application: discount_application })=>{
        const data = {
            key: discount_application.key,
            title: discount_application.title,
            amount: amount
        };
        return discount_application.type === 'discount_code' ? (0, $dreuv.templateCustomerDiscountItem)(data) : (0, $dreuv.templateDiscountItem)(data);
    }))).join('')}
  </ul>
`;
const $38b44673de44a149$var$cartItemRemoveButton = async (item, lineId)=>`
  <a
    href="/cart/change?line=${lineId}&amp;quantity=0"
    class="cart-item-product__info-remove cart-remove"
    aria-label="${window.theme.strings.cart.label.remove}"
    data-remove-line-item
    data-line-id="${lineId}"
  >
    <span class="screenreader-text">${window.theme.strings.cart.label.remove}</span>

    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.10609 1.1061L14.9345 14.9345M15 1L1 15" stroke="currentColor" stroke-linecap="square"/>
    </svg>
  </a>
`;
const $38b44673de44a149$var$templateCartItem = async (item, lineId)=>`
  <tr class="responsive-table-row cart-table__product-row" data-product="${item.id}" data-line-id="${lineId}">
    <td data-label="${window.theme.strings.cart.label.product}">
      ${await $38b44673de44a149$var$cartItemProduct(item, lineId)}
    </td>

    <td data-label="${window.theme.strings.cart.label.price}">
      ${await $38b44673de44a149$var$cartItemPrice(item)}
      ${await $38b44673de44a149$var$cartItemDiscounts(item)}
    </td>

    <td data-label="${window.theme.strings.cart.label.quantity}">
      ${await (0, $gqLTF.quantityIncrementor)(item.quantity, item.variant_id, lineId)}
    </td>

    <td data-label="${window.theme.strings.cart.label.total}">
      ${await $38b44673de44a149$var$cartItemTotal(item)}
    </td>

    <td>
      ${await $38b44673de44a149$var$cartItemRemoveButton(item, lineId)}
    </td>
  </tr>
`;
module.exports.templateCartItem = $38b44673de44a149$var$templateCartItem;

});

parcelRegister("hPUPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.variantMetafieldQuery = module.exports.skuQuery = module.exports.sellingPlansQuery = module.exports.productsByIdQuery = module.exports.productsByHandleQuery = module.exports.productRecommendationsQuery = module.exports.productMetafieldQuery = module.exports.productByIdQuery = module.exports.generateMetafields = module.exports.allProductsQuery = module.exports.allProductsInCollectionQuery = void 0;

var $etbRz = parcelRequire("etbRz");
const $cfc3473ea1169834$var$generateMetafields = (keys)=>{
    const separatedKeys = keys.map((key)=>key.split('.'));
    return separatedKeys.map(([namespace, key])=>`
      ${namespace}___${key}: metafield(namespace: "${namespace}", key: "${key}") {
        namespace,
        key,
        value
      }
    `);
};
module.exports.generateMetafields = $cfc3473ea1169834$var$generateMetafields;
const $cfc3473ea1169834$var$productFields = `
  id
  handle
  title
  descriptionHtml
  tags
  available: availableForSale
  images(first: 15) {
    edges {
      node {
        src
      }
    }
  }
  priceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  compareAtPriceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  options(first: 25) {
    id
    name
    values
  }
  ${$cfc3473ea1169834$var$generateMetafields($etbRz.productMetafields)}
  variants(first: 250) {
    edges {
      node {
        id
        title
        sku
        available: availableForSale
        price: priceV2 {
          amount
        }
        compareAtPrice: compareAtPriceV2 {
          amount
        }
        image {
          src
        }
        selectedOptions {
          name
          value
        }
        ${$cfc3473ea1169834$var$generateMetafields($etbRz.variantMetafields)}
      }
    }
  }
  ${window.theme ? Object.keys(window.theme.strings.products.labels).map((label)=>`
            ${label}: metafield(namespace: "labels", key: "${label}") {
              namespace,
              key,
              value
            }
          `) : ''}
`;
const $cfc3473ea1169834$var$allProductsInCollectionQuery = (handle)=>`
  query AllProductsInCollection {
    collectionByHandle(handle: "${handle}") {
      handle
      products(first: 250) {
        edges {
          node {
            ${$cfc3473ea1169834$var$productFields}
          }
        }
      }
    }
  }
`;
module.exports.allProductsInCollectionQuery = $cfc3473ea1169834$var$allProductsInCollectionQuery;
const $cfc3473ea1169834$var$allProductsQuery = ()=>`
  query AllProducts {
    products(first: 250) {
      edges {
        node {
          ${$cfc3473ea1169834$var$productFields}
        }
      }
    }
  }
`;
module.exports.allProductsQuery = $cfc3473ea1169834$var$allProductsQuery;
const $cfc3473ea1169834$var$productByIdQuery = (id)=>`
  query ProductById {
    product(id: "gid://shopify/Product/${id}") {
      ${$cfc3473ea1169834$var$productFields}
    }
  }
`;
module.exports.productByIdQuery = $cfc3473ea1169834$var$productByIdQuery;
const $cfc3473ea1169834$var$productsByIdQuery = (ids, limit = 250)=>`
  query ProductsById {
    products(first: ${limit}, query: "id:${ids.join(' OR ')}") {
      edges {
        node {
          ${$cfc3473ea1169834$var$productFields}
        }
      }
    }
  }
`;
module.exports.productsByIdQuery = $cfc3473ea1169834$var$productsByIdQuery;
const $cfc3473ea1169834$var$productsByHandleQuery = (handles, limit = 250)=>`
  query ProductsByHandle {
    products(first: ${limit}, query: "handle:${handles.join(' OR ')}") {
      edges {
        node {
          ${$cfc3473ea1169834$var$productFields}
        }
      }
    }
  }
`;
module.exports.productsByHandleQuery = $cfc3473ea1169834$var$productsByHandleQuery;
const $cfc3473ea1169834$var$productRecommendationsQuery = (id)=>`
  query ProductRecommendations {
    productRecommendations(productId: "gid://shopify/Product/${id}") {
      ${$cfc3473ea1169834$var$productFields}
    }
  }
`;
module.exports.productRecommendationsQuery = $cfc3473ea1169834$var$productRecommendationsQuery;
const $cfc3473ea1169834$var$productMetafieldQuery = (ids, metafieldKeys = $etbRz.productMetafields)=>{
    if (typeof ids === 'string') ids = [
        ids
    ];
    return `
    query ProductMetafieldsQuery {
      products(first: 250, query: "id:${ids.join(' OR ')}") {
        edges {
          node {
            id
            ${$cfc3473ea1169834$var$generateMetafields(metafieldKeys)}
          }
        }
      }
    }
  `;
};
module.exports.productMetafieldQuery = $cfc3473ea1169834$var$productMetafieldQuery;
const $cfc3473ea1169834$var$variantMetafieldQuery = (productIds, metafieldKeys = $etbRz.productMetafields, variantMetafieldKeys = $etbRz.variantMetafields)=>{
    if (typeof productIds === 'string') productIds = [
        productIds
    ];
    return `
    query VariantMetafieldsQuery {
      products(first: 250, query: "id:${productIds.join(' OR ')}") {
        edges {
          node {
            id
            ${$cfc3473ea1169834$var$generateMetafields(metafieldKeys)}

            variants(first: 250) {
              edges {
                node {
                  id
                  ${$cfc3473ea1169834$var$generateMetafields(variantMetafieldKeys)}
                }
              }
            }
          }
        }
      }
    }
  `;
};
module.exports.variantMetafieldQuery = $cfc3473ea1169834$var$variantMetafieldQuery;
const $cfc3473ea1169834$var$sellingPlansQuery = (productIds)=>{
    if (typeof productIds === 'string') productIds = [
        productIds
    ];
    return `
    query SellingPlansQuery {
      products(first: 250, query: "id:${productIds.join(' OR ')}") {
        edges {
          node {
            id
            sellingPlanGroups(first: 250) {
              edges {
                node {
                  name
                  sellingPlans(first: 250) {
                    edges {
                      node {
                        id
                        name
                        checkoutCharge {
                          type
                          value
                        }
                        #deliveryPolicy {
                        #  ... on SellingPlanDeliveryPolicy {
                        #    interval
                        #    intervalCount
                        #  }
                        #}
                        priceAdjustments {
                          adjustmentValue {
                            ... on SellingPlanFixedAmountPriceAdjustment {
                              adjustmentAmount {
                                amount
                              }
                            }
                            ... on SellingPlanFixedPriceAdjustment {
                              price {
                                amount
                              }
                            }
                            ... on SellingPlanPercentagePriceAdjustment {
                              adjustmentPercentage
                            }
                          }
                          orderCount
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
};
module.exports.sellingPlansQuery = $cfc3473ea1169834$var$sellingPlansQuery;
const $cfc3473ea1169834$var$skuQuery = (productIds)=>{
    if (typeof productIds === 'string') productIds = [
        productIds
    ];
    return `
    query SkuQuery {
      products(first: 250, query: "id:${productIds.join(' OR ')}") {
        edges {
          node {
            id
            variants(first: 250) {
              edges {
                node {
                  id
                  sku
                }
              }
            }
          }
        }
      }
    }
  `;
};
module.exports.skuQuery = $cfc3473ea1169834$var$skuQuery;

});
parcelRegister("etbRz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.variantMetafields = module.exports.productMetafields = module.exports.default = void 0;
parcelRequire("4fH4F");

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $99Uv1 = parcelRequire("99Uv1");

var $2bQLV = parcelRequire("2bQLV");

var $hPUPb = parcelRequire("hPUPb");

var $9gI3j = parcelRequire("9gI3j");
var $a88cf9d9b80ae390$var$_class;
function $a88cf9d9b80ae390$var$_defineProperty(e, r, t) {
    return (r = $a88cf9d9b80ae390$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a88cf9d9b80ae390$var$_toPropertyKey(t) {
    var i = $a88cf9d9b80ae390$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a88cf9d9b80ae390$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a88cf9d9b80ae390$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
const $a88cf9d9b80ae390$var$propertiesHiddenFromURL = [
    'SKU',
    'Lead time'
];
/**
 * @type {Object<{[key: string]: string}>}
 */ const $a88cf9d9b80ae390$var$selectors = {
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    price: '[data-product-price]',
    priceWrapper: '[data-price-wrapper]',
    quantityInput: '[data-quantity-input]',
    submitButton: '[data-submit-button]:not(.rfq-btn)',
    submitButtonText: ':not(.rfq-btn) > [data-submit-button-text]',
    buyButton: '[data-buy-button]',
    buyButtonText: '[data-buy-button-text]',
    variantSelector: '[data-product-select]',
    optionLegends: '[data-option-legend]',
    cylindoViewer: '[data-cylindo-viewer]',
    tearSheetLink: '[data-tear-sheet-link]',
    contactBlock: '[data-contact-block]',
    skuInput: '[data-sku-input]'
};
// A list of product metafields to fetch
// e.g. ['namespace.key']
const $a88cf9d9b80ae390$var$productMetafields = module.exports.productMetafields = [
    'product.short_description',
    'product.dimensions',
    'product.materials',
    'product.separate_variants',
    'product.show_dimensions_on_listing_pages',
    'tear_sheet.additional_information',
    'cylindo.enabled',
    'cylindo.frame_number'
];
// A list of variant metafields to fetch
const $a88cf9d9b80ae390$var$variantMetafields = module.exports.variantMetafields = [
    'product.dimensions',
    'variant.require_contact'
];
let $a88cf9d9b80ae390$var$ProductForm = module.exports.default = ($a88cf9d9b80ae390$var$_class = class ProductForm {
    constructor(element, product, variant, properties = {}){
        /**
     * @type {HTMLElement}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "wrapper", null);
        /**
     * @type {HTMLElement}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "content", null);
        /**
     * @type {HTMLFormElement}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "element", null);
        /**
     * @type {ShopifyProduct}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "product", null);
        /**
     * @type {ShopifyProductVariant}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "variant", null);
        /**
     * @type {Record<string, LiveNodeList<HTMLElement>>}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "elements", {});
        /**
     * @type {Record<string, string>}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "properties", {});
        /**
     * @type {number}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "quantity", 1);
        /**
     * @type {Array<{name: string, value: string}>}
     */ $a88cf9d9b80ae390$var$_defineProperty(this, "options", []);
        this.wrapper = element.closest('.product');
        this.content = element.closest('.product-content');
        this.element = element;
        this.product = product;
        this.variant = variant;
        this.properties = properties;
        this.options = this.element.shopifyProductForm.options();
        if (Object.keys(properties).length > 0) this.setPropertyValues();
        this.elements = {
            comparePrice: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.comparePrice, this.content),
            comparePriceText: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.comparePriceText, this.content),
            priceWrapper: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.priceWrapper, this.content),
            price: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.price, this.content),
            quantityInputs: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.quantityInput, this.element),
            submitButton: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.submitButton, this.element),
            submitButtonText: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.submitButtonText, this.element),
            buyButton: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.buyButton, this.element),
            buyButtonText: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.buyButtonText, this.element),
            variantSelector: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.variantSelector, this.element),
            optionLegends: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.optionLegends, this.element),
            cylindoViewers: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.cylindoViewer, this.wrapper),
            tearSheetLinks: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.tearSheetLink, this.wrapper),
            contactBlock: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.contactBlock, this.wrapper),
            skuInput: new $bFxq0.LiveNodeList($a88cf9d9b80ae390$var$selectors.skuInput, this.element)
        };
        this.registerListeners();
        this.populateProductMetafields($a88cf9d9b80ae390$var$productMetafields);
        if (this.variant) this.populateVariantMetafields($a88cf9d9b80ae390$var$variantMetafields);
        this.element.dispatchEvent(new $2bQLV.ProductOptionChangeEvent({
            form: this.element,
            product: this.product,
            variant: this.variant,
            options: this.options,
            properties: this.properties,
            quantity: this.quantity
        }));
        this.elements.variantSelector.item?.dispatchEvent(new Event('change'));
    }
    registerListeners() {
        this.element.addEventListener('product:option:change', async (event)=>{
            this.variant = event.variant;
            this.options = event.options;
            this.properties = event.properties || {};
            this.quantity = event.quantity;
            await this.populateVariantMetafields($a88cf9d9b80ae390$var$variantMetafields);
            this.updateSelectedVariant();
            this.updatePrice();
            this.updateAvailability();
            this.updateSwatchValues();
            this.updatePropertyValues();
            this.updateCylindoFeatures();
            this.updateBrowserHistory();
            this.updateTearSheetURLs();
        });
        this.element.addEventListener('product:quantity:change', async (event)=>{
            this.quantity = event.quantity;
            this.updatePrice();
            this.updateAvailability();
        });
        this.element.addEventListener('product:property:change', async (event)=>{
            this.properties = event.properties;
            this.updatePropertyValues();
            this.updateCylindoFeatures();
            this.updateBrowserHistory();
            this.updateTearSheetURLs();
            this.element.dispatchEvent(new $2bQLV.ProductOptionChangeEvent({
                form: this.element,
                product: this.product,
                variant: this.variant,
                options: this.options,
                properties: this.properties,
                quantity: this.quantity
            }));
        });
        this.elements.optionLegends.addEventListener('click', (event)=>{
            const target = event.currentTarget || event.target;
            const expanded = target.getAttribute('aria-expanded') === 'true';
            if (!expanded) this.elements.optionLegends.forEach((item)=>item.setAttribute('aria-expanded', 'false'));
            target.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        });
    }
    async populateProductMetafields(keys) {
        const metafieldQuery = (0, $hPUPb.productMetafieldQuery)(this.product.id.toString(), keys);
        const metafieldData = await (0, $9gI3j.fetchFromApi)(metafieldQuery);
        this.product.metafields = {};
        for (const fullKey of keys){
            const [namespace, key] = fullKey.split('.');
            if (!this.product.metafields[namespace]) this.product.metafields[namespace] = {};
            this.product.metafields[namespace][key] = metafieldData.data.products?.edges?.[0]?.node[`${namespace}___${key}`]?.value;
        }
    }
    async populateVariantMetafields(keys) {
        if (!this.variant) return;
        const metafieldQuery = (0, $hPUPb.variantMetafieldQuery)(this.product.id.toString(), [], keys);
        const metafieldData = await (0, $9gI3j.fetchFromApi)(metafieldQuery);
        this.variant.metafields = {};
        for (const fullKey of keys){
            const [namespace, key] = fullKey.split('.');
            if (!this.variant.metafields[namespace]) this.variant.metafields[namespace] = {};
            this.variant.metafields[namespace][key] = metafieldData.data.products?.edges?.[0]?.node.variants?.edges?.find((edge)=>edge.node.id === `gid://shopify/ProductVariant/${this.variant.id}`)?.node?.[`${namespace}___${key}`]?.value;
        }
    }
    updateSelectedVariant() {
        this.elements.variantSelector.forEach((selector)=>{
            selector.value = this.variant.id;
        });
        this.elements.skuInput.forEach((input)=>{
            input.value = this.variant.sku || '';
        });
        this.updateAvailableQuantity();
        this.element.dispatchEvent(new $2bQLV.ProductVariantChangeEvent({
            form: this.element,
            options: this.options,
            product: this.product,
            properties: this.properties,
            quantity: this.quantity,
            variant: this.variant
        }));
    }
    updateBrowserHistory() {
        const enableHistoryState = this.element.dataset.enableHistoryState;
        if (!this.variant || enableHistoryState !== 'true') return;
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        searchParams.set('variant', this.variant.id);
        Object.entries(this.properties).forEach(([key, value])=>{
            if ($a88cf9d9b80ae390$var$propertiesHiddenFromURL.includes(key)) return;
            searchParams.set(`properties[${key}]`, value);
        });
        url.search = searchParams.toString();
        window.history.replaceState({
            path: url.toString()
        }, '', url.toString());
    }
    updateTearSheetURLs() {
        this.elements.tearSheetLinks.forEach((link)=>{
            const url = new URL(link.href);
            const searchParams = new URLSearchParams(url.search);
            if (this.variant) searchParams.set('variant', this.variant.id);
            if (this.properties) Object.entries(this.properties).forEach(([key, value])=>{
                searchParams.set(`properties[${key}]`, value);
            });
            url.search = searchParams.toString();
            link.href = url.toString();
        });
    }
    updatePrice() {
        if (!this.variant) return;
        const price = this.variant.price;
        this.elements.price.forEach((element)=>{
            if (element.closest('.samples-popup') === null) element.innerHTML = (0, $99Uv1.formatMoney)(price);
        });
        const comparePrice = this.variant.compare_at_price;
        this.elements.comparePrice.forEach((element)=>{
            element.setAttribute('aria-hidden', (comparePrice <= price).toString());
            element.innerHTML = (0, $99Uv1.formatMoney)(comparePrice > price ? comparePrice : price);
        });
    }
    updateAvailability() {
        let disabled = false;
        let hideContactBlock = false;
        let buttonText = window.theme.strings.addToCart;
        let buyButtonText = this.product.variants.length > 1 ? window.theme.strings.configure : window.theme.strings.buyNow;
        const availableQuantity = parseInt(this.elements.quantityInputs.items[0]?.max || 999, 10);
        if (!this.variant) {
            disabled = true;
            hideContactBlock = true;
            buttonText = window.theme.strings.unavailable;
            buyButtonText = window.theme.strings.unavailable;
        } else {
            if (this.variant.metafields.variant.require_contact) {
                disabled = true;
                hideContactBlock = false;
            } else {
                disabled = false;
                hideContactBlock = true;
            }
            if (!this.variant.available) {
                disabled = true;
                buttonText = window.theme.strings.soldOut;
                buyButtonText = window.theme.strings.soldOut;
            } else if (availableQuantity < this.quantity) {
                disabled = true;
                buttonText = window.theme.strings.quantityUnavailable;
                buyButtonText = window.theme.strings.quantityUnavailable;
            }
        }
        this.elements.contactBlock.forEach((block)=>{
            block.setAttribute('aria-hidden', hideContactBlock.toString());
        });
        this.elements.submitButton.forEach((button)=>{
            button.disabled = disabled;
        });
        this.elements.submitButtonText.forEach((button)=>{
            button.innerText = buttonText;
        });
        this.elements.buyButtonText.forEach((button)=>{
            button.innerText = buyButtonText;
        });
    }
    updateSwatchValues() {
        const swatches = this.element.querySelectorAll('.product-options-swatch__value[data-option]');
        swatches.forEach((swatch)=>{
            const name = swatch.dataset.option;
            const value = this.options.find((option)=>option.name === name)?.value;
            swatch.innerText = value;
        });
    }
    setPropertyValues() {
        Object.entries(this.properties).forEach(([key, value])=>{
            const inputs = this.element.querySelectorAll(`input[name="properties[${key}]"]`);
            inputs.forEach((input)=>{
                if (input.type === 'radio' || input.type === 'checkbox') {
                    input.checked = input.value === value;
                    return;
                }
                input.value = value;
            });
        });
    }
    updatePropertyValues() {
        if (!this.variant) return;
        Object.entries(this.properties).forEach(([key, value])=>{
            if ($a88cf9d9b80ae390$var$propertiesHiddenFromURL.includes(key)) return;
            const property = this.element.querySelector(`[data-property="${key}"]`);
            if (property) property.innerText = value;
        });
    }
    updateCylindoFeatures() {
        if (!this.variant || !this.variant.sku) return;
        const skuCode = this.variant.sku.split('-').slice(0, -1).join('-');
        const usedFeatures = {};
        this.options.filter(({ name: name })=>window.theme.cylindoOptions.includes(name)).forEach(({ name: name, value: value })=>{
            usedFeatures[(0, $99Uv1.convertNameforMatch)(name)] = (0, $99Uv1.convertValueforMatch)(value);
        });
        Object.entries(this.properties).filter(([key])=>window.theme.cylindoOptions.includes(key)).forEach(([key, value])=>{
            usedFeatures[(0, $99Uv1.convertNameforMatch)(key)] = (0, $99Uv1.convertValueforMatch)(value);
        });
        this.elements.cylindoViewers.forEach((item)=>{
            item.setAttribute('code', skuCode);
            item.features = usedFeatures;
        });
    }
    updateAvailableQuantity() {
        this.elements.quantityInputs.forEach((input)=>{
            input.max = parseInt([
                ...this.elements.variantSelector.items[0]?.querySelectorAll('option')
            ].find((option)=>!!option.selected)?.dataset.quantityAvailable || 0);
        });
    }
}, $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "populateProductMetafields", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "populateProductMetafields"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "populateVariantMetafields", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "populateVariantMetafields"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateSelectedVariant", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateSelectedVariant"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateBrowserHistory", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateBrowserHistory"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateTearSheetURLs", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateTearSheetURLs"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updatePrice", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updatePrice"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateAvailability", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateAvailability"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateSwatchValues", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateSwatchValues"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "setPropertyValues", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "setPropertyValues"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updatePropertyValues", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updatePropertyValues"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateCylindoFeatures", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateCylindoFeatures"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_applyDecoratedDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateAvailableQuantity", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($a88cf9d9b80ae390$var$_class.prototype, "updateAvailableQuantity"), $a88cf9d9b80ae390$var$_class.prototype), $a88cf9d9b80ae390$var$_class);

});
parcelRegister("4fH4F", function(module, exports) {

$parcel$export(module.exports, "ProductForm", function () { return $3189f9ca4432b349$export$a7a5d736c2a3d416; });

var $gfx0a = parcelRequire("gfx0a");

var $9TprG = parcelRequire("9TprG");
var $3189f9ca4432b349$var$selectors = {
    idInput: '[name="id"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]'
};
function $3189f9ca4432b349$export$e714470cbde6ec74(url, id) {
    if (/variant=/.test(url)) return url.replace(/(variant=)[^&]+/, '$1' + id);
    else if (/\?/.test(url)) return url.concat('&variant=').concat(id);
    return url.concat('?variant=').concat(id);
}
function $3189f9ca4432b349$export$a7a5d736c2a3d416(element, product, options) {
    this.element = element;
    this.product = $3189f9ca4432b349$var$_validateProductObject(product);
    options = options || {};
    this._listeners = new (0, $gfx0a.default)();
    this._listeners.add(this.element, 'submit', this._onSubmit.bind(this, options));
    this.optionInputs = this._initInputs($3189f9ca4432b349$var$selectors.optionInput, options.onOptionChange);
    this.quantityInputs = this._initInputs($3189f9ca4432b349$var$selectors.quantityInput, options.onQuantityChange);
    this.propertyInputs = this._initInputs($3189f9ca4432b349$var$selectors.propertyInput, options.onPropertyChange);
}
/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */ $3189f9ca4432b349$export$a7a5d736c2a3d416.prototype.destroy = function() {
    this._listeners.removeAll();
};
/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */ $3189f9ca4432b349$export$a7a5d736c2a3d416.prototype.options = function() {
    return $3189f9ca4432b349$var$_serializeOptionValues(this.optionInputs, function(item) {
        var regex = /(?:^(options\[))(.*?)(?:\])/;
        item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
        return item;
    });
};
/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */ $3189f9ca4432b349$export$a7a5d736c2a3d416.prototype.variant = function() {
    return (0, $9TprG.getVariantFromSerializedArray)(this.product, this.options());
};
/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */ $3189f9ca4432b349$export$a7a5d736c2a3d416.prototype.properties = function() {
    var properties = $3189f9ca4432b349$var$_serializePropertyValues(this.propertyInputs, function(propertyName) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/;
        var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
        return name;
    });
    return Object.entries(properties).length === 0 ? null : properties;
};
/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */ $3189f9ca4432b349$export$a7a5d736c2a3d416.prototype.quantity = function() {
    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
};
// Private Methods
// -----------------------------------------------------------------------------
$3189f9ca4432b349$export$a7a5d736c2a3d416.prototype._setIdInputValue = function(value) {
    var idInputElement = this.element.querySelector($3189f9ca4432b349$var$selectors.idInput);
    if (!idInputElement) {
        idInputElement = document.createElement('input');
        idInputElement.type = 'hidden';
        idInputElement.name = 'id';
        this.element.appendChild(idInputElement);
    }
    idInputElement.value = value.toString();
};
$3189f9ca4432b349$export$a7a5d736c2a3d416.prototype._onSubmit = function(options, event) {
    event.dataset = this._getProductFormEventData();
    if (event.dataset.variant) this._setIdInputValue(event.dataset.variant.id);
    if (options.onFormSubmit) options.onFormSubmit(event);
};
$3189f9ca4432b349$export$a7a5d736c2a3d416.prototype._onFormEvent = function(cb) {
    if (typeof cb === 'undefined') return Function.prototype;
    return (function(event) {
        event.dataset = this._getProductFormEventData();
        cb(event);
    }).bind(this);
};
$3189f9ca4432b349$export$a7a5d736c2a3d416.prototype._initInputs = function(selector, cb) {
    var elements = Array.prototype.slice.call(this.element.querySelectorAll(selector));
    return elements.map((function(element) {
        this._listeners.add(element, 'change', this._onFormEvent(cb));
        return element;
    }).bind(this));
};
$3189f9ca4432b349$export$a7a5d736c2a3d416.prototype._getProductFormEventData = function() {
    return {
        options: this.options(),
        variant: this.variant(),
        properties: this.properties(),
        quantity: this.quantity()
    };
};
function $3189f9ca4432b349$var$_serializeOptionValues(inputs, transform) {
    return inputs.reduce(function(options, input) {
        if (input.checked || // If input is a checked (means type radio or checkbox)
        input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
        ) options.push(transform({
            name: input.name,
            value: input.value
        }));
        return options;
    }, []);
}
function $3189f9ca4432b349$var$_serializePropertyValues(inputs, transform) {
    return inputs.reduce(function(properties, input) {
        if (input.checked || // If input is a checked (means type radio or checkbox)
        input.type !== 'radio' && input.type !== 'checkbox' // Or if its any other type of input
        ) properties[transform(input.name)] = input.value;
        return properties;
    }, {});
}
function $3189f9ca4432b349$var$_validateProductObject(product) {
    if (typeof product !== 'object') throw new TypeError(product + ' is not an object.');
    if (typeof product.variants[0].options === 'undefined') throw new TypeError('Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route');
    return product;
}

});
parcelRegister("gfx0a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd47a58084ea4555$export$2e2bcd8739ae039; });
function $bd47a58084ea4555$export$2e2bcd8739ae039() {
    this.entries = [];
}
$bd47a58084ea4555$export$2e2bcd8739ae039.prototype.add = function(element, event, fn) {
    this.entries.push({
        element: element,
        event: event,
        fn: fn
    });
    element.addEventListener(event, fn);
};
$bd47a58084ea4555$export$2e2bcd8739ae039.prototype.removeAll = function() {
    this.entries = this.entries.filter(function(listener) {
        listener.element.removeEventListener(listener.event, listener.fn);
        return false;
    });
};

});

parcelRegister("9TprG", function(module, exports) {

$parcel$export(module.exports, "getVariantFromSerializedArray", function () { return $733cfd0d0def4d9b$export$e99164525d8c6bf3; });
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */ function $733cfd0d0def4d9b$export$e89691701404cde7(handle) {
    return fetch('/products/' + handle + '.js').then(function(response) {
        return response.json();
    });
}
function $733cfd0d0def4d9b$export$e334b0fe0821374e(product, value) {
    $733cfd0d0def4d9b$var$_validateProductStructure(product);
    if (typeof value !== 'number') throw new TypeError(value + ' is not a Number.');
    var result = product.variants.filter(function(variant) {
        return variant.id === value;
    });
    return result[0] || null;
}
function $733cfd0d0def4d9b$export$e99164525d8c6bf3(product, collection) {
    $733cfd0d0def4d9b$var$_validateProductStructure(product);
    // If value is an array of options
    var optionArray = $733cfd0d0def4d9b$var$_createOptionArrayFromOptionCollection(product, collection);
    return $733cfd0d0def4d9b$export$4bac2ca76aecc1e3(product, optionArray);
}
function $733cfd0d0def4d9b$export$4bac2ca76aecc1e3(product, options) {
    $733cfd0d0def4d9b$var$_validateProductStructure(product);
    $733cfd0d0def4d9b$var$_validateOptionsArray(options);
    var result = product.variants.filter(function(variant) {
        return options.every(function(option, index) {
            return variant.options[index] === option;
        });
    });
    return result[0] || null;
}
/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */ function $733cfd0d0def4d9b$var$_createOptionArrayFromOptionCollection(product, collection) {
    $733cfd0d0def4d9b$var$_validateProductStructure(product);
    $733cfd0d0def4d9b$var$_validateSerializedArray(collection);
    var optionArray = [];
    collection.forEach(function(option) {
        for(var i = 0; i < product.options.length; i++)if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
            optionArray[i] = option.value;
            break;
        }
    });
    return optionArray;
}
/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */ function $733cfd0d0def4d9b$var$_validateProductStructure(product) {
    if (typeof product !== 'object') throw new TypeError(product + ' is not an object.');
    if (Object.keys(product).length === 0 && product.constructor === Object) throw new Error(product + ' is empty.');
}
/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */ function $733cfd0d0def4d9b$var$_validateSerializedArray(collection) {
    if (!Array.isArray(collection)) throw new TypeError(collection + ' is not an array.');
    if (collection.length === 0) return [];
    if (collection[0].hasOwnProperty('name')) {
        if (typeof collection[0].name !== 'string') throw new TypeError('Invalid value type passed for name of option ' + collection[0].name + '. Value should be string.');
    } else throw new Error(collection[0] + 'does not contain name key.');
}
/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */ function $733cfd0d0def4d9b$var$_validateOptionsArray(options) {
    if (Array.isArray(options) && typeof options[0] === 'object') throw new Error(options + 'is not a valid array of options.');
}

});


parcelRegister("2bQLV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProductVariantChangeEvent = module.exports.ProductQuantityChangeEvent = module.exports.ProductPropertyChangeEvent = module.exports.ProductOptionChangeEvent = module.exports.ProductFormEvent = module.exports.ProductEvent = void 0;
parcelRequire("4fH4F");
const $19858b40e83b7a6b$var$_excluded = [
    "product",
    "variant"
], $19858b40e83b7a6b$var$_excluded2 = [
    "form",
    "options",
    "properties",
    "quantity",
    "parentEvent"
];
function $19858b40e83b7a6b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $19858b40e83b7a6b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $19858b40e83b7a6b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $19858b40e83b7a6b$var$_defineProperty(e, r, t) {
    return (r = $19858b40e83b7a6b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $19858b40e83b7a6b$var$_toPropertyKey(t) {
    var i = $19858b40e83b7a6b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $19858b40e83b7a6b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $19858b40e83b7a6b$var$ProductEvent extends Event {
    constructor(name, _ref){
        let { product: product, variant: variant } = _ref, options = $19858b40e83b7a6b$var$_objectWithoutProperties(_ref, $19858b40e83b7a6b$var$_excluded);
        super(name, options);
        /**
     * @type {Product}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "product", null);
        /**
     * @type {ProductVariant}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "variant", null);
        if (!product) throw new Error('product is required in product event data');
        this.product = product;
        this.variant = variant;
    }
}
module.exports.ProductEvent = $19858b40e83b7a6b$var$ProductEvent;
class $19858b40e83b7a6b$var$ProductFormEvent extends $19858b40e83b7a6b$var$ProductEvent {
    constructor(name, _ref2){
        let { form: form, options: options, properties: properties, quantity: quantity, parentEvent: parentEvent } = _ref2, eventOptions = $19858b40e83b7a6b$var$_objectWithoutProperties(_ref2, $19858b40e83b7a6b$var$_excluded2);
        super(name, eventOptions);
        /**
     * @type {HTMLFormElement}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "form", null);
        /**
     * @type {object}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "options", null);
        /**
     * @type {object}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "properties", null);
        /**
     * @type {number}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "quantity", 0);
        /**
     * @type {Event}
     */ $19858b40e83b7a6b$var$_defineProperty(this, "parentEvent", null);
        if (!form) throw new Error('form is required in product form event data');
        this.form = form;
        this.options = options;
        this.properties = properties;
        this.quantity = quantity;
        this.parentEvent = parentEvent;
    }
}
module.exports.ProductFormEvent = $19858b40e83b7a6b$var$ProductFormEvent;
class $19858b40e83b7a6b$var$ProductOptionChangeEvent extends $19858b40e83b7a6b$var$ProductFormEvent {
    constructor(options){
        super('product:option:change', options);
    }
}
module.exports.ProductOptionChangeEvent = $19858b40e83b7a6b$var$ProductOptionChangeEvent;
class $19858b40e83b7a6b$var$ProductQuantityChangeEvent extends $19858b40e83b7a6b$var$ProductFormEvent {
    constructor(options){
        super('product:quantity:change', options);
    }
}
module.exports.ProductQuantityChangeEvent = $19858b40e83b7a6b$var$ProductQuantityChangeEvent;
class $19858b40e83b7a6b$var$ProductPropertyChangeEvent extends $19858b40e83b7a6b$var$ProductFormEvent {
    constructor(options){
        super('product:property:change', options);
    }
}
module.exports.ProductPropertyChangeEvent = $19858b40e83b7a6b$var$ProductPropertyChangeEvent;
class $19858b40e83b7a6b$var$ProductVariantChangeEvent extends $19858b40e83b7a6b$var$ProductFormEvent {
    constructor(options){
        super('product:variant:change', options);
    }
}
module.exports.ProductVariantChangeEvent = $19858b40e83b7a6b$var$ProductVariantChangeEvent;

});

parcelRegister("9gI3j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchFromApi = void 0;
const $6bf7c79435c83af8$var$ACCESS_TOKEN = 'a1affee3bd7be1fa995ded69d39953b6';
if (!$6bf7c79435c83af8$var$ACCESS_TOKEN) alert('Please set Storefront API access token in dev/js/components/api.js using the Headless App');
const $6bf7c79435c83af8$var$fetchFromApi = async (query)=>{
    const response = await fetch('/api/2021-10/graphql.json', {
        credentials: 'include',
        method: 'post',
        headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': $6bf7c79435c83af8$var$ACCESS_TOKEN,
            'Shopify-Search-Query-Debug': 1
        },
        body: query
    });
    return response.json();
};
module.exports.fetchFromApi = $6bf7c79435c83af8$var$fetchFromApi;

});




parcelRegister("7rvq6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $56b36d6408704387$var$_jsCookie = $56b36d6408704387$var$_interopRequireDefault((parcelRequire("gQUJc")));

var $bFxq0 = parcelRequire("bFxq0");
var $56b36d6408704387$var$_class;
function $56b36d6408704387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $56b36d6408704387$var$_defineProperty(e, r, t) {
    return (r = $56b36d6408704387$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $56b36d6408704387$var$_toPropertyKey(t) {
    var i = $56b36d6408704387$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $56b36d6408704387$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $56b36d6408704387$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $56b36d6408704387$var$NewsletterPopup = module.exports.default = ($56b36d6408704387$var$_class = class NewsletterPopup {
    constructor(){
        /**
     * @type {LiveElement}
     */ $56b36d6408704387$var$_defineProperty(this, "newsletterPopup", new $bFxq0.LiveElement('.newsletter-popup'));
        /**
     * @type {LiveElement}
     */ $56b36d6408704387$var$_defineProperty(this, "newsletterPopupCloseButton", new $bFxq0.LiveElement('.newsletter-popup__close-button'));
        this.registerListeners();
    }
    registerListeners() {
        if (!this.newsletterPopup.item) return;
        if (!$56b36d6408704387$var$_jsCookie.default.get('newsletter_popup')) setTimeout(()=>{
            this.openNewsletterPopup();
        }, 10000);
        this.newsletterPopupCloseButton.addEventListener('click', this.closeNewsletterPopup);
    }
    openNewsletterPopup() {
        this.newsletterPopup.item.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lock-scroll');
    }
    closeNewsletterPopup() {
        this.newsletterPopupCloseButton.item.blur();
        this.newsletterPopup.item.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lock-scroll');
        $56b36d6408704387$var$_jsCookie.default.set('newsletter_popup', true, {
            expires: 7
        });
    }
}, $56b36d6408704387$var$_applyDecoratedDescriptor($56b36d6408704387$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($56b36d6408704387$var$_class.prototype, "registerListeners"), $56b36d6408704387$var$_class.prototype), $56b36d6408704387$var$_applyDecoratedDescriptor($56b36d6408704387$var$_class.prototype, "openNewsletterPopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($56b36d6408704387$var$_class.prototype, "openNewsletterPopup"), $56b36d6408704387$var$_class.prototype), $56b36d6408704387$var$_applyDecoratedDescriptor($56b36d6408704387$var$_class.prototype, "closeNewsletterPopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($56b36d6408704387$var$_class.prototype, "closeNewsletterPopup"), $56b36d6408704387$var$_class.prototype), $56b36d6408704387$var$_class);

});
parcelRegister("gQUJc", function(module, exports) {
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

});


parcelRegister("1x8AP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $hRMhb = parcelRequire("hRMhb");
var $11df89e31a7c5c4b$var$_class;
function $11df89e31a7c5c4b$var$_defineProperty(e, r, t) {
    return (r = $11df89e31a7c5c4b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $11df89e31a7c5c4b$var$_toPropertyKey(t) {
    var i = $11df89e31a7c5c4b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $11df89e31a7c5c4b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $11df89e31a7c5c4b$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $11df89e31a7c5c4b$var$PhoneFormatting = module.exports.default = ($11df89e31a7c5c4b$var$_class = class PhoneFormatting {
    constructor(){
        $11df89e31a7c5c4b$var$_defineProperty(this, "phoneContainers", new $bFxq0.LiveNodeList('.telephone-format'));
        if (!this.phoneContainers) return;
        this.registerListeners();
    }
    /**
   *
   */ registerListeners() {
        this.phoneContainers.forEach((element)=>{
            this.formatPhone(element);
        });
    }
    formatPhone(element) {
        try {
            const phoneNumber = (0, $hRMhb.parsePhoneNumberWithError)(element.querySelector('.telephone-format__phone').innerText, 'GB');
            if (phoneNumber.isValid()) element.querySelector('.telephone-format__link').setAttribute('href', 'tel:' + phoneNumber.formatInternational().replace(' ', ''));
        } catch (error) {
            console.error('Error formatting phone number', error);
        }
    }
}, $11df89e31a7c5c4b$var$_applyDecoratedDescriptor($11df89e31a7c5c4b$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($11df89e31a7c5c4b$var$_class.prototype, "registerListeners"), $11df89e31a7c5c4b$var$_class.prototype), $11df89e31a7c5c4b$var$_applyDecoratedDescriptor($11df89e31a7c5c4b$var$_class.prototype, "formatPhone", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($11df89e31a7c5c4b$var$_class.prototype, "formatPhone"), $11df89e31a7c5c4b$var$_class.prototype), $11df89e31a7c5c4b$var$_class);

});
parcelRegister("hRMhb", function(module, exports) {

$parcel$export(module.exports, "parsePhoneNumberWithError", function () { return $d01cd58a82271b02$export$176bb591929cc9a8; });

var $b4K3N = parcelRequire("b4K3N");

var $3SCBY = parcelRequire("3SCBY");
function $d01cd58a82271b02$export$176bb591929cc9a8() {
    return (0, $b4K3N.default)((0, $3SCBY.default), arguments);
}

});
parcelRegister("b4K3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8103cc0c5aa1063c$export$2e2bcd8739ae039; });
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

var $e7rX8 = parcelRequire("e7rX8");
function $8103cc0c5aa1063c$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $e7rX8.default));
    return func.apply(this, args);
}

});
parcelRegister("e7rX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a47766f3d7f34ab2$export$2e2bcd8739ae039; });
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $a47766f3d7f34ab2$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-6]|7(?:0[0-689]|[1-79])|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRegister("3SCBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d345da863f7a3c4$export$2e2bcd8739ae039; });

var $2S0Ot = parcelRequire("2S0Ot");

var $1bzzB = parcelRequire("1bzzB");
function $2d345da863f7a3c4$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $1bzzB.default)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $2S0Ot.default)(text, options, metadata);
}

});
parcelRegister("2S0Ot", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21714162bf796574$export$2e2bcd8739ae039; });

var $ci4eq = parcelRequire("ci4eq");
function $21714162bf796574$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $21714162bf796574$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $21714162bf796574$var$ownKeys(Object(source), !0).forEach(function(key) {
            $21714162bf796574$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $21714162bf796574$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $21714162bf796574$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21714162bf796574$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $ci4eq.default)(text, $21714162bf796574$var$_objectSpread($21714162bf796574$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}

});
parcelRegister("ci4eq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f2a72cec86c0b07$export$2e2bcd8739ae039; });
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $lCfAV = parcelRequire("lCfAV");

var $8mlZ4 = parcelRequire("8mlZ4");

var $iDvhk = parcelRequire("iDvhk");

var $9mkf3 = parcelRequire("9mkf3");

var $kT5DY = parcelRequire("kT5DY");

var $7De70 = parcelRequire("7De70");

var $iDvhk = parcelRequire("iDvhk");

var $2cljZ = parcelRequire("2cljZ");

var $ekDGj = parcelRequire("ekDGj");

var $kp5T4 = parcelRequire("kp5T4");

var $liVMY = parcelRequire("liVMY");

var $19pcA = parcelRequire("19pcA");


var $i4YuT = parcelRequire("i4YuT");

var $7x5JU = parcelRequire("7x5JU");
// This prevents malicious input from consuming CPU.
var $8f2a72cec86c0b07$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $8f2a72cec86c0b07$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $lCfAV.PLUS_CHARS) + (0, $lCfAV.VALID_DIGITS) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $8f2a72cec86c0b07$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $lCfAV.VALID_DIGITS) + '#' + ']+$');
var $8f2a72cec86c0b07$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $8f2a72cec86c0b07$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $iDvhk.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $8mlZ4.default)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $8f2a72cec86c0b07$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $8mlZ4.default)('TOO_SHORT');
            throw new (0, $8mlZ4.default)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $8f2a72cec86c0b07$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $8mlZ4.default)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $lCfAV.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $8mlZ4.default)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $lCfAV.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $8mlZ4.default)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $ekDGj.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $kp5T4.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $8f2a72cec86c0b07$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $2cljZ.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $8f2a72cec86c0b07$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $8f2a72cec86c0b07$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $8mlZ4.default)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($8f2a72cec86c0b07$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($8f2a72cec86c0b07$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $8f2a72cec86c0b07$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $7x5JU.default)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $8f2a72cec86c0b07$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $9mkf3.default)(number)) {
        if ((0, $9mkf3.isViablePhoneNumberStart)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $kT5DY.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $8f2a72cec86c0b07$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $8f2a72cec86c0b07$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $liVMY.default)((0, $7De70.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($8f2a72cec86c0b07$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $iDvhk.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $19pcA.default)((0, $7De70.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $i4YuT.default)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRegister("lCfAV", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", function () { return $fbc93e533898030d$export$cd8355bcbe13154; });
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", function () { return $fbc93e533898030d$export$85ddd8c9b243679b; });
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", function () { return $fbc93e533898030d$export$514717690676fb4a; });
$parcel$export(module.exports, "VALID_DIGITS", function () { return $fbc93e533898030d$export$852d1d4a47329634; });
$parcel$export(module.exports, "VALID_PUNCTUATION", function () { return $fbc93e533898030d$export$7f01587e28f9194; });
$parcel$export(module.exports, "PLUS_CHARS", function () { return $fbc93e533898030d$export$207c99ccf3902df8; });
// The minimum length of the national significant number.
var $fbc93e533898030d$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $fbc93e533898030d$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $fbc93e533898030d$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $fbc93e533898030d$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $fbc93e533898030d$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $fbc93e533898030d$var$SLASHES = "\uFF0F/";
var $fbc93e533898030d$var$DOTS = "\uFF0E.";
var $fbc93e533898030d$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $fbc93e533898030d$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $fbc93e533898030d$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $fbc93e533898030d$export$7f01587e28f9194 = "".concat($fbc93e533898030d$var$DASHES).concat($fbc93e533898030d$var$SLASHES).concat($fbc93e533898030d$var$DOTS).concat($fbc93e533898030d$export$20542845033f576e).concat($fbc93e533898030d$var$BRACKETS).concat($fbc93e533898030d$var$TILDES);
var $fbc93e533898030d$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRegister("8mlZ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61616e611c4d8dd2$export$2e2bcd8739ae039; });
function $61616e611c4d8dd2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $61616e611c4d8dd2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $61616e611c4d8dd2$var$_typeof(obj);
}
function $61616e611c4d8dd2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $61616e611c4d8dd2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $61616e611c4d8dd2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $61616e611c4d8dd2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $61616e611c4d8dd2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $61616e611c4d8dd2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $61616e611c4d8dd2$var$_setPrototypeOf(subClass, superClass);
}
function $61616e611c4d8dd2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $61616e611c4d8dd2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $61616e611c4d8dd2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $61616e611c4d8dd2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $61616e611c4d8dd2$var$_possibleConstructorReturn(this, result);
    };
}
function $61616e611c4d8dd2$var$_possibleConstructorReturn(self, call) {
    if (call && ($61616e611c4d8dd2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $61616e611c4d8dd2$var$_assertThisInitialized(self);
}
function $61616e611c4d8dd2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $61616e611c4d8dd2$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $61616e611c4d8dd2$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$61616e611c4d8dd2$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $61616e611c4d8dd2$var$_construct(Class, arguments, $61616e611c4d8dd2$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $61616e611c4d8dd2$var$_setPrototypeOf(Wrapper, Class);
    };
    return $61616e611c4d8dd2$var$_wrapNativeSuper(Class);
}
function $61616e611c4d8dd2$var$_construct(Parent, args, Class) {
    if ($61616e611c4d8dd2$var$_isNativeReflectConstruct()) $61616e611c4d8dd2$var$_construct = Reflect.construct;
    else $61616e611c4d8dd2$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $61616e611c4d8dd2$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $61616e611c4d8dd2$var$_construct.apply(null, arguments);
}
function $61616e611c4d8dd2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $61616e611c4d8dd2$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $61616e611c4d8dd2$var$_setPrototypeOf(o, p) {
    $61616e611c4d8dd2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $61616e611c4d8dd2$var$_setPrototypeOf(o, p);
}
function $61616e611c4d8dd2$var$_getPrototypeOf(o) {
    $61616e611c4d8dd2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $61616e611c4d8dd2$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $61616e611c4d8dd2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $61616e611c4d8dd2$var$_inherits(ParseError, _Error);
    var _super = $61616e611c4d8dd2$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $61616e611c4d8dd2$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($61616e611c4d8dd2$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $61616e611c4d8dd2$var$_createClass(ParseError);
}(/*#__PURE__*/ $61616e611c4d8dd2$var$_wrapNativeSuper(Error));

});

parcelRegister("iDvhk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d91421c723b6e01a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getCountryCallingCode", function () { return $d91421c723b6e01a$export$32876ca2f1919cf0; });

var $4T2D9 = parcelRequire("4T2D9");

var $bJOIv = parcelRequire("bJOIv");
function $d91421c723b6e01a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d91421c723b6e01a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d91421c723b6e01a$var$_typeof(obj);
}
function $d91421c723b6e01a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d91421c723b6e01a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d91421c723b6e01a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d91421c723b6e01a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d91421c723b6e01a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $d91421c723b6e01a$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $d91421c723b6e01a$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $d91421c723b6e01a$var$V4 = '1.7.35';
var $d91421c723b6e01a$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $d91421c723b6e01a$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $d91421c723b6e01a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $d91421c723b6e01a$var$_classCallCheck(this, Metadata);
        $d91421c723b6e01a$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $d91421c723b6e01a$var$setVersion.call(this, metadata);
    }
    $d91421c723b6e01a$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $d91421c723b6e01a$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $d91421c723b6e01a$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $d91421c723b6e01a$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $d91421c723b6e01a$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $d91421c723b6e01a$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $d91421c723b6e01a$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $d91421c723b6e01a$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $d91421c723b6e01a$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $d91421c723b6e01a$var$getType(this.types(), _type2)) return new $d91421c723b6e01a$var$Type($d91421c723b6e01a$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $d91421c723b6e01a$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $d91421c723b6e01a$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $d91421c723b6e01a$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $d91421c723b6e01a$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $d91421c723b6e01a$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$d91421c723b6e01a$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $d91421c723b6e01a$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $d91421c723b6e01a$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $d91421c723b6e01a$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $d91421c723b6e01a$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $d91421c723b6e01a$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $d91421c723b6e01a$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $bJOIv.default)(metadata) || !(0, $bJOIv.default)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $bJOIv.default)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $d91421c723b6e01a$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $d91421c723b6e01a$var$typeOf = function typeOf(_) {
    return $d91421c723b6e01a$var$_typeof(_);
};
function $d91421c723b6e01a$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $d91421c723b6e01a$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $d91421c723b6e01a$var$DEFAULT_EXT_PREFIX;
}
function $d91421c723b6e01a$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $d91421c723b6e01a$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $d91421c723b6e01a$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $d91421c723b6e01a$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $4T2D9.default)(version, $d91421c723b6e01a$var$V3) === -1) this.v2 = true;
        else if ((0, $4T2D9.default)(version, $d91421c723b6e01a$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRegister("4T2D9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ee56d44aacf64b$export$2e2bcd8739ae039; });
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $38ee56d44aacf64b$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});

parcelRegister("bJOIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88bb3d0053227e12$export$2e2bcd8739ae039; });
var $88bb3d0053227e12$var$objectConstructor = {}.constructor;
function $88bb3d0053227e12$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $88bb3d0053227e12$var$objectConstructor;
}

});


parcelRegister("9mkf3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d05deb59d6c2b0b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isViablePhoneNumberStart", function () { return $6d05deb59d6c2b0b$export$4c3f76c95c05197c; });

var $lCfAV = parcelRequire("lCfAV");

var $aSHS0 = parcelRequire("aSHS0");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $6d05deb59d6c2b0b$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $lCfAV.VALID_DIGITS) + ']{' + (0, $lCfAV.MIN_LENGTH_FOR_NSN) + '}'; //
var $6d05deb59d6c2b0b$export$a77dd7471651eee = '[' + (0, $lCfAV.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $lCfAV.VALID_PUNCTUATION) + ']*' + '[' + (0, $lCfAV.VALID_DIGITS) + ']' + '){3,}' + '[' + (0, $lCfAV.VALID_PUNCTUATION) + (0, $lCfAV.VALID_DIGITS) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $6d05deb59d6c2b0b$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $lCfAV.PLUS_CHARS) + ']{0,1}' + '(?:' + '[' + (0, $lCfAV.VALID_PUNCTUATION) + ']*' + '[' + (0, $lCfAV.VALID_DIGITS) + ']' + '){1,2}' + '$', 'i');
var $6d05deb59d6c2b0b$export$a2d12a04749c087d = $6d05deb59d6c2b0b$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $aSHS0.default)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $6d05deb59d6c2b0b$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $6d05deb59d6c2b0b$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $6d05deb59d6c2b0b$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $6d05deb59d6c2b0b$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $lCfAV.MIN_LENGTH_FOR_NSN) && $6d05deb59d6c2b0b$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $6d05deb59d6c2b0b$export$4c3f76c95c05197c(number) {
    return $6d05deb59d6c2b0b$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRegister("aSHS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec0fa38ac558e3e$export$2e2bcd8739ae039; });

var $lCfAV = parcelRequire("lCfAV");
var $7ec0fa38ac558e3e$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $7ec0fa38ac558e3e$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $lCfAV.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $7ec0fa38ac558e3e$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $7ec0fa38ac558e3e$var$RFC3966_EXTN_PREFIX + $7ec0fa38ac558e3e$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $7ec0fa38ac558e3e$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $7ec0fa38ac558e3e$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $7ec0fa38ac558e3e$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $7ec0fa38ac558e3e$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $7ec0fa38ac558e3e$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRegister("kT5DY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f34d526dd31e4212$export$2e2bcd8739ae039; });

var $aSHS0 = parcelRequire("aSHS0");
// 1 or more valid digits, for use when parsing.
var $f34d526dd31e4212$var$EXTN_PATTERN = new RegExp('(?:' + (0, $aSHS0.default)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $f34d526dd31e4212$export$2e2bcd8739ae039(number) {
    var start = number.search($f34d526dd31e4212$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($f34d526dd31e4212$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRegister("7De70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e71f444f765491$export$2e2bcd8739ae039; });

var $3zzea = parcelRequire("3zzea");
function $58e71f444f765491$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $58e71f444f765491$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $58e71f444f765491$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $58e71f444f765491$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $58e71f444f765491$var$_arrayLikeToArray(o, minLen);
}
function $58e71f444f765491$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $58e71f444f765491$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $58e71f444f765491$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $58e71f444f765491$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $58e71f444f765491$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $3zzea.parseDigit)(character);
}

});
parcelRegister("3zzea", function(module, exports) {

$parcel$export(module.exports, "parseDigit", function () { return $299ff76a92d69568$export$1d16fddea1437169; });
function $299ff76a92d69568$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $299ff76a92d69568$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $299ff76a92d69568$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $299ff76a92d69568$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $299ff76a92d69568$var$_arrayLikeToArray(o, minLen);
}
function $299ff76a92d69568$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $299ff76a92d69568$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $299ff76a92d69568$export$1d16fddea1437169(character) {
    return $299ff76a92d69568$export$2848f3d68c08fe69[character];
}
function $299ff76a92d69568$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $299ff76a92d69568$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $299ff76a92d69568$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRegister("2cljZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $199d3dc4f3a6d3a1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPossibleNumber", function () { return $199d3dc4f3a6d3a1$export$4f8890cedf1e0497; });

var $iDvhk = parcelRequire("iDvhk");

var $BboYg = parcelRequire("BboYg");
function $199d3dc4f3a6d3a1$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $iDvhk.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $199d3dc4f3a6d3a1$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $199d3dc4f3a6d3a1$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $BboYg.default)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRegister("BboYg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06fc4cf7ba89691d$export$2e2bcd8739ae039; });

var $ai2aQ = parcelRequire("ai2aQ");
function $06fc4cf7ba89691d$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $06fc4cf7ba89691d$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $06fc4cf7ba89691d$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $06fc4cf7ba89691d$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $ai2aQ.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

});
parcelRegister("ai2aQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77dd45857f570fb1$export$2e2bcd8739ae039; });
function $77dd45857f570fb1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $77dd45857f570fb1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $77dd45857f570fb1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $77dd45857f570fb1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $77dd45857f570fb1$var$_arrayLikeToArray(o, minLen);
}
function $77dd45857f570fb1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $77dd45857f570fb1$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $77dd45857f570fb1$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRegister("ekDGj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6f1b6d8a2d36588$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");

var $2cljZ = parcelRequire("2cljZ");

var $drHkP = parcelRequire("drHkP");

var $dgv8C = parcelRequire("dgv8C");

var $hwq3X = parcelRequire("hwq3X");

var $n7ahl = parcelRequire("n7ahl");
function $a6f1b6d8a2d36588$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a6f1b6d8a2d36588$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a6f1b6d8a2d36588$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a6f1b6d8a2d36588$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a6f1b6d8a2d36588$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a6f1b6d8a2d36588$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a6f1b6d8a2d36588$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a6f1b6d8a2d36588$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a6f1b6d8a2d36588$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a6f1b6d8a2d36588$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a6f1b6d8a2d36588$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $a6f1b6d8a2d36588$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $a6f1b6d8a2d36588$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $a6f1b6d8a2d36588$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError('`country` or `countryCallingCode` not passed');
        if (!nationalNumber) throw new TypeError('`nationalNumber` not passed');
        if (!metadata) throw new TypeError('`metadata` not passed');
        var _getCountryAndCountry = $a6f1b6d8a2d36588$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $a6f1b6d8a2d36588$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $hwq3X.default)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $2cljZ.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $drHkP.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $iDvhk.default)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $dgv8C.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $n7ahl.default)(this, _format, options ? $a6f1b6d8a2d36588$var$_objectSpread($a6f1b6d8a2d36588$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $a6f1b6d8a2d36588$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $a6f1b6d8a2d36588$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $iDvhk.default)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($a6f1b6d8a2d36588$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($a6f1b6d8a2d36588$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}

});
parcelRegister("drHkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c9f696a1f85567b$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");

var $kp5T4 = parcelRequire("kp5T4");

var $dgv8C = parcelRequire("dgv8C");
function $9c9f696a1f85567b$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $iDvhk.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $dgv8C.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $kp5T4.default)(nationalNumber, metadata.nationalNumberPattern());
}

});
parcelRegister("kp5T4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edaab58bec5177b2$export$2e2bcd8739ae039; });
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $edaab58bec5177b2$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

});

parcelRegister("dgv8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a84ec5832b8b10e$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");

var $kp5T4 = parcelRequire("kp5T4");
function $9a84ec5832b8b10e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9a84ec5832b8b10e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a84ec5832b8b10e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9a84ec5832b8b10e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9a84ec5832b8b10e$var$_arrayLikeToArray(o, minLen);
}
function $9a84ec5832b8b10e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9a84ec5832b8b10e$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $9a84ec5832b8b10e$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $iDvhk.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $kp5T4.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($9a84ec5832b8b10e$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($9a84ec5832b8b10e$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $9a84ec5832b8b10e$var$_createForOfIteratorHelperLoose($9a84ec5832b8b10e$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($9a84ec5832b8b10e$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $9a84ec5832b8b10e$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $kp5T4.default)(nationalNumber, type.pattern());
}

});


parcelRegister("hwq3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc19a45d9896325b$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");
function $cc19a45d9896325b$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $iDvhk.default)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $cc19a45d9896325b$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $cc19a45d9896325b$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $iDvhk.default)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}

});

parcelRegister("n7ahl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0457b4dfd145a78f$export$2e2bcd8739ae039; });

var $kp5T4 = parcelRequire("kp5T4");

var $gRR05 = parcelRequire("gRR05");

var $iDvhk = parcelRequire("iDvhk");

var $hiOBN = parcelRequire("hiOBN");

var $k363p = parcelRequire("k363p");
function $0457b4dfd145a78f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0457b4dfd145a78f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0457b4dfd145a78f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0457b4dfd145a78f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0457b4dfd145a78f$var$_arrayLikeToArray(o, minLen);
}
function $0457b4dfd145a78f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0457b4dfd145a78f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0457b4dfd145a78f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0457b4dfd145a78f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0457b4dfd145a78f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0457b4dfd145a78f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0457b4dfd145a78f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0457b4dfd145a78f$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $0457b4dfd145a78f$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $0457b4dfd145a78f$var$_objectSpread($0457b4dfd145a78f$var$_objectSpread({}, $0457b4dfd145a78f$var$DEFAULT_OPTIONS), options);
    else options = $0457b4dfd145a78f$var$DEFAULT_OPTIONS;
    metadata = new (0, $iDvhk.default)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $0457b4dfd145a78f$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $0457b4dfd145a78f$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $0457b4dfd145a78f$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $0457b4dfd145a78f$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $k363p.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $0457b4dfd145a78f$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $0457b4dfd145a78f$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $0457b4dfd145a78f$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $0457b4dfd145a78f$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $gRR05.default)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $0457b4dfd145a78f$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $0457b4dfd145a78f$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $kp5T4.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $0457b4dfd145a78f$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $0457b4dfd145a78f$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $iDvhk.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $0457b4dfd145a78f$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $hiOBN.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($0457b4dfd145a78f$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}

});
parcelRegister("gRR05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47ab5548fd0a20a$export$2e2bcd8739ae039; });

var $6ePiG = parcelRequire("6ePiG");
var $c47ab5548fd0a20a$export$4f32ad1c51a7a6be = /(\$\d)/;
function $c47ab5548fd0a20a$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($c47ab5548fd0a20a$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $6ePiG.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRegister("6ePiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48abd80ed00f81dc$export$2e2bcd8739ae039; });

var $lCfAV = parcelRequire("lCfAV");
function $48abd80ed00f81dc$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $lCfAV.VALID_PUNCTUATION), "]+"), 'g'), ' ').trim();
}

});


parcelRegister("hiOBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c98b5ff0bdb278ee$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $c98b5ff0bdb278ee$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $c98b5ff0bdb278ee$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $iDvhk.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($c98b5ff0bdb278ee$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});

parcelRegister("k363p", function(module, exports) {

$parcel$export(module.exports, "formatRFC3966", function () { return $e988c8a770872ef5$export$d4f2d2bc1159d115; });

var $9mkf3 = parcelRequire("9mkf3");
function $e988c8a770872ef5$var$_slicedToArray(arr, i) {
    return $e988c8a770872ef5$var$_arrayWithHoles(arr) || $e988c8a770872ef5$var$_iterableToArrayLimit(arr, i) || $e988c8a770872ef5$var$_unsupportedIterableToArray(arr, i) || $e988c8a770872ef5$var$_nonIterableRest();
}
function $e988c8a770872ef5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e988c8a770872ef5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e988c8a770872ef5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e988c8a770872ef5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e988c8a770872ef5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e988c8a770872ef5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e988c8a770872ef5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e988c8a770872ef5$var$_arrayLikeToArray(o, minLen);
}
function $e988c8a770872ef5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e988c8a770872ef5$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $e988c8a770872ef5$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $e988c8a770872ef5$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $9mkf3.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $e988c8a770872ef5$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

});



parcelRegister("liVMY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8281b1b8276a6ca$export$2e2bcd8739ae039; });

var $8FJBT = parcelRequire("8FJBT");

var $h0hwr = parcelRequire("h0hwr");

var $iDvhk = parcelRequire("iDvhk");

var $lCfAV = parcelRequire("lCfAV");
function $f8281b1b8276a6ca$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $8FJBT.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $h0hwr.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $iDvhk.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $lCfAV.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }

});
parcelRegister("8FJBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $650588495fe5b9b1$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");

var $lCfAV = parcelRequire("lCfAV");
var $650588495fe5b9b1$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $lCfAV.VALID_DIGITS) + '])');
function $650588495fe5b9b1$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $iDvhk.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($650588495fe5b9b1$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}

});

parcelRegister("h0hwr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c610074c93345799$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");

var $kp5T4 = parcelRequire("kp5T4");

var $19pcA = parcelRequire("19pcA");

var $BboYg = parcelRequire("BboYg");

var $iDvhk = parcelRequire("iDvhk");
function $c610074c93345799$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $iDvhk.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $iDvhk.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $19pcA.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $19pcA.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $kp5T4.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $kp5T4.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $BboYg.default)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRegister("19pcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d6a2e50e6a38860$export$2e2bcd8739ae039; });

var $9Rosf = parcelRequire("9Rosf");

var $kp5T4 = parcelRequire("kp5T4");

var $BboYg = parcelRequire("BboYg");
function $0d6a2e50e6a38860$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $9Rosf.default)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$0d6a2e50e6a38860$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$0d6a2e50e6a38860$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $0d6a2e50e6a38860$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $kp5T4.default)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $kp5T4.default)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $0d6a2e50e6a38860$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $BboYg.default)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}

});
parcelRegister("9Rosf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72dc0872ceeca685$export$2e2bcd8739ae039; });
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $72dc0872ceeca685$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRegister("i4YuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d297873783262a73$export$2e2bcd8739ae039; });

var $fYWBh = parcelRequire("fYWBh");
var $d297873783262a73$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $d297873783262a73$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($d297873783262a73$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $fYWBh.default)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}

});
parcelRegister("fYWBh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba29ea638e27cd61$export$2e2bcd8739ae039; });

var $iDvhk = parcelRequire("iDvhk");

var $dgv8C = parcelRequire("dgv8C");
function $ba29ea638e27cd61$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ba29ea638e27cd61$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ba29ea638e27cd61$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ba29ea638e27cd61$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ba29ea638e27cd61$var$_arrayLikeToArray(o, minLen);
}
function $ba29ea638e27cd61$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ba29ea638e27cd61$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $iDvhk.default)(metadata);
    var matchingCountries = [];
    for(var _iterator = $ba29ea638e27cd61$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $dgv8C.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}

});


parcelRegister("7x5JU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $016a52dbafb6a92f$export$2e2bcd8739ae039; });

var $dbLYf = parcelRequire("dbLYf");

var $8mlZ4 = parcelRequire("8mlZ4");
function $016a52dbafb6a92f$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $dbLYf.default)(numberToParse);
    if (!(0, $dbLYf.isPhoneContextValid)(phoneContext)) throw new (0, $8mlZ4.default)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $dbLYf.PLUS_SIGN)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $dbLYf.RFC3966_PREFIX_));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $dbLYf.RFC3966_PREFIX_).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $dbLYf.RFC3966_PHONE_CONTEXT_));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $dbLYf.RFC3966_ISDN_SUBADDRESS_));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}

});
parcelRegister("dbLYf", function(module, exports) {

$parcel$export(module.exports, "PLUS_SIGN", function () { return $99a183701a548a57$export$1ddc7eed78155f68; });
$parcel$export(module.exports, "RFC3966_PREFIX_", function () { return $99a183701a548a57$export$70d485ce3f6de783; });
$parcel$export(module.exports, "RFC3966_PHONE_CONTEXT_", function () { return $99a183701a548a57$export$f6d5879d582c3a27; });
$parcel$export(module.exports, "RFC3966_ISDN_SUBADDRESS_", function () { return $99a183701a548a57$export$9e356e12edb00a81; });
$parcel$export(module.exports, "default", function () { return $99a183701a548a57$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPhoneContextValid", function () { return $99a183701a548a57$export$474a4aa22ad6959a; });
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $lCfAV = parcelRequire("lCfAV");
var $99a183701a548a57$export$1ddc7eed78155f68 = '+';
var $99a183701a548a57$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $99a183701a548a57$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $lCfAV.VALID_DIGITS) + ']' + '|' + $99a183701a548a57$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $99a183701a548a57$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $99a183701a548a57$export$1ddc7eed78155f68 + $99a183701a548a57$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $lCfAV.VALID_DIGITS) + ']' + $99a183701a548a57$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $99a183701a548a57$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($99a183701a548a57$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $99a183701a548a57$var$ALPHANUM_ = (0, $lCfAV.VALID_DIGITS);
var $99a183701a548a57$var$RFC3966_DOMAINLABEL_ = '[' + $99a183701a548a57$var$ALPHANUM_ + ']+((\\-)*[' + $99a183701a548a57$var$ALPHANUM_ + '])*';
var $99a183701a548a57$var$VALID_ALPHA_ = 'a-zA-Z';
var $99a183701a548a57$var$RFC3966_TOPLABEL_ = '[' + $99a183701a548a57$var$VALID_ALPHA_ + ']+((\\-)*[' + $99a183701a548a57$var$ALPHANUM_ + '])*';
var $99a183701a548a57$var$RFC3966_DOMAINNAME_ = '^(' + $99a183701a548a57$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $99a183701a548a57$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $99a183701a548a57$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($99a183701a548a57$var$RFC3966_DOMAINNAME_, 'g');
var $99a183701a548a57$export$70d485ce3f6de783 = 'tel:';
var $99a183701a548a57$export$f6d5879d582c3a27 = ';phone-context=';
var $99a183701a548a57$export$9e356e12edb00a81 = ';isub=';
function $99a183701a548a57$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($99a183701a548a57$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $99a183701a548a57$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $99a183701a548a57$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $99a183701a548a57$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $99a183701a548a57$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

});




parcelRegister("1bzzB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dd269a7456fa0ea$export$2e2bcd8739ae039; });

var $bJOIv = parcelRequire("bJOIv");
function $0dd269a7456fa0ea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0dd269a7456fa0ea$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0dd269a7456fa0ea$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0dd269a7456fa0ea$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0dd269a7456fa0ea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0dd269a7456fa0ea$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0dd269a7456fa0ea$var$_slicedToArray(arr, i) {
    return $0dd269a7456fa0ea$var$_arrayWithHoles(arr) || $0dd269a7456fa0ea$var$_iterableToArrayLimit(arr, i) || $0dd269a7456fa0ea$var$_unsupportedIterableToArray(arr, i) || $0dd269a7456fa0ea$var$_nonIterableRest();
}
function $0dd269a7456fa0ea$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0dd269a7456fa0ea$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0dd269a7456fa0ea$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0dd269a7456fa0ea$var$_arrayLikeToArray(o, minLen);
}
function $0dd269a7456fa0ea$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0dd269a7456fa0ea$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0dd269a7456fa0ea$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0dd269a7456fa0ea$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $0dd269a7456fa0ea$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $0dd269a7456fa0ea$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $bJOIv.default)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}

});




parcelRegister("2qKNe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $4fH4F = parcelRequire("4fH4F");

var $1c524e99a72a6966$var$_productDataCache = $1c524e99a72a6966$var$_interopRequireDefault((parcelRequire("2hsI2")));

var $2bQLV = parcelRequire("2bQLV");

var $1c524e99a72a6966$var$_productForm = $1c524e99a72a6966$var$_interopRequireDefault((parcelRequire("etbRz")));

var $RGSzv = parcelRequire("RGSzv");
var $1c524e99a72a6966$var$_class, $1c524e99a72a6966$var$_Product;
function $1c524e99a72a6966$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $1c524e99a72a6966$var$_defineProperty(e, r, t) {
    return (r = $1c524e99a72a6966$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1c524e99a72a6966$var$_toPropertyKey(t) {
    var i = $1c524e99a72a6966$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1c524e99a72a6966$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1c524e99a72a6966$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $1c524e99a72a6966$var$Product = module.exports.default = ($1c524e99a72a6966$var$_class = ($1c524e99a72a6966$var$_Product = class Product {
    constructor(){
        /**
     * @type {LiveNodeList<HTMLFormElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productForms", new $bFxq0.LiveNodeList('form[action*="/cart/add"]'));
        /**
     * @type {LiveElement<HTMLElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productBuyBar", new $bFxq0.LiveElement('.product-buy-bar'));
        /**
     * @type {LiveElement<HTMLButtonElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productDropRodModalTrigger", new $bFxq0.LiveElement('.product-options__drop-rod-modal-trigger'));
        /**
     * @type {LiveElement<HTMLElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productDropRodModals", new $bFxq0.LiveNodeList('.product-options__drop-rod-length-modal, .product-options__drop-rod-length-help'));
        /**
     * @type {LiveElement<HTMLButtonElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productDropRodModalClose", new $bFxq0.LiveElement('.product-options__drop-rod-length-modal-close'));
        /**
     * @type {LiveNodeList<HTMLButtonElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productImages", new $bFxq0.LiveNodeList('.product__image-grid-item'));
        /**
     * @type {LiveElement<HTMLDivElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productSlideshowModal", new $bFxq0.LiveElement('.product__slideshow-container'));
        /**
     * @type {LiveElement<HTMLUListElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productSlideshow", new $bFxq0.LiveElement('#product-slideshow'));
        /**
     * @type {LiveElement<HTMLButtonElement>}
     */ $1c524e99a72a6966$var$_defineProperty(this, "productSlideshowClose", new $bFxq0.LiveElement('.product-slideshow__close'));
        this.productForms.items.forEach(this.init);
        this.registerListeners();
    }
    registerListeners() {
        this.productForms.on('update', (newItems)=>{
            newItems.forEach(this.init);
        });
        this.productBuyBar.addDelegatedEventListener(window, 'scroll', ()=>{
            const form = this.productBuyBar.item.closest('.product-content-form');
            const { top: top, height: height } = form.getBoundingClientRect();
            this.productBuyBar.item.setAttribute('aria-hidden', (top + height > 0).toString());
        });
        this.productDropRodModalTrigger.addEventListener('click', (event)=>{
            event.preventDefault();
            const hidden = this.productDropRodModals.items[0]?.getAttribute('aria-hidden') === 'true';
            this.productDropRodModalTrigger.item?.setAttribute('aria-expanded', hidden ? 'true' : 'false');
            this.productDropRodModals.forEach((item)=>item?.setAttribute('aria-hidden', hidden ? 'false' : 'true'));
        });
        this.productDropRodModalClose.addEventListener('click', (event)=>{
            event.preventDefault();
            this.productDropRodModals.forEach((item)=>item?.setAttribute('aria-hidden', 'true'));
        });
        this.productImages.addEventListener('click', (event)=>{
            const image = event.currentTarget || event.target;
            this.productSlideshowModal.item?.setAttribute('aria-hidden', 'false');
            setTimeout(()=>{
                (0, $RGSzv.goToSlide)(this.productSlideshow.item, image.dataset.index);
            }, 5);
        });
        this.productSlideshowClose.addEventListener('click', (event)=>{
            this.productSlideshowModal.item?.setAttribute('aria-hidden', 'true');
        });
    }
    async init(form) {
        const handle = form.dataset.productHandle;
        const product = await this.constructor.cache.get(handle);
        const variant = product.variants.find((variant)=>parseInt(variant.id) === parseInt(form.dataset.variantId));
        const params = new URLSearchParams(window.location.search);
        const properties = {};
        params.entries().forEach(([key, value])=>{
            if (key.startsWith('properties[')) {
                const propertyName = key.replace(/properties\[(.*?)\]/, '$1');
                properties[propertyName] = value;
            }
        });
        form.shopifyProductForm = new $4fH4F.ProductForm(form, product, {
            onOptionChange: (event)=>{
                form.dispatchEvent(new $2bQLV.ProductOptionChangeEvent({
                    form: form,
                    options: event.dataset.options,
                    product: product,
                    properties: event.dataset.properties,
                    quantity: event.dataset.quantity,
                    variant: event.dataset.variant,
                    parentEvent: event
                }));
            },
            onQuantityChange: (event)=>{
                form.dispatchEvent(new $2bQLV.ProductQuantityChangeEvent({
                    form: form,
                    options: event.dataset.options,
                    product: product,
                    properties: event.dataset.properties,
                    quantity: event.dataset.quantity,
                    variant: event.dataset.variant,
                    parentEvent: event
                }));
            },
            onPropertyChange: (event)=>{
                form.dispatchEvent(new $2bQLV.ProductPropertyChangeEvent({
                    form: form,
                    options: event.dataset.options,
                    product: product,
                    properties: event.dataset.properties,
                    quantity: event.dataset.quantity,
                    variant: event.dataset.variant,
                    parentEvent: event
                }));
            }
        });
        form.productForm = new $1c524e99a72a6966$var$_productForm.default(form, product, variant, properties);
    }
}, $1c524e99a72a6966$var$_defineProperty($1c524e99a72a6966$var$_Product, "cache", new $1c524e99a72a6966$var$_productDataCache.default()), $1c524e99a72a6966$var$_Product), $1c524e99a72a6966$var$_applyDecoratedDescriptor($1c524e99a72a6966$var$_class.prototype, "init", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($1c524e99a72a6966$var$_class.prototype, "init"), $1c524e99a72a6966$var$_class.prototype), $1c524e99a72a6966$var$_class);

});
parcelRegister("2hsI2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("4fH4F");
function $1a9370642632fb76$var$_defineProperty(e, r, t) {
    return (r = $1a9370642632fb76$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1a9370642632fb76$var$_toPropertyKey(t) {
    var i = $1a9370642632fb76$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1a9370642632fb76$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $1a9370642632fb76$var$ProductDataCache {
    constructor(){
        /**
     * @type {Map<string, Product>}
     */ $1a9370642632fb76$var$_defineProperty(this, "cache", new Map());
    }
    async get(handle) {
        const product = this.cache.get(handle);
        if (product) return product;
        const response = await fetch(`/products/${handle}.js`, {
            credentials: 'include'
        });
        const productData = await response.json();
        this.cache.set(handle, productData);
        return productData;
    }
}
module.exports.default = $1a9370642632fb76$var$ProductDataCache;

});

parcelRegister("RGSzv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unregisterSlideshow = module.exports.silentlySetCurrentSlide = module.exports.setCurrentSlide = module.exports.registerSlideshow = module.exports.isHorizontal = module.exports.isCentered = module.exports.goToSlide = module.exports.getScrollProgress = void 0;

var $bFxq0 = parcelRequire("bFxq0");
function $0a163643e435bdde$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a163643e435bdde$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a163643e435bdde$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0a163643e435bdde$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a163643e435bdde$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a163643e435bdde$var$_defineProperty(e, r, t) {
    return (r = $0a163643e435bdde$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0a163643e435bdde$var$_toPropertyKey(t) {
    var i = $0a163643e435bdde$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0a163643e435bdde$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0a163643e435bdde$var$getScrollProgress = (target)=>{
    if (target.scrollWidth === target.clientWidth) return -1;
    return target.scrollLeft / (target.scrollWidth - target.clientWidth - 5);
};
module.exports.getScrollProgress = $0a163643e435bdde$var$getScrollProgress;
const $0a163643e435bdde$var$goToSlide = (element, index)=>{
    const child = element.children[index];
    const scrollOptions = {
        left: element.horizontal ? element.centered ? child.offsetLeft + element.clientWidth / 2 - child.clientWidth / 2 : child.offsetLeft : 0,
        top: element.horizontal ? 0 : element.centered ? child.offsetTop + element.clientHeight / 2 - child.clientHeight / 2 : child.offsetTop
    };
    element?.scrollTo($0a163643e435bdde$var$_objectSpread({
        behavior: 'smooth'
    }, scrollOptions));
};
module.exports.goToSlide = $0a163643e435bdde$var$goToSlide;
const $0a163643e435bdde$var$isHorizontal = (element)=>window.getComputedStyle(element).scrollSnapType.startsWith('x');
module.exports.isHorizontal = $0a163643e435bdde$var$isHorizontal;
const $0a163643e435bdde$var$isCentered = (element)=>{
    if (!element.firstElementChild) return false;
    return window.getComputedStyle(element.firstElementChild).scrollSnapAlign === 'center';
};
module.exports.isCentered = $0a163643e435bdde$var$isCentered;
const $0a163643e435bdde$var$setCurrentSlide = (element)=>{
    if (!element) return;
    const direction = element.scrollLeft > element.previousScroll ? 'right' : 'left';
    let gap = parseFloat(window.getComputedStyle(element).gap || 0);
    if (isNaN(gap)) gap = 0;
    const horizontal = element.horizontal;
    const centered = element.centered;
    let padding = parseFloat(window.getComputedStyle(element)[horizontal ? 'paddingLeft' : 'paddingTop']) || 0;
    if (isNaN(padding)) padding = 0;
    const containerEdge = element.getBoundingClientRect()[horizontal ? 'left' : 'top'] + padding;
    let newElement;
    const offset = 25;
    for (let child of element.slides.items){
        const edge = child.getBoundingClientRect()[horizontal ? 'left' : 'top'] - containerEdge;
        if (centered) {
            const centeredEdge = edge - child.clientWidth / 2;
            const threshold = horizontal ? element.clientWidth / 2 : element.clientHeight / 2;
            if (centeredEdge >= 0 && centeredEdge < threshold) newElement = child;
        } else {
            const threshold = direction === 'right' ? (horizontal ? child.clientWidth : child.clientHeight) - gap - offset : 0 + gap + offset;
            if (edge >= 0 - threshold) newElement = child;
        }
        if (newElement) break;
    }
    const current = element.querySelector('[aria-current="true"]');
    if (current) current.removeAttribute('aria-current');
    if (newElement) newElement.setAttribute('aria-current', 'true');
    element.previousScroll = element.scrollLeft;
};
module.exports.setCurrentSlide = $0a163643e435bdde$var$setCurrentSlide;
const $0a163643e435bdde$var$silentlySetCurrentSlide = (element)=>{
    if (!element) return;
    element.style.scrollBehavior = 'auto';
    $0a163643e435bdde$var$setCurrentSlide(element);
    setTimeout(()=>{
        delete element.style.scrollBehavior;
    }, 10);
};
module.exports.silentlySetCurrentSlide = $0a163643e435bdde$var$silentlySetCurrentSlide;
const $0a163643e435bdde$var$registerSlideshow = (control, config = {})=>{
    const id = control.getAttribute('aria-controls');
    const target = document.getElementById(id);
    control.slideshow = target;
    if (!target.slides) target.slides = new $bFxq0.LiveNodeList(`:scope > [aria-hidden="false"], :scope > :not([aria-hidden])`, target, {
        attributes: true,
        attributeFilter: [
            'aria-hidden'
        ]
    });
    if (!target.currentSlide) target.currentSlide = new $bFxq0.LiveElement(`:scope > [aria-current="true"]`, target, {
        attributes: true,
        attributeFilter: [
            'aria-current'
        ]
    });
    target.horizontal = $0a163643e435bdde$var$isHorizontal(target);
    target.centered = $0a163643e435bdde$var$isCentered(target);
    target.slides.on('update', $0a163643e435bdde$var$silentlySetCurrentSlide.bind(void 0, target));
    target.addEventListener('scroll', $0a163643e435bdde$var$silentlySetCurrentSlide.bind(void 0, target));
    window.addEventListener('resize', $0a163643e435bdde$var$silentlySetCurrentSlide.bind(void 0, target));
    $0a163643e435bdde$var$silentlySetCurrentSlide(target);
    if (config.onUpdateChildren) {
        target.slides.on('update', config.onUpdateChildren);
        config.onUpdateChildren();
    }
    if (config.onChange) {
        target.currentSlide.on('update', config.onChange);
        config.onChange();
    }
    if (config.onScroll) {
        target.slides.on('update', config.onScroll);
        target.addEventListener('scroll', config.onScroll);
        config.onScroll();
    }
};
module.exports.registerSlideshow = $0a163643e435bdde$var$registerSlideshow;
const $0a163643e435bdde$var$unregisterSlideshow = (control, config = {})=>{
    const id = control.getAttribute('aria-controls');
    const target = document.getElementById(id);
    if (!target) return;
    if (target.slides) target.slides.off('update', $0a163643e435bdde$var$silentlySetCurrentSlide.bind(void 0, target));
    target.removeEventListener('scroll', $0a163643e435bdde$var$silentlySetCurrentSlide.bind(void 0, target));
    if (config.onUpdateChildren && target.slides) target.slides.off('update', config.onUpdateChildren);
    if (config.onScroll) target.removeEventListener('scroll', config.onScroll);
};
module.exports.unregisterSlideshow = $0a163643e435bdde$var$unregisterSlideshow;

});


parcelRegister("dnf5d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $9bc91f8567b9261f$var$_jsCookie = $9bc91f8567b9261f$var$_interopRequireDefault((parcelRequire("gQUJc")));

var $bFxq0 = parcelRequire("bFxq0");
var $9bc91f8567b9261f$var$_class;
function $9bc91f8567b9261f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $9bc91f8567b9261f$var$_defineProperty(e, r, t) {
    return (r = $9bc91f8567b9261f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9bc91f8567b9261f$var$_toPropertyKey(t) {
    var i = $9bc91f8567b9261f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9bc91f8567b9261f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9bc91f8567b9261f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $9bc91f8567b9261f$var$PromoBar = module.exports.default = ($9bc91f8567b9261f$var$_class = class PromoBar {
    constructor(){
        /**
     * @type {LiveElement}
     */ $9bc91f8567b9261f$var$_defineProperty(this, "promoBar", new $bFxq0.LiveElement('.promo-bar'));
        this.registerListeners();
        this.promoBar.on('update', ()=>{
            this.registerListeners();
        });
    }
    registerListeners() {
        if (!this.promoBar.item) return;
        if (!$9bc91f8567b9261f$var$_jsCookie.default.get('promo_bar')) {
            this.openPromoBar();
            this.closeButton = this.promoBar.item.querySelector('.promo-bar__close');
            if (this.closeButton) this.closeButton.addEventListener('click', this.closePromoBar);
        }
    }
    openPromoBar() {
        this.promoBar.item.setAttribute('aria-hidden', 'false');
        this.promoBarItems = this.promoBar.item.querySelectorAll('.promo-bar__row');
        if (this.promoBarItems.length > 1) {
            let counter = 1;
            const i = setInterval(()=>{
                this.promoBarItems.forEach((item)=>{
                    item.classList.remove('promo-bar__row--active');
                });
                this.promoBarItems[counter].classList.add('promo-bar__row--active');
                counter++;
                if (counter === this.promoBarItems.length) counter = 0;
            }, this.promoBar.item.dataset.rotationSpeed * 1000);
        }
    }
    closePromoBar() {
        $9bc91f8567b9261f$var$_jsCookie.default.set('promo_bar', true, {
            expires: 7
        });
        this.promoBar.item.setAttribute('aria-hidden', 'true');
    }
}, $9bc91f8567b9261f$var$_applyDecoratedDescriptor($9bc91f8567b9261f$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($9bc91f8567b9261f$var$_class.prototype, "registerListeners"), $9bc91f8567b9261f$var$_class.prototype), $9bc91f8567b9261f$var$_applyDecoratedDescriptor($9bc91f8567b9261f$var$_class.prototype, "openPromoBar", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($9bc91f8567b9261f$var$_class.prototype, "openPromoBar"), $9bc91f8567b9261f$var$_class.prototype), $9bc91f8567b9261f$var$_applyDecoratedDescriptor($9bc91f8567b9261f$var$_class.prototype, "closePromoBar", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($9bc91f8567b9261f$var$_class.prototype, "closePromoBar"), $9bc91f8567b9261f$var$_class.prototype), $9bc91f8567b9261f$var$_class);

});

parcelRegister("lm8TI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $f8c28de9145f28b0$var$_liveNodeList = $f8c28de9145f28b0$var$_interopRequireDefault((parcelRequire("bFxq0")));
var $f8c28de9145f28b0$var$_class;
function $f8c28de9145f28b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $f8c28de9145f28b0$var$_defineProperty(e, r, t) {
    return (r = $f8c28de9145f28b0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f8c28de9145f28b0$var$_toPropertyKey(t) {
    var i = $f8c28de9145f28b0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f8c28de9145f28b0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f8c28de9145f28b0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $f8c28de9145f28b0$var$QuantityIncrementor = module.exports.default = ($f8c28de9145f28b0$var$_class = class QuantityIncrementor {
    constructor(){
        $f8c28de9145f28b0$var$_defineProperty(this, "incrementors", new $f8c28de9145f28b0$var$_liveNodeList.default('.quantity-incrementor'));
        this.registerListeners();
    }
    registerListeners() {
        this.incrementors.forEach(this.initIncrementor);
        this.incrementors.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.initIncrementor);
        });
        this.incrementors.addDelegatedEventListener(document, 'cart:processing:start', (event)=>{
            this.incrementors.forEach((incrementor)=>{
                if ('lineItem' in event) {
                    if ('lineId' in incrementor.dataset && parseInt(incrementor.dataset.lineId, 10) === event.lineItem?.lineId || 'productId' in incrementor.dataset && parseInt(incrementor.dataset.productId, 10) === event.lineItem?.productId) return this.disable(incrementor);
                    return;
                }
                this.disable(incrementor);
            });
        });
        this.incrementors.addDelegatedEventListener(document, 'cart:processing:end', (event)=>{
            this.incrementors.forEach((incrementor)=>{
                this.enable(incrementor);
            });
        });
        this.incrementors.addDelegatedEventListener(document, 'cart:error', (_)=>{
            this.incrementors.forEach((incrementor)=>{
                this.enable(incrementor);
            });
        });
    }
    disable(incrementor) {
        incrementor.querySelectorAll('button, input').forEach((item)=>{
            item.setAttribute('disabled', 'disabled');
        });
    }
    enable(incrementor) {
        incrementor.querySelectorAll('button, input').forEach((item)=>{
            item.removeAttribute('disabled');
        });
    }
    initIncrementor(incrementor) {
        const plus = incrementor.querySelector('.quantity-incrementor__plus');
        const minus = incrementor.querySelector('.quantity-incrementor__minus');
        const input = incrementor.querySelector('.quantity-incrementor__input');
        const lineId = parseInt(incrementor.dataset.lineId, 10);
        let min;
        let max;
        const resetMinMax = ()=>{
            min = parseInt(input.getAttribute('min'), 10);
            max = parseInt(input.getAttribute('max'), 10);
            if (isNaN(min)) min = 1;
            if (isNaN(max)) max = 999;
        };
        const minmax = (value)=>{
            if (value < min) return min;
            if (value > max) return max;
            return value;
        };
        const updateButtonState = ()=>{
            if (max === 0) [
                input,
                minus,
                plus
            ].forEach((item)=>{
                item.setAttribute('disabled', 'disabled');
            });
            else [
                input,
                minus,
                plus
            ].forEach((item)=>{
                item.removeAttribute('disabled');
            });
            if (parseInt(input.value, 10) === min) minus.setAttribute('disabled', 'disabled');
            else minus.removeAttribute('disabled');
            if (parseInt(input.value, 10) === max) plus.setAttribute('disabled', 'disabled');
            else plus.removeAttribute('disabled');
        };
        plus.addEventListener('click', (e)=>{
            e.preventDefault();
            clearTimeout(this.timer);
            let value = parseInt(input.value, 10);
            value = isNaN(value) ? min : value;
            value++;
            input.value = minmax(value);
            input.dispatchEvent(new Event('change'));
        });
        minus.addEventListener('click', (e)=>{
            e.preventDefault();
            clearTimeout(this.timer);
            let value = parseInt(input.value, 10);
            if (value > 0) {
                value = isNaN(value) ? min : value;
                value--;
                input.value = minmax(value);
                input.dispatchEvent(new Event('change'));
            }
        });
        input.addEventListener('change', (e)=>{
            if (parseInt(input.value, 10) === min) minus.setAttribute('disabled', 'disabled');
            else minus.removeAttribute('disabled');
            if (parseInt(input.value, 10) === max) plus.setAttribute('disabled', 'disabled');
            else plus.removeAttribute('disabled');
        });
        input.addEventListener('keyup', (e)=>{
            e.preventDefault();
            clearTimeout(this.timer);
            let value = parseInt(input.value, 10);
            input.value = minmax(value);
            input.dispatchEvent(new Event('change'));
        });
        input.addEventListener('change', (e)=>{
            updateButtonState();
            this.updateSiteCart(lineId, parseInt(input.value, 10));
            input.closest('[data-product-form]')?.dispatchEvent(new Event('product:quantity:change'));
        });
        const form = input.closest('form');
        if (form) form.addEventListener('product:variant:change', (event)=>{
            resetMinMax();
            updateButtonState();
            let value = parseInt(input.value, 10);
            input.value = minmax(value);
            input.dispatchEvent(new Event('change'));
        });
        resetMinMax();
        updateButtonState();
    }
    async updateSiteCart(lineId, value) {
        if (lineId) this.timer = setTimeout((e)=>{
            window.app.components.cartApi.updateLineItem(lineId, value);
        }, 500);
    }
}, $f8c28de9145f28b0$var$_applyDecoratedDescriptor($f8c28de9145f28b0$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f8c28de9145f28b0$var$_class.prototype, "registerListeners"), $f8c28de9145f28b0$var$_class.prototype), $f8c28de9145f28b0$var$_applyDecoratedDescriptor($f8c28de9145f28b0$var$_class.prototype, "disable", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f8c28de9145f28b0$var$_class.prototype, "disable"), $f8c28de9145f28b0$var$_class.prototype), $f8c28de9145f28b0$var$_applyDecoratedDescriptor($f8c28de9145f28b0$var$_class.prototype, "enable", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f8c28de9145f28b0$var$_class.prototype, "enable"), $f8c28de9145f28b0$var$_class.prototype), $f8c28de9145f28b0$var$_applyDecoratedDescriptor($f8c28de9145f28b0$var$_class.prototype, "initIncrementor", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f8c28de9145f28b0$var$_class.prototype, "initIncrementor"), $f8c28de9145f28b0$var$_class.prototype), $f8c28de9145f28b0$var$_applyDecoratedDescriptor($f8c28de9145f28b0$var$_class.prototype, "updateSiteCart", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($f8c28de9145f28b0$var$_class.prototype, "updateSiteCart"), $f8c28de9145f28b0$var$_class.prototype), $f8c28de9145f28b0$var$_class);

});

parcelRegister("4EdiZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $RGSzv = parcelRequire("RGSzv");
var $36253804f50d2fa1$var$_class;
function $36253804f50d2fa1$var$_defineProperty(e, r, t) {
    return (r = $36253804f50d2fa1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $36253804f50d2fa1$var$_toPropertyKey(t) {
    var i = $36253804f50d2fa1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $36253804f50d2fa1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $36253804f50d2fa1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $36253804f50d2fa1$var$SlideshowButtons = module.exports.default = ($36253804f50d2fa1$var$_class = class SlideshowButtons {
    constructor(){
        $36253804f50d2fa1$var$_defineProperty(this, "buttons", new $bFxq0.LiveNodeList('.slideshow-button'));
        this.registerListeners();
    }
    registerListeners() {
        this.buttons.addEventListener('click', this.scrollToTarget);
        this.buttons.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.registerSlideshow);
            oldItems.forEach(this.unregisterSlideshow);
        });
        this.buttons.forEach(this.registerSlideshow);
    }
    registerSlideshow(item) {
        const target1 = document.getElementById(item.getAttribute('aria-controls'));
        (0, $RGSzv.registerSlideshow)(item, {
            onScroll: this.handleScroll.bind(this, item, target1)
        });
    }
    unregisterSlideshow(item) {
        unregisterSlideshow(item, {
            onScroll: this.handleScroll.bind(this, item, target)
        });
    }
    scrollToTarget(e) {
        const target1 = e.currentTarget || e.target;
        const action = target1.dataset.action;
        const targetElement = document.getElementById(target1.getAttribute('aria-controls'));
        if (!targetElement) return;
        const current = targetElement.querySelector('[aria-current="true"]') || targetElement.firstElementChild;
        let newElement = current[`${action}ElementSibling`];
        while(newElement?.getAttribute('aria-hidden') === 'true')newElement = newElement[`${action}ElementSibling`];
        if (!newElement) return;
        (0, $RGSzv.goToSlide)(targetElement, [
            ...targetElement.children
        ].indexOf(newElement));
    }
    handleScroll(item, target1) {
        const progress = (0, $RGSzv.getScrollProgress)(target1);
        if (item.dataset.action === 'previous') {
            if (progress <= 0) item.setAttribute('disabled', 'disabled');
            else item.removeAttribute('disabled');
        }
        if (item.dataset.action === 'next') {
            if (progress >= 1) item.setAttribute('disabled', 'disabled');
            else item.removeAttribute('disabled');
        }
    }
}, $36253804f50d2fa1$var$_applyDecoratedDescriptor($36253804f50d2fa1$var$_class.prototype, "registerSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($36253804f50d2fa1$var$_class.prototype, "registerSlideshow"), $36253804f50d2fa1$var$_class.prototype), $36253804f50d2fa1$var$_applyDecoratedDescriptor($36253804f50d2fa1$var$_class.prototype, "unregisterSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($36253804f50d2fa1$var$_class.prototype, "unregisterSlideshow"), $36253804f50d2fa1$var$_class.prototype), $36253804f50d2fa1$var$_applyDecoratedDescriptor($36253804f50d2fa1$var$_class.prototype, "scrollToTarget", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($36253804f50d2fa1$var$_class.prototype, "scrollToTarget"), $36253804f50d2fa1$var$_class.prototype), $36253804f50d2fa1$var$_applyDecoratedDescriptor($36253804f50d2fa1$var$_class.prototype, "handleScroll", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($36253804f50d2fa1$var$_class.prototype, "handleScroll"), $36253804f50d2fa1$var$_class.prototype), $36253804f50d2fa1$var$_class);

});

parcelRegister("lMD4b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $RGSzv = parcelRequire("RGSzv");
var $fdbc6277f6d62861$var$_class;
function $fdbc6277f6d62861$var$_defineProperty(e, r, t) {
    return (r = $fdbc6277f6d62861$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fdbc6277f6d62861$var$_toPropertyKey(t) {
    var i = $fdbc6277f6d62861$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fdbc6277f6d62861$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fdbc6277f6d62861$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $fdbc6277f6d62861$var$SlideshowPagination = module.exports.default = ($fdbc6277f6d62861$var$_class = class SlideshowPagination {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $fdbc6277f6d62861$var$_defineProperty(this, "paginationItems", new $bFxq0.LiveNodeList('.slideshow-pagination'));
        this.registerListeners();
    }
    registerListeners() {
        this.paginationItems.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.registerSlideshow);
            oldItems.forEach(this.unregisterSlideshow);
        });
        this.paginationItems.forEach(this.registerSlideshow);
    }
    registerSlideshow(item) {
        const target1 = document.getElementById(item.getAttribute('aria-controls'));
        (0, $RGSzv.registerSlideshow)(item, {
            onScroll: this.handleScroll.bind(this, item, target1),
            onUpdateChildren: this.createChildren.bind(this, item, target1)
        });
        window.addEventListener('resize', this.handleResize.bind(this, item, target1));
    }
    unregisterSlideshow(item) {
        unregisterSlideshow(item, {
            onScroll: this.handleScroll.bind(this, item, target),
            onUpdateChildren: ()=>{
                this.createChildren(item, target).then((_)=>{
                    this.handleScroll(item, target);
                });
            }
        });
        window.removeEventListener('resize', this.handleResize.bind(this, item, target));
    }
    handleResize(item, target1, event) {
        clearTimeout(item.resizeCallback);
        item.resizeCallback = setTimeout(()=>{
            this.createChildren(item, target1).then((_)=>{
                this.handleScroll(item, target1);
            });
        }, 250);
    }
    createChildren(item, target1) {
        return new Promise((resolve, reject)=>{
            const perPage = window.matchMedia('(min-width: 63.75em)').matches ? item.dataset.perPage : item.dataset.perPageMobile;
            item.innerHTML = '';
            let j = 0;
            Array.prototype.forEach.call(target1.slides.items, (child, i)=>{
                const k = Array.from(target1.children).indexOf(child);
                if (i % perPage === 0) {
                    const dummy = document.createElement('div');
                    dummy.innerHTML = `
                <button class="slideshow-pagination__item" data-index="${k}">
                  <span class="screenreader-text">Go to slide ${j}</span>
                </button>
              `;
                    const button = dummy.firstElementChild;
                    button.addEventListener('click', ()=>(0, $RGSzv.goToSlide)(target1, button.dataset.index));
                    item.appendChild(button);
                    j++;
                }
            });
            item.setAttribute('aria-hidden', (item.children.length <= 1).toString());
            resolve();
        });
    }
    handleScroll(item, target1, event) {
        const selected = target1.querySelector('[aria-current="true"]');
        const index = Array.from(target1.children).indexOf(selected);
        const children = Array.from(item.querySelectorAll('.slideshow-pagination__item'));
        children.forEach((child)=>child.setAttribute('aria-current', 'false'));
        let current = children[0];
        for (let child of children)if (parseInt(child.dataset.index) >= index) {
            current = child;
            break;
        }
        if (current) current.setAttribute('aria-current', 'true');
    }
}, $fdbc6277f6d62861$var$_applyDecoratedDescriptor($fdbc6277f6d62861$var$_class.prototype, "registerSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($fdbc6277f6d62861$var$_class.prototype, "registerSlideshow"), $fdbc6277f6d62861$var$_class.prototype), $fdbc6277f6d62861$var$_applyDecoratedDescriptor($fdbc6277f6d62861$var$_class.prototype, "unregisterSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($fdbc6277f6d62861$var$_class.prototype, "unregisterSlideshow"), $fdbc6277f6d62861$var$_class.prototype), $fdbc6277f6d62861$var$_applyDecoratedDescriptor($fdbc6277f6d62861$var$_class.prototype, "handleResize", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($fdbc6277f6d62861$var$_class.prototype, "handleResize"), $fdbc6277f6d62861$var$_class.prototype), $fdbc6277f6d62861$var$_applyDecoratedDescriptor($fdbc6277f6d62861$var$_class.prototype, "createChildren", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($fdbc6277f6d62861$var$_class.prototype, "createChildren"), $fdbc6277f6d62861$var$_class.prototype), $fdbc6277f6d62861$var$_applyDecoratedDescriptor($fdbc6277f6d62861$var$_class.prototype, "handleScroll", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($fdbc6277f6d62861$var$_class.prototype, "handleScroll"), $fdbc6277f6d62861$var$_class.prototype), $fdbc6277f6d62861$var$_class);

});

parcelRegister("50HSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $RGSzv = parcelRequire("RGSzv");
var $3a5efccfc61b8cf1$var$_class;
function $3a5efccfc61b8cf1$var$_defineProperty(e, r, t) {
    return (r = $3a5efccfc61b8cf1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3a5efccfc61b8cf1$var$_toPropertyKey(t) {
    var i = $3a5efccfc61b8cf1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3a5efccfc61b8cf1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3a5efccfc61b8cf1$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $3a5efccfc61b8cf1$var$SlideshowProgress = module.exports.default = ($3a5efccfc61b8cf1$var$_class = class SlideshowProgress {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $3a5efccfc61b8cf1$var$_defineProperty(this, "progressBars", new $bFxq0.LiveNodeList('.slideshow-progress'));
        this.registerListeners();
    }
    registerListeners() {
        this.progressBars.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.registerSlideshow);
            oldItems.forEach(this.unregisterSlideshow);
        });
        this.progressBars.forEach(this.registerSlideshow);
    }
    registerSlideshow(item) {
        const target1 = document.getElementById(item.getAttribute('aria-controls'));
        (0, $RGSzv.registerSlideshow)(item, {
            onScroll: this.handleScroll.bind(this, item, target1)
        });
    }
    unregisterSlideshow(item) {
        unregisterSlideshow(item, {
            onScroll: this.handleScroll.bind(this, item, target)
        });
    }
    handleScroll(item, target1) {
        const progress = (0, $RGSzv.getScrollProgress)(target1);
        item.querySelector('.slideshow-progress__value').style.width = `${progress * 100}%`;
    }
}, $3a5efccfc61b8cf1$var$_applyDecoratedDescriptor($3a5efccfc61b8cf1$var$_class.prototype, "registerSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($3a5efccfc61b8cf1$var$_class.prototype, "registerSlideshow"), $3a5efccfc61b8cf1$var$_class.prototype), $3a5efccfc61b8cf1$var$_applyDecoratedDescriptor($3a5efccfc61b8cf1$var$_class.prototype, "unregisterSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($3a5efccfc61b8cf1$var$_class.prototype, "unregisterSlideshow"), $3a5efccfc61b8cf1$var$_class.prototype), $3a5efccfc61b8cf1$var$_applyDecoratedDescriptor($3a5efccfc61b8cf1$var$_class.prototype, "handleScroll", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($3a5efccfc61b8cf1$var$_class.prototype, "handleScroll"), $3a5efccfc61b8cf1$var$_class.prototype), $3a5efccfc61b8cf1$var$_class);

});

parcelRegister("2vkhr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bFxq0 = parcelRequire("bFxq0");
function $1d2e3541ab6d36b0$var$_defineProperty(e, r, t) {
    return (r = $1d2e3541ab6d36b0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1d2e3541ab6d36b0$var$_toPropertyKey(t) {
    var i = $1d2e3541ab6d36b0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1d2e3541ab6d36b0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $1d2e3541ab6d36b0$var$Video {
    constructor(){
        $1d2e3541ab6d36b0$var$_defineProperty(this, "videos", new $bFxq0.LiveNodeList('.video video'));
        $1d2e3541ab6d36b0$var$_defineProperty(this, "videoContainers", new $bFxq0.LiveNodeList('.video'));
        $1d2e3541ab6d36b0$var$_defineProperty(this, "playButtons", new $bFxq0.LiveNodeList('.video__play'));
        this.registerListeners();
    }
    registerListeners() {
        this.videos.addEventListener('play', (evt)=>{
            const video = evt.currentTarget || evt.target;
            const container = video.closest('.video');
            container.classList.add('video--playing');
        });
        this.videoContainers.addEventListener('click', (evt)=>{
            evt.preventDefault();
            const container = evt.currentTarget || evt.target;
            const video = container.querySelector('video');
            if (video.querySelector('source')) {
                if (container.classList.contains('video--playing')) {
                    container.classList.remove('video--playing');
                    video.pause();
                } else {
                    container.classList.add('video--playing');
                    video.play();
                }
            }
        });
    }
}
module.exports.default = $1d2e3541ab6d36b0$var$Video;

});

parcelRegister("9ZCHO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7467d5b3955682e9$var$_liveNodeList = $7467d5b3955682e9$var$_interopRequireDefault((parcelRequire("bFxq0")));

var $bfbrY = parcelRequire("bfbrY");

var $99Uv1 = parcelRequire("99Uv1");
var $7467d5b3955682e9$var$_class;
function $7467d5b3955682e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $7467d5b3955682e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7467d5b3955682e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7467d5b3955682e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7467d5b3955682e9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7467d5b3955682e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7467d5b3955682e9$var$_defineProperty(e, r, t) {
    return (r = $7467d5b3955682e9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7467d5b3955682e9$var$_toPropertyKey(t) {
    var i = $7467d5b3955682e9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7467d5b3955682e9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7467d5b3955682e9$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
/**
 * Creates an Intersection observer to lazy load videos
 * matching a specific selector. Videos matching selector
 * must have either an `data-src` or `data-srcset` attribute.
 * After the video is successfully loaded, both `data-src` and
 * `data-srcset` attributes are removed, allowing before and
 * after states to be styled in CSS
 *
 * @type {VideoLazyLoader}
 */ let $7467d5b3955682e9$var$VideoLazyLoader = module.exports.default = ($7467d5b3955682e9$var$_class = class VideoLazyLoader {
    /**
   * Create the lazy loader instance
   *
   * @param {string} selector
   * @param {object} config
   */ constructor(selector, config = {}){
        /**
     * The default config for lazy loader instances
     *
     * @type {object}
     */ $7467d5b3955682e9$var$_defineProperty(this, "config", {
            // If the video gets within 50px in the Y axis, start the download.
            rootMargin: '100px 0px',
            threshold: [
                0,
                0.25,
                0.5,
                0.75,
                1
            ],
            trackVisibility: true,
            delay: 100
        });
        /**
     * @type {string}
     */ $7467d5b3955682e9$var$_defineProperty(this, "containerSelector", '.lazy-load-container');
        /**
     * The selector used to gather videos
     *
     * @type {String}
     */ $7467d5b3955682e9$var$_defineProperty(this, "selector", null);
        /**
     * The node list in which we'll store all the videos
     * to be lazy loaded
     *
     * @type {NodeList}
     */ $7467d5b3955682e9$var$_defineProperty(this, "videos", null);
        /**
     * A node list containing lazy load containers
     *
     * @type {NodeList}
     */ $7467d5b3955682e9$var$_defineProperty(this, "containers", null);
        /**
     * The IntersectionObserver instance powering this lazy loader
     *
     * @type {IntersectionObserver}
     */ $7467d5b3955682e9$var$_defineProperty(this, "observer", null);
        /**
     * @type {boolean}
     */ $7467d5b3955682e9$var$_defineProperty(this, "paused", false);
        this.selector = selector;
        // Merge optional config with the default
        this.config = $7467d5b3955682e9$var$_objectSpread($7467d5b3955682e9$var$_objectSpread({}, this.config), config);
        this.collect();
        this.videos.forEach((video)=>{
            if ((0, $99Uv1.isInViewport)(video)) this.load(video);
        });
        // Create the IntersectionObserver instance and observe each
        // of the videos and containers matching our selector
        this.observer = new IntersectionObserver(this.intersect, this.config);
        this.observe();
    }
    /**
   * Collect videos and containers on the page to be lazy loaded
   */ collect() {
        // Select all the videos to be lazy loaded
        this.videos = new $7467d5b3955682e9$var$_liveNodeList.default(this.selector);
        this.containers = new $7467d5b3955682e9$var$_liveNodeList.default(this.containerSelector);
        this.videos.on('update', (newItems, oldItems)=>{
            oldItems.forEach((item)=>this.observer.unobserve(item));
            newItems.forEach((item)=>this.observer.observe(item));
        });
        this.containers.on('update', (newItems, oldItems)=>{
            oldItems.forEach((item)=>this.observer.unobserve(item));
            newItems.forEach((item)=>this.observer.observe(item));
        });
    }
    /**
   * Begin observation for each of the collected elements
   */ observe() {
        this.videos.forEach((video)=>this.observer.observe(video));
        this.containers.forEach((container)=>this.observer.observe(container));
    }
    /**
   * Begin observation for each of the collected elements
   */ unobserve() {
        this.videos.forEach((video)=>this.observer.unobserve(video));
        this.containers.forEach((container)=>this.observer.unobserve(container));
    }
    /**
   * Handle a list of entries when an intersection occurs
   *
   * @param {Array} entries
   */ intersect(entries) {
        if (this.paused) return;
        // Loop through the entries
        entries.forEach((entry)=>{
            // Are we in viewport?
            if (entry.isIntersecting && entry.intersectionRatio > 0) {
                // If the entry is a container, load all the videos within it
                if (entry.target.matches(this.containerSelector)) {
                    Promise.all(Array.prototype.map.call(entry.target.querySelectorAll(this.selector), this.load)).then(()=>{
                        this.observer.unobserve(entry.target);
                    });
                    return;
                }
                this.load(entry.target).then(()=>{
                    // Stop watching and load the video
                    this.observer.unobserve(entry.target);
                }).catch((_)=>{
                    this.observer.unobserve(entry.target);
                });
            }
        });
    }
    /**
   * Load an video
   *
   * @param {HTMLVideoElement} video
   */ load(video) {
        return new Promise((resolve, reject)=>{
            // Remove the data-src and data-srcset attributes when
            // the video has successfully loaded
            video.addEventListener('play', ()=>{
                requestAnimationFrame(()=>{
                    video.classList.add('playing');
                    video.removeAttribute('data-lazy-load-src');
                });
                // If video is within a slideshow, trigger a transition to ensure that
                // the slide is in the correct position. This is necessary because until
                // the video is loaded the slide may be of an incorrect size
                const slideshow = video.closest('.slideshow');
                if (slideshow && slideshow.magicRoundabout) slideshow.magicRoundabout.transition();
                resolve(true);
            });
            video.addEventListener('canplay', ()=>{
                if (video.autoplay) video.play().catch((_)=>{
                    video.dispatchEvent(new ErrorEvent('error'));
                });
            });
            video.addEventListener('error', (e)=>{
                reject(e);
            });
            // Set the srcset or src attribute on the video.
            // We prefer srcset if it is defined
            if ('srcset' in video && 'lazyLoadSrcset' in video.dataset) video.srcset = video.dataset.lazyLoadSrcset;
            else if ('lazyLoadSrc' in video.dataset) video.src = video.dataset.lazyLoadSrc;
            video.load();
            const videoParent = video.parentNode;
            if (videoParent.classList.contains('autoplay-video')) {
                var p = video.play();
                if (p !== undefined) p.then((_)=>{
                    // Autoplay started!
                    videoParent.classList.remove('autoplay-video--off');
                }).catch((error)=>{
                    // Autoplay not allowed!
                    // Mute video and try to play again
                    videoParent.classList.add('autoplay-video--off');
                // Show something in the UI that the video is muted
                });
                const button = videoParent.querySelector('.autoplay-video__button');
                button.addEventListener('click', (e)=>{
                    video.play();
                    videoParent.classList.remove('autoplay-video--off');
                });
            }
        });
    }
    /**
   * Unobserve the current list of videos and reselect all videos on the page
   *
   * @return {void}
   */ refreshVideos() {
        this.unobserve();
        this.collect();
        this.observe();
    }
    /**
   * @return {void}
   */ pause() {
        this.paused = true;
    }
    /**
   * @return {void}
   */ unpause() {
        this.paused = false;
    }
}, $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "collect", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "collect"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "observe", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "observe"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "unobserve", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "unobserve"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "intersect", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "intersect"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "load", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "load"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "refreshVideos", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "refreshVideos"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "pause", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "pause"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_applyDecoratedDescriptor($7467d5b3955682e9$var$_class.prototype, "unpause", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($7467d5b3955682e9$var$_class.prototype, "unpause"), $7467d5b3955682e9$var$_class.prototype), $7467d5b3955682e9$var$_class);

});

parcelRegister("2hcZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $1a87405413b1e568$var$_class;
function $1a87405413b1e568$var$_defineProperty(e, r, t) {
    return (r = $1a87405413b1e568$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1a87405413b1e568$var$_toPropertyKey(t) {
    var i = $1a87405413b1e568$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1a87405413b1e568$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1a87405413b1e568$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $1a87405413b1e568$var$PredictiveSearch = module.exports.default = ($1a87405413b1e568$var$_class = class PredictiveSearch {
    constructor(){
        /**
     * @type {LiveElement}
     */ $1a87405413b1e568$var$_defineProperty(this, "form", new $bFxq0.LiveElement('.search-form'));
        /**
     * @type {LiveElement}
     */ $1a87405413b1e568$var$_defineProperty(this, "input", new $bFxq0.LiveElement('.search-form-input'));
        /**
     * @type {LiveElement}
     */ $1a87405413b1e568$var$_defineProperty(this, "closeButton", new $bFxq0.LiveElement('.search-form__results-close'));
        /**
     * @type {LiveElement}
     */ $1a87405413b1e568$var$_defineProperty(this, "results", new $bFxq0.LiveElement('.search-form__results'));
        /**
     * @type {LiveElement}
     */ $1a87405413b1e568$var$_defineProperty(this, "resultsInner", new $bFxq0.LiveElement('.search-form__results-inner'));
        this.registerListeners();
    }
    registerListeners() {
        this.input.addEventListener('input', this.onChange.bind(this));
        this.input.addEventListener('focus', this.onChange.bind(this));
        this.form.addEventListener('focusin', this.onChange.bind(this));
        // this.form.addEventListener('focusout', this.close)
        this.results.addEventListener('click', this.close);
        this.resultsInner.addEventListener('click', (e)=>e.stopPropagation());
        this.closeButton.addEventListener('click', (event)=>{
            const button = event.currentTarget || event.target;
            button.blur();
            this.close();
        });
    }
    async onChange(event) {
        let target = event.currentTarget || event.target;
        if (target === this.form.item) target = target.querySelector('input[name="q"]');
        const resultsBox = this.form.item.querySelector('.predictive-search-results');
        const term = target.value?.trim();
        if (!term || !term.length) {
            this.close();
            return;
        } else this.open();
        const results = await this.getSearchResults(term);
        resultsBox.innerHTML = '';
        resultsBox.appendChild(results);
    }
    async getSearchResults(term) {
        const response = await fetch(`/search/suggest?q=${term}&section_id=predictive-search`);
        if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
        }
        const responseText = await response.text();
        const dummy = document.createElement('div');
        dummy.innerHTML = responseText;
        const cylindoViewers = dummy.querySelectorAll('cylindo-viewer');
        cylindoViewers.forEach((viewer)=>{
            const load = ()=>{
                const image = viewer.shadowRoot?.querySelector('cylindo-three-sixty')?.shadowRoot.querySelector('img') || viewer.shadowRoot?.querySelector('img');
                image?.addEventListener('load', ()=>{
                    viewer.setAttribute('aria-hidden', 'false');
                });
                viewer.features = JSON.parse(viewer.dataset.features);
                viewer.removeEventListener('loaded', load);
            };
            viewer.addEventListener('loaded', load);
            setTimeout(()=>{
                load();
                viewer.removeEventListener('loaded', load);
            }, 2000);
        });
        return dummy.querySelector('#shopify-section-predictive-search');
    }
    open() {
        this.results.item.setAttribute('aria-hidden', 'false');
    }
    close() {
        this.results.item.setAttribute('aria-hidden', 'true');
    }
}, $1a87405413b1e568$var$_applyDecoratedDescriptor($1a87405413b1e568$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($1a87405413b1e568$var$_class.prototype, "registerListeners"), $1a87405413b1e568$var$_class.prototype), $1a87405413b1e568$var$_applyDecoratedDescriptor($1a87405413b1e568$var$_class.prototype, "getSearchResults", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($1a87405413b1e568$var$_class.prototype, "getSearchResults"), $1a87405413b1e568$var$_class.prototype), $1a87405413b1e568$var$_applyDecoratedDescriptor($1a87405413b1e568$var$_class.prototype, "open", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($1a87405413b1e568$var$_class.prototype, "open"), $1a87405413b1e568$var$_class.prototype), $1a87405413b1e568$var$_applyDecoratedDescriptor($1a87405413b1e568$var$_class.prototype, "close", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($1a87405413b1e568$var$_class.prototype, "close"), $1a87405413b1e568$var$_class.prototype), $1a87405413b1e568$var$_class);

});

parcelRegister("3Qemy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $RGSzv = parcelRequire("RGSzv");
var $2cc15e91d04a6085$var$_class;
function $2cc15e91d04a6085$var$_defineProperty(e, r, t) {
    return (r = $2cc15e91d04a6085$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2cc15e91d04a6085$var$_toPropertyKey(t) {
    var i = $2cc15e91d04a6085$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2cc15e91d04a6085$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2cc15e91d04a6085$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $2cc15e91d04a6085$var$SlideshowThumbnails = module.exports.default = ($2cc15e91d04a6085$var$_class = class SlideshowThumbnails {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $2cc15e91d04a6085$var$_defineProperty(this, "thumbnailItems", new $bFxq0.LiveNodeList('.slideshow-thumbnails'));
        this.registerListeners();
    }
    registerListeners() {
        this.thumbnailItems.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.registerSlideshow);
            oldItems.forEach(this.unregisterSlideshow);
        });
        this.thumbnailItems.forEach(this.registerSlideshow);
    }
    registerSlideshow(item) {
        const target1 = document.getElementById(item.getAttribute('aria-controls'));
        (0, $RGSzv.registerSlideshow)(item, {
            onScroll: this.handleScroll.bind(this, item, target1)
        });
        window.addEventListener('resize', this.handleResize.bind(this, item, target1));
        item.querySelectorAll('.slideshow-thumbnails__item').forEach((button)=>{
            button.addEventListener('click', ()=>(0, $RGSzv.goToSlide)(target1, button.dataset.index));
        });
    }
    unregisterSlideshow(item) {
        unregisterSlideshow(item, {
            onScroll: this.handleScroll.bind(this, item, target),
            onUpdateChildren: ()=>{
                this.handleScroll(item, target);
            }
        });
        window.removeEventListener('resize', this.handleResize.bind(this, item, target));
    }
    handleResize(item, target1, event) {
        clearTimeout(item.resizeCallback);
        item.resizeCallback = setTimeout(()=>{
            this.handleScroll(item, target1);
        }, 250);
    }
    handleScroll(item, target1, event) {
        const selected = target1.querySelector('[aria-current="true"]');
        const index = Array.from(target1.children).indexOf(selected);
        const children = Array.from(item.querySelectorAll('.slideshow-thumbnails__item'));
        children.forEach((child)=>child.setAttribute('aria-current', 'false'));
        let current = children[0];
        for (let child of children)if (parseInt(child.dataset.index) >= index) {
            current = child;
            break;
        }
        current.setAttribute('aria-current', 'true');
        (0, $RGSzv.goToSlide)(item, current.dataset.index);
    }
}, $2cc15e91d04a6085$var$_applyDecoratedDescriptor($2cc15e91d04a6085$var$_class.prototype, "registerSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($2cc15e91d04a6085$var$_class.prototype, "registerSlideshow"), $2cc15e91d04a6085$var$_class.prototype), $2cc15e91d04a6085$var$_applyDecoratedDescriptor($2cc15e91d04a6085$var$_class.prototype, "unregisterSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($2cc15e91d04a6085$var$_class.prototype, "unregisterSlideshow"), $2cc15e91d04a6085$var$_class.prototype), $2cc15e91d04a6085$var$_applyDecoratedDescriptor($2cc15e91d04a6085$var$_class.prototype, "handleResize", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($2cc15e91d04a6085$var$_class.prototype, "handleResize"), $2cc15e91d04a6085$var$_class.prototype), $2cc15e91d04a6085$var$_applyDecoratedDescriptor($2cc15e91d04a6085$var$_class.prototype, "handleScroll", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($2cc15e91d04a6085$var$_class.prototype, "handleScroll"), $2cc15e91d04a6085$var$_class.prototype), $2cc15e91d04a6085$var$_class);

});

parcelRegister("85F5i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $RGSzv = parcelRequire("RGSzv");
var $5e3ea8d90d7072b0$var$_class;
function $5e3ea8d90d7072b0$var$_defineProperty(e, r, t) {
    return (r = $5e3ea8d90d7072b0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5e3ea8d90d7072b0$var$_toPropertyKey(t) {
    var i = $5e3ea8d90d7072b0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5e3ea8d90d7072b0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $5e3ea8d90d7072b0$var$SlideshowScrollbar = module.exports.default = ($5e3ea8d90d7072b0$var$_class = class SlideshowScrollbar {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $5e3ea8d90d7072b0$var$_defineProperty(this, "scrollbars", new $bFxq0.LiveNodeList('.slideshow-scrollbar'));
        this.registerListeners();
    }
    registerListeners() {
        this.scrollbars.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.registerSlideshow);
            oldItems.forEach(this.unregisterSlideshow);
        });
        this.scrollbars.addEventListener('input', this.handleChange);
        this.scrollbars.addEventListener('change', this.handleChange);
        // this.scrollbars.addEventListener('pointermove', this.handleChange)
        this.scrollbars.addEventListener('pointerdown', this.disableSnapping);
        this.scrollbars.addEventListener('pointerup', this.enableSnapping);
        this.scrollbars.forEach(this.registerSlideshow);
        this.scrollbars.addDelegatedEventListener(window, 'resize', ()=>{
            this.scrollbars.forEach(this.setSliderWidth);
        });
    }
    registerSlideshow(control) {
        const slideshow = document.getElementById(control.getAttribute('aria-controls'));
        if (!control || !slideshow) return;
        this.setSliderWidth(control);
        (0, $RGSzv.registerSlideshow)(control, {
            onScroll: this.handleScroll.bind(this, control, slideshow),
            onUpdateChildren: this.setSliderWidth.bind(this, control)
        });
    }
    setSliderWidth(control) {
        const slideshow = control.slideshow || document.getElementById(control.getAttribute('aria-controls'));
        const size = (slideshow.horizontal ? slideshow.clientWidth / slideshow.scrollWidth : slideshow.clientHeight / slideshow.scrollHeight) * 100;
        if (!isNaN(size) && size !== 100) control.style.setProperty('--scrollbar-thumb-width', `${size}%`);
    }
    unregisterSlideshow(control) {
        const slideshow = document.getElementById(control.getAttribute('aria-controls'));
        (0, $RGSzv.unregisterSlideshow)(control, {
            onScroll: this.handleScroll.bind(this, control, slideshow)
        });
    }
    handleScroll(control, slideshow) {
        // if (control === document.activeElement) {
        //   return
        // }
        const progress = (0, $RGSzv.getScrollProgress)(slideshow);
        control.value = `${progress * 100}`;
        control.setAttribute('aria-valuenow', `${progress * 100}`);
    }
    handleChange(event) {
        const control = event.currentTarget || event.target;
        const slideshow = control.slideshow || document.getElementById(control.getAttribute('aria-controls'));
        if (!control || !slideshow) return;
        const value = (slideshow.horizontal ? slideshow.scrollWidth - slideshow.clientWidth : slideshow.scrollHeight - slideshow.clientHeight) * (parseFloat(control.value) / 100);
        const scrollOptions = slideshow.horizontal ? {
            left: value
        } : {
            top: value
        };
        slideshow.scrollTo(scrollOptions);
    }
    disableSnapping(event) {
        const control = event.currentTarget || event.target;
        const slideshow = control.slideshow || document.getElementById(control.getAttribute('aria-controls'));
        slideshow.setAttribute('aria-grabbed', 'true');
        slideshow.style.scrollSnapType = 'none';
        slideshow.style.scrollBehavior = 'smooth';
    }
    enableSnapping(event) {
        const control = event.currentTarget || event.target;
        const slideshow = control.slideshow || document.getElementById(control.getAttribute('aria-controls'));
        slideshow.setAttribute('aria-grabbed', 'false');
        const children = [
            ...slideshow.children
        ];
        setTimeout(()=>{
            slideshow.style.scrollSnapType = null;
            slideshow.style.scrollBehavior = null;
            control.blur();
        }, 25);
    }
}, $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "registerSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "registerSlideshow"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "setSliderWidth", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "setSliderWidth"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "unregisterSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "unregisterSlideshow"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "handleScroll", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "handleScroll"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "handleChange", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "handleChange"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "disableSnapping", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "disableSnapping"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_applyDecoratedDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "enableSnapping", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($5e3ea8d90d7072b0$var$_class.prototype, "enableSnapping"), $5e3ea8d90d7072b0$var$_class.prototype), $5e3ea8d90d7072b0$var$_class);

});

parcelRegister("kkyPf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $ecd0b0842a8c9e41$var$_class;
function $ecd0b0842a8c9e41$var$_defineProperty(e, r, t) {
    return (r = $ecd0b0842a8c9e41$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ecd0b0842a8c9e41$var$_toPropertyKey(t) {
    var i = $ecd0b0842a8c9e41$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ecd0b0842a8c9e41$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ecd0b0842a8c9e41$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $ecd0b0842a8c9e41$var$CollectionHeader = module.exports.default = ($ecd0b0842a8c9e41$var$_class = class CollectionHeader {
    constructor(){
        $ecd0b0842a8c9e41$var$_defineProperty(this, "toggles", new $bFxq0.LiveNodeList('.collection-header__description-toggle'));
        this.registerListeners();
    }
    registerListeners() {
        this.toggles.addEventListener('click', this.handleClick);
    }
    handleClick(event) {
        const target = event.currentTarget || event.target;
        target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    }
}, $ecd0b0842a8c9e41$var$_applyDecoratedDescriptor($ecd0b0842a8c9e41$var$_class.prototype, "handleClick", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($ecd0b0842a8c9e41$var$_class.prototype, "handleClick"), $ecd0b0842a8c9e41$var$_class.prototype), $ecd0b0842a8c9e41$var$_class);

});

parcelRegister("c1PA8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $RGSzv = parcelRequire("RGSzv");
var $8c1d971f526a10d4$var$_class;
function $8c1d971f526a10d4$var$_defineProperty(e, r, t) {
    return (r = $8c1d971f526a10d4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8c1d971f526a10d4$var$_toPropertyKey(t) {
    var i = $8c1d971f526a10d4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8c1d971f526a10d4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8c1d971f526a10d4$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $8c1d971f526a10d4$var$SlideshowCount = module.exports.default = ($8c1d971f526a10d4$var$_class = class SlideshowCount {
    constructor(){
        $8c1d971f526a10d4$var$_defineProperty(this, "items", new $bFxq0.LiveNodeList('.slideshow-count'));
        this.registerListeners();
    }
    registerListeners() {
        this.items.on('update', (newItems, oldItems)=>{
            newItems.forEach(this.registerSlideshow);
            oldItems.forEach(this.unregisterSlideshow);
        });
        this.items.forEach(this.registerSlideshow);
    }
    registerSlideshow(item) {
        const target1 = document.getElementById(item.getAttribute('aria-controls'));
        (0, $RGSzv.registerSlideshow)(item, {
            onChange: this.updateCount.bind(this, item, target1),
            onUpdateChildren: this.updateTotal.bind(this, item, target1)
        });
    }
    unregisterSlideshow(item) {
        (0, $RGSzv.unregisterSlideshow)(item, {
            onChange: this.updateCount.bind(this, item, target),
            onUpdateChildren: this.updateTotal.bind(this, item, target)
        });
    }
    updateCount(item, target1) {
        const element = item.querySelector('.slideshow-count__current');
        element.innerHTML = `${[
            ...target1.slides.items
        ].indexOf(target1.currentSlide.item) + 1}`.padStart(2, '0');
    }
    updateTotal(item, target1) {
        const element = item.querySelector('.slideshow-count__total');
        element.innerHTML = `${target1.slides.length}`.padStart(2, '0');
    }
}, $8c1d971f526a10d4$var$_applyDecoratedDescriptor($8c1d971f526a10d4$var$_class.prototype, "registerSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($8c1d971f526a10d4$var$_class.prototype, "registerSlideshow"), $8c1d971f526a10d4$var$_class.prototype), $8c1d971f526a10d4$var$_applyDecoratedDescriptor($8c1d971f526a10d4$var$_class.prototype, "unregisterSlideshow", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($8c1d971f526a10d4$var$_class.prototype, "unregisterSlideshow"), $8c1d971f526a10d4$var$_class.prototype), $8c1d971f526a10d4$var$_applyDecoratedDescriptor($8c1d971f526a10d4$var$_class.prototype, "updateCount", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($8c1d971f526a10d4$var$_class.prototype, "updateCount"), $8c1d971f526a10d4$var$_class.prototype), $8c1d971f526a10d4$var$_applyDecoratedDescriptor($8c1d971f526a10d4$var$_class.prototype, "updateTotal", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($8c1d971f526a10d4$var$_class.prototype, "updateTotal"), $8c1d971f526a10d4$var$_class.prototype), $8c1d971f526a10d4$var$_class);

});

parcelRegister("4gw5u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");

var $hPUPb = parcelRequire("hPUPb");

var $9gI3j = parcelRequire("9gI3j");

var $31b18bf87f0afc42$var$_collectionProduct = $31b18bf87f0afc42$var$_interopRequireDefault((parcelRequire("btEtU")));

var $31b18bf87f0afc42$var$_productDataCache = $31b18bf87f0afc42$var$_interopRequireDefault((parcelRequire("2hsI2")));
var $31b18bf87f0afc42$var$_class;
function $31b18bf87f0afc42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $31b18bf87f0afc42$var$_defineProperty(e, r, t) {
    return (r = $31b18bf87f0afc42$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $31b18bf87f0afc42$var$_toPropertyKey(t) {
    var i = $31b18bf87f0afc42$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $31b18bf87f0afc42$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $31b18bf87f0afc42$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $31b18bf87f0afc42$var$RecentlyViewed = module.exports.default = ($31b18bf87f0afc42$var$_class = class RecentlyViewed {
    constructor(){
        $31b18bf87f0afc42$var$_defineProperty(this, "cache", new $31b18bf87f0afc42$var$_productDataCache.default());
        /**
     * Product ids for recently viewed products, most recent first
     *
     * @type {Set<string>}
     */ $31b18bf87f0afc42$var$_defineProperty(this, "ids", new Set([]));
        /**
     * @type {LiveNodeList}
     */ $31b18bf87f0afc42$var$_defineProperty(this, "sections", new $bFxq0.LiveNodeList('.recently-viewed'));
        this.populateRecentlyViewed();
        if (document.body.classList.contains('template-product')) this.addToRecentlyViewed();
        this.fetchProducts();
        this.registerListeners();
    }
    registerListeners() {
        this.sections.on('update', (newItems, oldItems)=>{
            this.fetchProducts(newItems);
        });
    }
    populateRecentlyViewed() {
        const recentlyViewed = sessionStorage.getItem('recentlyViewed');
        if (recentlyViewed) this.ids = new Set(JSON.parse(recentlyViewed));
    }
    async fetchProducts(sections = this.sections.items) {
        if (this.ids.size <= 1) return;
        const query = (0, $hPUPb.productsByIdQuery)([
            ...this.ids
        ], 20);
        const response = await (0, $9gI3j.fetchFromApi)(query);
        const products = response.data.products.edges.map((edge)=>{
            const product = edge.node;
            product.variants = product.variants.edges.map((variant)=>variant.node);
            product.images = product.images.edges.map((image)=>image.node);
            return product;
        });
        if (window.theme.customer.b2b === true) await this.injectTradePrices(products);
        products.sort((a, b)=>{
            const aIndex = [
                ...this.ids
            ].indexOf(a.id);
            const bIndex = [
                ...this.ids
            ].indexOf(b.id);
            return aIndex - bIndex;
        });
        const html = products.map((product)=>{
            if (product.product___separate_variants?.value === 'true') return product.variants.map((variant)=>{
                return (0, $31b18bf87f0afc42$var$_collectionProduct.default)(product, variant);
            }).join('\n');
            return (0, $31b18bf87f0afc42$var$_collectionProduct.default)(product);
        });
        sections.forEach((section)=>{
            const container = section.querySelector('.collection__list');
            container.innerHTML = html.join('');
            container.querySelectorAll('cylindo-viewer').forEach((viewer)=>{
                viewer.features = JSON.parse(viewer.dataset.features);
            });
        });
    }
    async injectTradePrices(products = []) {
        return Promise.all(products.map(async (product)=>{
            const productJson = await this.cache.get(product.handle);
            product.priceRange.minVariantPrice.amount = productJson.price_min / 100;
            product.priceRange.maxVariantPrice.amount = productJson.price_max / 100;
            product.compareAtPriceRange.minVariantPrice.amount = (productJson.compare_at_price_min / 100).toFixed(2);
            product.compareAtPriceRange.maxVariantPrice.amount = (productJson.compare_at_price_max / 100).toFixed(2);
            product.variants.forEach((variant)=>{
                const variantJson = productJson.variants.find((v)=>v.id === variant.id.replace('gid://shopify/ProductVariant/', ''));
                if (variantJson) variant.price = (variantJson.price / 100).toFixed(2);
            });
            return product;
        }));
    }
    addToRecentlyViewed() {
        const id = document.querySelector('[data-product-form]').dataset.productId;
        this.ids = new Set([
            id,
            ...this.ids
        ]);
        sessionStorage.setItem('recentlyViewed', JSON.stringify([
            ...this.ids
        ]));
    }
}, $31b18bf87f0afc42$var$_applyDecoratedDescriptor($31b18bf87f0afc42$var$_class.prototype, "registerListeners", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($31b18bf87f0afc42$var$_class.prototype, "registerListeners"), $31b18bf87f0afc42$var$_class.prototype), $31b18bf87f0afc42$var$_applyDecoratedDescriptor($31b18bf87f0afc42$var$_class.prototype, "populateRecentlyViewed", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($31b18bf87f0afc42$var$_class.prototype, "populateRecentlyViewed"), $31b18bf87f0afc42$var$_class.prototype), $31b18bf87f0afc42$var$_applyDecoratedDescriptor($31b18bf87f0afc42$var$_class.prototype, "fetchProducts", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($31b18bf87f0afc42$var$_class.prototype, "fetchProducts"), $31b18bf87f0afc42$var$_class.prototype), $31b18bf87f0afc42$var$_applyDecoratedDescriptor($31b18bf87f0afc42$var$_class.prototype, "injectTradePrices", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($31b18bf87f0afc42$var$_class.prototype, "injectTradePrices"), $31b18bf87f0afc42$var$_class.prototype), $31b18bf87f0afc42$var$_applyDecoratedDescriptor($31b18bf87f0afc42$var$_class.prototype, "addToRecentlyViewed", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($31b18bf87f0afc42$var$_class.prototype, "addToRecentlyViewed"), $31b18bf87f0afc42$var$_class.prototype), $31b18bf87f0afc42$var$_class);

});
parcelRegister("btEtU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.productPrice = module.exports.default = void 0;

var $lSnmX = parcelRequire("lSnmX");

var $99Uv1 = parcelRequire("99Uv1");
const $85b1cdeae9d2bbab$var$productLabel = (product)=>{
    const labels = Object.keys(window.theme.strings.products.labels);
    let label, icon;
    for (const definition of labels)if (product[definition]?.value) {
        label = window.theme.strings.products.labels[definition];
        icon = window.theme.strings.products.label_icons[definition];
    }
    if (label) return `<div class="product-label collection-product__label">
      <figure class="product-label__icon image">
        <img class="image__image" src="${icon}" />
      </figure>

      <span class="product-label__text">
        ${label}
      </span>
    </div>`;
    return '';
};
const $85b1cdeae9d2bbab$var$rewardPoints = (product)=>{
    const points = product.reward_points?.value;
    if (points) return `
      <div class="reward-points collection-product__reward-points">
        <button type="button" class="reward-points__tooltip tooltip" data-tippy-content="${window.theme.strings.reward_points.content}">
          <div class="tooltip__icon">
            ${loyaltyStarIcon}
          </div>

          <span class="tooltip__label">
            ${window.theme.strings.reward_points.title.replace('{{points}}', points)}
          </span>
        </button>
      </div>
    `;
    return '';
};
const $85b1cdeae9d2bbab$var$quickBuy = (product, currentVariant)=>{
    if (!window.theme.collection.show_quick_buy) return '';
    return `
    <div class="quick-buy-form">
      <form
        id="product_form_${product.id}"
        method="post"
        enctype="multipart/form-data"
        action="/cart/add"
        data-enable-history-state="true"
        data-product-form
        data-product-handle="${product.handle}"
        novalidate
      >
        <input type="hidden" name="form_type" value="product" class="field--filled">
        <input type="hidden" name="utf8" value="\u{2713}" class="field--filled">

        ${window.theme.collection.show_option_selector_in_listings && product.options.length === 1 && !product.hasOnlyDefaultVariant ? product.options.slice(0, 1).map((option)=>`
                    <select
                      id="Option${option.id}"
                      name="options[${option.name}]">
                      ${option.values.map((value)=>`
                          <option 
                          value="${value}"
                          ${product.variants.filter((variant)=>{
                return variant.selectedOptions[0].value === value;
            })[0]?.available ? '' : 'disabled="disabled"'}
                          >${value}</option>
                        `)}
                    </select>
                  `).join('') : ''}

        <select class="hide" name="id" data-product-select>
          ${product.variants.map((variant)=>{
        return `
              <option value="${variant.id}" ${currentVariant && currentVariant.id === variant.id ? 'selected' : ''} ${!variant.available ? 'disabled="disabled"' : ''}>${variant.title}${!variant.available ? ' - Sold Out' : ''}</option>
            `;
    })}
        </select>

        <button type="submit" data-submit-button class="button button--primary collection-product__add-button quick-buy-form__button">
          ${(currentVariant || product).available ? window.theme.strings.addToCart : window.theme.strings.soldOut ? $85b1cdeae9d2bbab$var$productPrice(product, currentVariant) + '<span class="button-divider"></span><span class="button__label">' + window.theme.strings.addToCart + '</span>' : '<span class="button__label">' + window.theme.strings.soldOut + '</span>'}
        </button>
      </form>
    </div>
  `;
};
const $85b1cdeae9d2bbab$var$productPrice = (product, variant)=>{
    let productForPrice = product;
    let price = productForPrice?.priceRange?.minVariantPrice?.amount;
    let compareAtPrice = productForPrice?.compareAtPriceRange?.minVariantPrice?.amount;
    if (variant) {
        productForPrice = variant;
        price = productForPrice.price?.amount;
        compareAtPrice = productForPrice.compareAtPrice?.amount;
    }
    const priceFormatted = (0, $99Uv1.formatMoney)(price * 100);
    const compareAtPriceFormatted = (0, $99Uv1.formatMoney)(compareAtPrice * 100);
    const priceVaries = productForPrice?.priceRange?.minVariantPrice?.amount !== productForPrice?.priceRange?.maxVariantPrice?.amount;
    let priceString = priceFormatted;
    if (priceVaries) {
        if (compareAtPrice > price) priceString = window.theme.strings.products.product.on_sale_from_html.replace('{{ price }}', priceFormatted);
        else priceString = window.theme.strings.products.product.from_text_html.replace('{{ price }}', priceFormatted);
    }
    return `
    <div class="product-price" data-price-wrapper itemprop="offers" itemscope itemtype="http://schema.org/Offer">
      <link itemprop="availability" href="http://schema.org/InStock">
      <meta itemprop="priceCurrency" content="${window.theme.shop.currency}">
      <meta itemprop="price" content="${price}">

      ${window.theme.customer.b2b ? `
        <span class="product-price__trade">${window.theme.strings.products.product.trade_pricing}:</span>
      ` : ''}


      <span data-product-price="${price}">
        ${priceString}

        ${compareAtPrice > price ? `
              <span class="screenreader-text" data-compare-text>${window.theme.strings.products.product.regular_price}</span>
              <s class="product-price__compare-at" data-compare-price>${(0, $99Uv1.formatMoney)(compareAtPrice)}</s>
            ` : ''}
      </span>
    </div>
  `;
};
module.exports.productPrice = $85b1cdeae9d2bbab$var$productPrice;
const $85b1cdeae9d2bbab$var$templateProduct = (product, variant, index)=>{
    let url = `/products/${product.handle}`;
    if (variant && product.hasOnlyDefaultVariant != true) {
        const variantString = `variant=${variant.id}`;
        if (url.includes('?')) url = `${url}&${variantString}`;
        else url = `${url}?${variantString}`;
    }
    if (!variant && product.hasOnlyDefaultVariant == true) variant = product.variants[0];
    let linkText = window.theme.strings.view;
    if (product.hasOnlyDefaultVariant) {
        if (!product.available) {
            let comingSoon = product.comingSoon;
            if (comingSoon && comingSoon.value == 'true') linkText = window.theme.strings.comingSoon;
            else linkText = window.theme.strings.soldOut;
        }
    } else if (variant && !variant.available) {
        let comingSoon = variant.comingSoon;
        if (comingSoon && comingSoon.value == 'true') linkText = window.theme.strings.comingSoon;
        else linkText = window.theme.strings.soldOut;
    }
    const features = {};
    (variant || product.variants[0]).selectedOptions.filter(({ name: name })=>window.theme.cylindoOptions.includes(name)).forEach(({ name: name, value: value })=>{
        features[(0, $99Uv1.convertNameforMatch)(name)] = (0, $99Uv1.convertValueforMatch)(value);
    });
    return `
    <li class="collection__list-item animate-on-scroll">
      <div class="collection-product" itemscope itemtype="http://schema.org/Product">
        <a href="${url}" title="${product.title}" class="collection-product__link">
          <div class="collection-product__image">
            ${product.cylindo___enabled && (variant?.sku || product.variants[0]?.sku) ? `
                    <cylindo-viewer
                      controls=""
                      customer-id="4704"
                      code="${(variant || product.variants[0])?.sku?.split('-').slice(0, -1).join('-')}"
                      data-features='${JSON.stringify(features)}'
                    >
                      <cylindo-360-frame frame="${product.cylindo___frame_number || 1}"></cylindo-360-frame>
                    </cylindo-viewer>
                  ` : `
                    <figure class="image collection-product__image-figure collection-product__image-figure--default objFit">
                      <img class="mini-cart-item__image-img" src="${(variant?.image || product.images[0])?.src}" sizes="7em" alt="${product.title}${variant ? ` - ${variant.title}` : ''}">
                    </figure>
                  `}
          </div>

          ${$85b1cdeae9d2bbab$var$productLabel(product)}
        </a>

        <div class="collection-product__content">
          <a href="${url}" title="${product.title}" class="collection-product__content-link">
            <div class="collection-product__content-title" itemprop="name">
              ${product.title}
            </div>
          </a>

          <div class="collection-product__content-meta">
            ${window.theme.collection.show_short_description_in_listings && product.shortDescription?.value ? `
              <div class="collection-product__content-short-description">
                ${product.shortDescription.value}
              </div>
            ` : ''}

            ${$85b1cdeae9d2bbab$var$productPrice(product, variant)}

            ${window.theme.collection.show_long_description_in_listings && product.longDescription?.value ? `
              <div class="collection-product__content-long-description">
                ${product.longDescription.value}
              </div>
            ` : ''}

            ${variant ? `
              <span class="collection-product__content-option-count">
                ${variant.title}
              </span>
            ` : ''}

            ${product.variants.length > 1 && !variant ? `
              <span class="collection-product__content-option-count">
                ${window.theme.strings.products.options.count.replace(/\{\{\s?count\s?\}\}/, product.variants.length)}
              </span>
            ` : ''}

            ${product.product___show_dimensions_on_listing_pages?.value === 'true' ? variant && variant.product___dimensions?.value ? `
                      <span class="collection-product__content-dimensions">
                        ${(0, $lSnmX.convertSchemaToHtml)(variant.product___dimensions.value)}
                      </span>
                    ` : product.product___dimensions?.value ? `
                        <span class="collection-product__content-dimensions">
                          ${(0, $lSnmX.convertSchemaToHtml)(product.product___dimensions.value)}
                        </span>
                      ` : '' : ''}
          </div>


          ${$85b1cdeae9d2bbab$var$quickBuy(product, variant)}
          ${$85b1cdeae9d2bbab$var$rewardPoints(product)}
        </div>
      </div>
    </li>
  `;
};
var $85b1cdeae9d2bbab$var$_default = module.exports.default = $85b1cdeae9d2bbab$var$templateProduct;

});
parcelRegister("lSnmX", function(module, exports) {

$parcel$export(module.exports, "convertSchemaToHtml", function () { return $fed0c4c7c3bf8130$export$f4e498a2f298fc35; });
/* Shopify Metafield & Metaobject Rich Text Editor Schema to HTML Converter */ /**
 * Converts Shopify Richtext Schema to HTML.
 *
 * @param {Object|string} schema - The schema object or JSON string to convert.
 * @param {Object} [options={}] - The conversion options.
 * @param {string|boolean} [options.scoped] - The scoped class name or a boolean value indicating whether to use the default scoped class name.
 * @returns {string} The converted HTML string.
 */ function $fed0c4c7c3bf8130$export$f4e498a2f298fc35(schema, options = {}) {
    let { scoped: scoped } = options;
    let html = '';
    if (typeof schema === 'string' || schema instanceof String) schema = JSON.parse(schema);
    if (typeof options === 'string' || options instanceof String || options === true) scoped = options;
    if (schema.type === 'root' && schema.children.length > 0) {
        if (scoped) html += `
      <div class="${scoped === true ? `rte` : scoped}">
        ${$fed0c4c7c3bf8130$export$f4e498a2f298fc35(schema.children, options)}
      </div>
      `;
        else html += $fed0c4c7c3bf8130$export$f4e498a2f298fc35(schema.children, options);
    } else for (const el of schema)switch(el.type){
        case 'paragraph':
            html += $fed0c4c7c3bf8130$var$buildParagraph(el, options);
            break;
        case 'heading':
            html += $fed0c4c7c3bf8130$var$buildHeading(el, options);
            break;
        case 'list':
            html += $fed0c4c7c3bf8130$var$buildList(el, options);
            break;
        case 'list-item':
            html += $fed0c4c7c3bf8130$var$buildListItem(el, options);
            break;
        case 'link':
            html += $fed0c4c7c3bf8130$var$buildLink(el, options);
            break;
        case 'text':
            html += $fed0c4c7c3bf8130$var$buildText(el, options);
            break;
        default:
            break;
    }
    return html;
}
function $fed0c4c7c3bf8130$var$getClass(tag, classes) {
    if (classes && classes[tag]) return classes[tag];
    else return null;
}
function $fed0c4c7c3bf8130$var$outputAttributes(attributes) {
    if (!attributes && attributes?.class) return '';
    const ATTRIBUTE_SEPARATOR = ' ';
    return Object.keys(attributes).map((key)=>{
        if (attributes[key]) return `${ATTRIBUTE_SEPARATOR}${key}="${attributes[key]}"`;
    }).join('');
}
function $fed0c4c7c3bf8130$var$createElement(tag, classes, content, attributes = {}) {
    attributes = {
        ...attributes,
        class: $fed0c4c7c3bf8130$var$getClass(tag, classes)
    };
    return `<${tag}${$fed0c4c7c3bf8130$var$outputAttributes(attributes)}>${content}</${tag}>`;
}
function $fed0c4c7c3bf8130$var$buildParagraph(el, options) {
    const { classes: classes } = options;
    return $fed0c4c7c3bf8130$var$createElement('p', classes, $fed0c4c7c3bf8130$export$f4e498a2f298fc35(el?.children, options));
}
function $fed0c4c7c3bf8130$var$buildHeading(el, options) {
    const { classes: classes } = options;
    const tag = `h${el?.level}`;
    return $fed0c4c7c3bf8130$var$createElement(tag, classes, $fed0c4c7c3bf8130$export$f4e498a2f298fc35(el?.children, options));
}
function $fed0c4c7c3bf8130$var$buildList(el, options) {
    const { classes: classes } = options;
    const tag = el?.listType === 'ordered' ? 'ol' : 'ul';
    return $fed0c4c7c3bf8130$var$createElement(tag, classes, $fed0c4c7c3bf8130$export$f4e498a2f298fc35(el?.children, options));
}
function $fed0c4c7c3bf8130$var$buildListItem(el, options) {
    const { classes: classes } = options;
    return $fed0c4c7c3bf8130$var$createElement('li', classes, $fed0c4c7c3bf8130$export$f4e498a2f298fc35(el?.children, options));
}
function $fed0c4c7c3bf8130$var$buildLink(el, options) {
    const { classes: classes } = options;
    const attributes = {
        href: el?.url,
        title: el?.title,
        target: el?.target
    };
    return $fed0c4c7c3bf8130$var$createElement('a', classes, $fed0c4c7c3bf8130$export$f4e498a2f298fc35(el?.children, options), attributes);
}
function $fed0c4c7c3bf8130$var$buildText(el, options) {
    const { classes: classes, newLineToBreak: newLineToBreak } = options;
    if (el?.bold && el?.italic) return $fed0c4c7c3bf8130$var$createElement('strong', classes, $fed0c4c7c3bf8130$var$createElement('em', classes, el?.value));
    else if (el?.bold) return $fed0c4c7c3bf8130$var$createElement('strong', classes, el?.value);
    else if (el?.italic) return $fed0c4c7c3bf8130$var$createElement('em', classes, el?.value);
    else return newLineToBreak ? el?.value?.replace(/\n/g, '<br>') : el?.value;
}

});



parcelRegister("hD1u2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $cd573ac314a3fa8f$var$_class;
function $cd573ac314a3fa8f$var$_defineProperty(e, r, t) {
    return (r = $cd573ac314a3fa8f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cd573ac314a3fa8f$var$_toPropertyKey(t) {
    var i = $cd573ac314a3fa8f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cd573ac314a3fa8f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd573ac314a3fa8f$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $cd573ac314a3fa8f$var$SamplesPopup = module.exports.default = ($cd573ac314a3fa8f$var$_class = class SamplesPopup {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $cd573ac314a3fa8f$var$_defineProperty(this, "triggers", new $bFxq0.LiveNodeList('[data-samples-popup-trigger]'));
        /**
     * @type {LiveElement}
     */ $cd573ac314a3fa8f$var$_defineProperty(this, "popup", new $bFxq0.LiveElement('#samples-popup'));
        /**
     * @type {LiveElement}
     */ $cd573ac314a3fa8f$var$_defineProperty(this, "inner", new $bFxq0.LiveElement('.samples-popup__inner', this.popup));
        /**
     * @type {LiveElement}
     */ $cd573ac314a3fa8f$var$_defineProperty(this, "closeButton", new $bFxq0.LiveElement('.samples-popup__close', this.popup));
        this.registerListeners();
    }
    registerListeners() {
        this.triggers.addEventListener('click', this.togglePopup);
        this.popup.addEventListener('click', this.closePopup);
        this.inner.addEventListener('click', (event)=>event.stopPropagation());
        this.closeButton.addEventListener('click', this.closePopup);
    }
    togglePopup() {
        const fn = this.popup.item.getAttribute('aria-hidden') === 'true' ? 'openPopup' : 'closePopup';
        this[fn]();
    }
    openPopup() {
        this.triggers.forEach((trigger)=>trigger.setAttribute('aria-expanded', 'true'));
        this.popup.item.setAttribute('aria-hidden', 'false');
    }
    closePopup() {
        this.triggers.forEach((trigger)=>trigger.setAttribute('aria-expanded', 'false'));
        this.popup.item.setAttribute('aria-hidden', 'true');
    }
}, $cd573ac314a3fa8f$var$_applyDecoratedDescriptor($cd573ac314a3fa8f$var$_class.prototype, "togglePopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd573ac314a3fa8f$var$_class.prototype, "togglePopup"), $cd573ac314a3fa8f$var$_class.prototype), $cd573ac314a3fa8f$var$_applyDecoratedDescriptor($cd573ac314a3fa8f$var$_class.prototype, "openPopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd573ac314a3fa8f$var$_class.prototype, "openPopup"), $cd573ac314a3fa8f$var$_class.prototype), $cd573ac314a3fa8f$var$_applyDecoratedDescriptor($cd573ac314a3fa8f$var$_class.prototype, "closePopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($cd573ac314a3fa8f$var$_class.prototype, "closePopup"), $cd573ac314a3fa8f$var$_class.prototype), $cd573ac314a3fa8f$var$_class);

});

parcelRegister("gI4si", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbrY = parcelRequire("bfbrY");

var $bFxq0 = parcelRequire("bFxq0");
var $c2a436248c47f567$var$_class;
function $c2a436248c47f567$var$_defineProperty(e, r, t) {
    return (r = $c2a436248c47f567$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c2a436248c47f567$var$_toPropertyKey(t) {
    var i = $c2a436248c47f567$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c2a436248c47f567$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c2a436248c47f567$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $c2a436248c47f567$var$CareInstructions = module.exports.default = ($c2a436248c47f567$var$_class = class CareInstructions {
    constructor(){
        /**
     * @type {LiveNodeList}
     */ $c2a436248c47f567$var$_defineProperty(this, "triggers", new $bFxq0.LiveNodeList('[data-care-instructions-trigger]'));
        /**
     * @type {LiveElement}
     */ $c2a436248c47f567$var$_defineProperty(this, "popup", new $bFxq0.LiveElement('#care-instructions'));
        /**
     * @type {LiveElement}
     */ $c2a436248c47f567$var$_defineProperty(this, "inner", new $bFxq0.LiveElement('.care-instructions__inner', this.popup));
        /**
     * @type {LiveElement}
     */ $c2a436248c47f567$var$_defineProperty(this, "closeButton", new $bFxq0.LiveElement('.care-instructions__close', this.popup));
        this.registerListeners();
    }
    registerListeners() {
        this.triggers.addEventListener('click', this.togglePopup);
        this.popup.addEventListener('click', this.closePopup);
        this.inner.addEventListener('click', (event)=>event.stopPropagation());
        this.closeButton.addEventListener('click', this.closePopup);
    }
    togglePopup() {
        const fn = this.popup.item.getAttribute('aria-hidden') === 'true' ? 'openPopup' : 'closePopup';
        this[fn]();
    }
    openPopup() {
        this.triggers.forEach((trigger)=>trigger.setAttribute('aria-expanded', 'true'));
        this.popup.item.setAttribute('aria-hidden', 'false');
    }
    closePopup() {
        this.triggers.forEach((trigger)=>trigger.setAttribute('aria-expanded', 'false'));
        this.popup.item.setAttribute('aria-hidden', 'true');
    }
}, $c2a436248c47f567$var$_applyDecoratedDescriptor($c2a436248c47f567$var$_class.prototype, "togglePopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c2a436248c47f567$var$_class.prototype, "togglePopup"), $c2a436248c47f567$var$_class.prototype), $c2a436248c47f567$var$_applyDecoratedDescriptor($c2a436248c47f567$var$_class.prototype, "openPopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c2a436248c47f567$var$_class.prototype, "openPopup"), $c2a436248c47f567$var$_class.prototype), $c2a436248c47f567$var$_applyDecoratedDescriptor($c2a436248c47f567$var$_class.prototype, "closePopup", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($c2a436248c47f567$var$_class.prototype, "closePopup"), $c2a436248c47f567$var$_class.prototype), $c2a436248c47f567$var$_class);

});

parcelRegister("ltzz6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bFxq0 = parcelRequire("bFxq0");
function $fa27e4e47219ff9b$var$_defineProperty(e, r, t) {
    return (r = $fa27e4e47219ff9b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fa27e4e47219ff9b$var$_toPropertyKey(t) {
    var i = $fa27e4e47219ff9b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fa27e4e47219ff9b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $fa27e4e47219ff9b$var$RequestForQuote {
    constructor(){
        $fa27e4e47219ff9b$var$_defineProperty(this, "loginLink", new $bFxq0.LiveNodeList('.rfq_history_page .login'));
        this.registerListeners();
    }
    registerListeners() {
        this.loginLink.on('update', this.replaceLoginLink);
    }
    replaceLoginLink(items) {
        items.forEach((item)=>{
            item.href = `/customer_identity/login?return_to=${window.location.pathname}`;
        });
    }
}
module.exports.default = $fa27e4e47219ff9b$var$RequestForQuote;

});

parcelRegister("aZmzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bFxq0 = parcelRequire("bFxq0");

var $bfbrY = parcelRequire("bfbrY");
var $80011c3c06120849$var$_class;
function $80011c3c06120849$var$_defineProperty(e, r, t) {
    return (r = $80011c3c06120849$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $80011c3c06120849$var$_toPropertyKey(t) {
    var i = $80011c3c06120849$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $80011c3c06120849$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $80011c3c06120849$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
let $80011c3c06120849$var$TradeSignUp = module.exports.default = ($80011c3c06120849$var$_class = class TradeSignUp {
    constructor(){
        /**
     * @type {LiveElement}
     */ $80011c3c06120849$var$_defineProperty(this, "form", new $bFxq0.LiveElement('.cog-form'));
        this.registerListeners();
        this.setupForm(this.form.item);
    }
    registerListeners() {
        this.form.on('update', (newItem)=>{
            this.setupForm(newItem);
        });
    }
    setupForm(form) {
        if (!form) return;
        [
            'cog-cognito--styled',
            'cog-form--light-background',
            'cog-cognito--protect-css'
        ].forEach((className)=>form.classList.remove(className));
    }
}, $80011c3c06120849$var$_applyDecoratedDescriptor($80011c3c06120849$var$_class.prototype, "setupForm", [
    $bfbrY.bind
], Object.getOwnPropertyDescriptor($80011c3c06120849$var$_class.prototype, "setupForm"), $80011c3c06120849$var$_class.prototype), $80011c3c06120849$var$_class);

});

"use strict";

var $37983ab7682e912c$var$_accordion = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("1GBb5")));

var $37983ab7682e912c$var$_addresses = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("cdXMh")));

var $37983ab7682e912c$var$_animator = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("kYSSk")));

var $37983ab7682e912c$var$_cartApi = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("gXXkU")));

var $37983ab7682e912c$var$_filter = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("ZbtOK")));

var $37983ab7682e912c$var$_form = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("aSWNK")));

var $37983ab7682e912c$var$_giftCard = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("LCDRY")));

var $37983ab7682e912c$var$_header = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("1AauR")));

var $37983ab7682e912c$var$_heroBanner = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("fCHpm")));

var $37983ab7682e912c$var$_imageLazyLoader = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("6iqGt")));

var $37983ab7682e912c$var$_instagram = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("69ZXl")));

var $37983ab7682e912c$var$_miniCart = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("1DG8D")));

var $37983ab7682e912c$var$_newsletterPopup = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("7rvq6")));

var $37983ab7682e912c$var$_phoneFormatting = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("1x8AP")));

var $37983ab7682e912c$var$_product = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("2qKNe")));

var $37983ab7682e912c$var$_promoBar = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("dnf5d")));

var $37983ab7682e912c$var$_quantityIncrementor = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("lm8TI")));

var $37983ab7682e912c$var$_slideshowButtons = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("4EdiZ")));

var $37983ab7682e912c$var$_slideshowPagination = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("lMD4b")));

var $37983ab7682e912c$var$_slideshowProgress = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("50HSp")));

var $37983ab7682e912c$var$_video = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("2vkhr")));

var $37983ab7682e912c$var$_videoLazyLoader = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("9ZCHO")));

var $37983ab7682e912c$var$_predictiveSearch = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("2hcZU")));

var $37983ab7682e912c$var$_slideshowThumbnails = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("3Qemy")));

var $37983ab7682e912c$var$_slideshowScrollbar = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("85F5i")));

var $37983ab7682e912c$var$_collectionHeader = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("kkyPf")));

var $37983ab7682e912c$var$_slideshowCount = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("c1PA8")));

var $37983ab7682e912c$var$_recentlyViewed = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("4gw5u")));

var $37983ab7682e912c$var$_samplesPopup = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("hD1u2")));

var $37983ab7682e912c$var$_careInstructions = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("gI4si")));

var $37983ab7682e912c$var$_requestForQuote = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("ltzz6")));

var $37983ab7682e912c$var$_tradeSignUp = $37983ab7682e912c$var$_interopRequireDefault((parcelRequire("aZmzx")));
function $37983ab7682e912c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $37983ab7682e912c$var$_defineProperty(e, r, t) {
    return (r = $37983ab7682e912c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $37983ab7682e912c$var$_toPropertyKey(t) {
    var i = $37983ab7682e912c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $37983ab7682e912c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} // Import dependencies
// import CurrencySwitcher from './components/currency-switcher'
// import LanguageSwitcher from './components/language-switcher'
// import Login from './templates/customers/login'
// import Recharge from './components/recharge'
class $37983ab7682e912c$var$Theme {
    /**
   * Create the application instance
   */ constructor(){
        /**
     * An object for storing application components
     *
     * @type {object}
     */ $37983ab7682e912c$var$_defineProperty(this, "components", {});
        this.registerComponents();
        this.registerCSSOnLoadEvent();
    }
    /**
   * Register an onload event for CSS stylesheets (both sync and async)
   */ async registerCSSOnLoadEvent() {
        const stylesheets = document.styleSheets;
        const promises = [
            ...stylesheets
        ].map((stylesheet)=>{
            return new Promise((resolve, reject)=>{
                // Stylesheets embedded in style tags will not have a href, and will never
                // fire the load event
                if (stylesheet.href === null) return resolve(stylesheet);
                // Stylesheets from third-party domains cannot be parsed due to CORS restrictions
                const url = new URL(stylesheet.href);
                if (url.host !== window.location.host) return resolve(stylesheet);
                // Add an event listener for the load of event on the stylesheet's link
                if (stylesheet.ownerNode) stylesheet.ownerNode.addEventListener('load', (e)=>{
                    resolve(stylesheet);
                });
                try {
                    // See if CSS Rules already exist within the stylesheet.
                    // If they do, the stylesheet is already loaded and parsed, and we don't
                    // need to rely on the load event
                    if (stylesheet.cssRules && stylesheet.cssRules.length > 0) return resolve(stylesheet);
                } catch (error) {
                    // InvalidAccessError is thrown if CSS has not yet finished parsing
                    // If this is the case, we let the error slide and add the event listener,
                    // but rethrow any other errors to catch legitimate bugs
                    if (error.name !== 'InvalidAccessError') throw error;
                }
            });
        });
        await Promise.all(promises);
        document.dispatchEvent(new Event('css:load'));
    }
    /**
   * Register individual application components here
   */ registerComponents() {
        this.components.imageLazyLoader = new $37983ab7682e912c$var$_imageLazyLoader.default('img[data-lazy-load-src], img[data-lazy-load-srcset], picture source[data-lazy-load-srcset]');
        this.components.videoLazyLoader = new $37983ab7682e912c$var$_videoLazyLoader.default('video[data-lazy-load-src]');
        this.components.form = new $37983ab7682e912c$var$_form.default();
        this.components.filter = new $37983ab7682e912c$var$_filter.default();
        this.components.cartApi = new $37983ab7682e912c$var$_cartApi.default();
        this.components.miniCart = new $37983ab7682e912c$var$_miniCart.default();
        this.components.product = new $37983ab7682e912c$var$_product.default();
        this.components.accordion = new $37983ab7682e912c$var$_accordion.default();
        this.components.addresses = new $37983ab7682e912c$var$_addresses.default();
        this.components.animator = new $37983ab7682e912c$var$_animator.default('.animate-on-scroll');
        this.components.giftCard = new $37983ab7682e912c$var$_giftCard.default();
        this.components.header = new $37983ab7682e912c$var$_header.default();
        this.components.heroBanner = new $37983ab7682e912c$var$_heroBanner.default();
        this.components.instagram = new $37983ab7682e912c$var$_instagram.default();
        this.components.newsletterPopup = new $37983ab7682e912c$var$_newsletterPopup.default();
        this.components.phoneFormatting = new $37983ab7682e912c$var$_phoneFormatting.default();
        this.components.promoBar = new $37983ab7682e912c$var$_promoBar.default();
        this.components.quantityIncrementor = new $37983ab7682e912c$var$_quantityIncrementor.default();
        this.components.slideshowButtons = new $37983ab7682e912c$var$_slideshowButtons.default();
        this.components.slideshowPagination = new $37983ab7682e912c$var$_slideshowPagination.default();
        this.components.slideshowProgress = new $37983ab7682e912c$var$_slideshowProgress.default();
        this.components.slideshowScrollbar = new $37983ab7682e912c$var$_slideshowScrollbar.default();
        this.components.slideshowThumbnails = new $37983ab7682e912c$var$_slideshowThumbnails.default();
        this.components.slideshowCount = new $37983ab7682e912c$var$_slideshowCount.default();
        this.components.video = new $37983ab7682e912c$var$_video.default();
        this.components.predictiveSearch = new $37983ab7682e912c$var$_predictiveSearch.default();
        this.components.collectionHeader = new $37983ab7682e912c$var$_collectionHeader.default();
        this.components.recentlyViewed = new $37983ab7682e912c$var$_recentlyViewed.default();
        this.components.samplesPopup = new $37983ab7682e912c$var$_samplesPopup.default();
        this.components.careInstructions = new $37983ab7682e912c$var$_careInstructions.default();
        this.components.requestForQuote = new $37983ab7682e912c$var$_requestForQuote.default();
        this.components.tradeSignUp = new $37983ab7682e912c$var$_tradeSignUp.default();
    // this.components.login = new Login()
    // this.components.currencySwitcher = new CurrencySwitcher()
    // this.components.languageSwitcher = new LanguageSwitcher()
    // this.components.recharge = new Recharge()
    }
}
window.app = new $37983ab7682e912c$var$Theme();


//# sourceMappingURL=theme.module.js.map
